// AUTO-GENERATED by tools/scripts/sync-en-fallback.mjs — DO NOT EDIT BY HAND.
// English last-resort layer for SharedTranslateLoader (API → cache → this seed).
// Regenerate after seeding new keys: pnpm sync:en-fallback
// Source: production /app_text (union of all apps) ∪ api seed migrations.
// Concurrent-PR note: on a merge conflict in this file, never hand-merge — rebase and re-run
// the sync; regeneration converges to the correct union automatically.
// prettier-ignore
export const EN_FALLBACK: Record<string, string> = {
  "ABANDON_CART_DESCRIPTION": "Let us know why so we can improve our service",
  "ABANDON_CART_TITLE": "Did we not meet your expectations?",
  "ABANDON_REASON_CHECKING_PRICE": "Checking price",
  "ABANDON_REASON_COULDNT_ADD_PAYMENT_METHOD": "Problems adding payment method",
  "ABANDON_REASON_JUST_BROWSING": "Just browsing",
  "ABANDON_REASON_OTHER": "Other",
  "ABANDON_REASON_TOO_EXPENSIVE": "It's too expensive",
  "ABORT_CANCEL_BOOKING": "Don't cancel",
  "ABOUT_THE_STORAGE_LOCATION": "About",
  "ACCEPTING": "Accepting",
  "ACCEPT_TERMS_OF_SERVICE": "Accept Terms of Service",
  "ACCEPT_TERMS_PART_1": "By continuing you accept our",
  "ACCEPT_TERMS_PART_2": "terms and conditions",
  "ACCEPT_TOS_CHECKBOX_LABEL": "Accept",
  "ACCESS_CODE": "Access code",
  "ACCESS_CODE_HELP": "Access code help",
  "ACCESS_CODE_NOT_WORKING_QUESTION": "Access code not working?",
  "ACCESS_CODE_REQUEST_NEW": "If your code doesn't work, request a new one.",
  "ACCESS_CODE_RETRIEVAL_FAILURE": "Access code could not be retrieved",
  "ACCESS_CODE_SALTO_KEYPAD_ACTIVATION": "Touch the circle on the black panel above the door handle to activate the keypad.",
  "ACCESS_CODE_SALTO_WALL_MOUNTED_KEYPAD": "Enter the access code on the keypad mounted on the wall next to the door.",
  "ACCOUNT": "Account",
  "ACCOUNT_COUNTRY": "Account country",
  "ACCOUNT_COUNTRY_DENMARK": "Denmark",
  "ACCOUNT_COUNTRY_UNITED_KINGDOM": "United Kingdom",
  "ACCOUNT_COUNTRY_UNITED_STATES": "United States",
  "ACCOUNT_DETAILS": "Account information",
  "ACCOUNT_OWNER": "Account owner",
  "ACCOUNT_STATUS_BANNER_DEACTIVATED": "Your location is currently deactivated - contact support for help",
  "ACCOUNT_STATUS_BANNER_LIVE": "Your location is live and visible on LuggageHero.",
  "ACCOUNT_STATUS_BANNER_REVIEWING": "All done! Our team is reviewing your account and will have you live shortly.",
  "ACTION": "Action",
  "ACTIONS": "Actions",
  "ACTIVE": "Active",
  "ACTIVE_STORAGE_LOCATION_MARKER_NOTICE": "Online booking required",
  "ADDRESS": "Address",
  "ADDRESS_AVAILABLE_AFTER_BOOKING_USP_TITLE": "Address available after booking",
  "ADDRESS_DIFFERENT_COUNTRY_WARNING": "This address is in a different country than the current one.",
  "ADDRESS_INCOMPLETE_STREET_BANNER": "This address is incomplete — the street name is missing. Please update the address so customers and our system can find your location.",
  "ADDRESS_LOOKUP_FAILED": "Address lookup failed — please try again",
  "ADDRESS_SENT": "We have sent you the address/directions.",
  "ADDRESS_UPDATE_FAILURE": "Could not update the address. Please try again.",
  "ADDRESS_UPDATE_SUCCESS": "Address updated",
  "ADDRESS_VISIBLE_AFTER_BOOKING": "Online booking required",
  "ADD_A_FEW_WORDS_OPTIONAL": "Add a few words?",
  "ADD_BASIC_INSURANCE": "Add Basic insurance",
  "ADD_CONTACT_INFO": "Add contact info",
  "ADD_ENTRY": "Add",
  "ADD_EXCEPTION": "Add exception",
  "ADD_FROM_GOOGLE_MAPS": "Add from Google Maps",
  "ADD_LOCATION": "Add location",
  "ADD_LUGGAGEHERO_NOTIF": "Add notif with your link",
  "ADD_LUGGAGEHERO_NOTIF_TEXT": "Include your LuggageHero Smart Link in an automated message via the BookingSync Notifications app",
  "ADD_MANUALLY": "Add manually",
  "ADD_NEW_AREA": "Add new storage area",
  "ADD_NEW_METHOD": "Add New Method",
  "ADD_NOW": "Add now",
  "ADD_OPTIONAL_PRODUCTS_TO_BOOKING": "Add additional products to your booking?",
  "ADD_PAYMENT_CARD": "Add payment card",
  "ADD_PAYMENT_INFO_NOW": "Add payment info now for swift service when you arrive at the shop. No charge if you don't show up.",
  "ADD_PAYOUT_METHOD": "Add payout method",
  "ADD_PREMIUM_INSURANCE": "Add Premium insurance",
  "ADD_PROTECTION": "Add insurance",
  "ADD_STORAGE_AREA": "Add storage area",
  "ADD_TAX": "Add Tax",
  "ADD_TAX_RATE": "Add rate",
  "ADD_UP_TO_X_BAGS": "You can add up to",
  "ADD_X_COVERAGE_PREFIX": "Add",
  "ADD_X_COVERAGE_SUFFIX": "coverage",
  "ADVANCE_BOOKING_DISCOUNT": "Advance booking savings",
  "ALBANIA": "Albania",
  "ALGERIA": "Algeria",
  "ALL": "All",
  "ALL_METRICS": "All metrics",
  "ALMOST_THERE": "Almost there!",
  "ALREADY_HAVE_AN_ACCOUNT": "Already have an account?",
  "ALSO_SHARE_ON_GOOGLE": "Also share on Google?",
  "ALSO_SHARE_ON_TRUSTPILOT": "Also share on Trustpilot?",
  "ALWAYS_OPEN": "Always open",
  "AND": "and",
  "ANGOLA": "Angola",
  "ANTIGUA_AND_BARBUDA": "Antigua and Barbuda",
  "ANYTHING_TO_ADD_OPTIONAL": "Anything to add? (optional)",
  "ANY_DISTANCE": "Any distance",
  "AN_UNKNOWN_ERROR_OCCURRED": "An unknown error occurred. Please try again.",
  "APPLY": "Apply",
  "APPLY_CODE": "Apply code",
  "APP_DOWNLOAD_GET_THE_APP": "Get the app",
  "APP_UPDATE_EXPLANATION_PART_1": "We update our app on a regular basis to ensure a smooth and stable experience for our users.",
  "APP_UPDATE_EXPLANATION_PART_2": "Please install the latest version to continue using our service.",
  "APP_UPDATING": "Updating…",
  "ARE_YOU_A_COMWELL_CLUB_OR_WYNDHAM_REWARDS_MEMBER": "Are you a Comwell Club or Wyndham rewards member?",
  "ARE_YOU_A_GUEST_AT_THE_HOTEL": "Are you a guest at the hotel?",
  "ARE_YOU_A_GUEST_HERE": "Are you a guest here?",
  "ARE_YOU_A_MARRIOTT_BONVOY_MEMBER": "Are you a Marriott Bonvoy member?",
  "ARE_YOU_A_MEMBER_OF": "Are you a member of",
  "ARE_YOU_A_SCANDIC_FRIENDS_MEMBER": "Are you a Scandic Friends member?",
  "ARE_YOU_A_STRAWBERRY_MEMBER": "Are you a member of Strawberry?",
  "ARE_YOU_A_THON_PLUS_MEMBER": "Are you a Thon+ member?",
  "ARGENTINA": "Argentina",
  "ARMENIA": "Armenia",
  "ARRIVING": "Arriving",
  "ASK_A_QUESTION": "Ask us a question",
  "ASK_STAFF_FOR_WIFI": "Please ask a member of the staff for Wi-Fi details.",
  "AS_BASIC_HERO": "as BasicHero",
  "AS_SUPERHERO": "as SuperHero",
  "ATTACH_SECURITY_SEAL_BEFORE_PROCEEDING": "Before you proceed, ask the staff for security seals for your bags",
  "AT_SHOP": "at",
  "AT_THIS_LOCATION": "at this location",
  "AT_THIS_RATE": "At this rate",
  "AUSTRALIA": "Australia",
  "AUSTRIA": "Austria",
  "AUTH_FIELD_ERROR": "One or more required fields are missing or invalid.",
  "AUTH_RESET_PASSWORD_INVALID_TOKEN_ERROR": "The link has expired or has already been used.",
  "AUTH_WRONG_CREDENTIALS": "Wrong email or password. Try again or reset your password",
  "AUTH_WRONG_CREDENTIALS_ERROR": "The email or password you entered is incorrect.",
  "AVERAGE_DAILY_REVENUE": "Average Daily Revenue",
  "AVERAGE_RATING": "Average rating",
  "AVERAGE_REVIEW_RATING": "Average Review Rating",
  "AWAITING_REVIEW": "Awaiting review",
  "AZERBAIJAN": "Azerbaijan",
  "BACK": "Back",
  "BACK_TO_LOGIN": "Back to login",
  "BAD_EXPERIENCE": "We are very sorry to hear that you had a bad experience. We would really appreciate your feedback and the chance to improve. Comments made here will not be visible to the shop or other travelers.",
  "BAG": "Bag",
  "BAGS": "Bags",
  "BAG_GUARANTEE_ADJUSTMENT": "Bag-Day Minimum Revenue Guarantee",
  "BAHAMAS": "Bahamas",
  "BAHRAIN": "Bahrain",
  "BANGLADESH": "Bangladesh",
  "BANK_ACCOUNT_COUNTRY": "Bank Account Country",
  "BANK_ACCOUNT_CURRENCY": "Bank Account Currency",
  "BANK_ACCOUNT_DETAILS": "Bank Account Details",
  "BARCELONA": "Barcelona",
  "BASIC_INSURANCE": "Basic insurance",
  "BECOME_SUPERHERO_CTA_TEXT": "Become SuperHero",
  "BELGIUM": "Belgium",
  "BENIN": "Benin",
  "BESTBUY_PROMO_CODE_TEXT": "A full day of luggage storage, 5€ per bag",
  "BEST_CHOICE": "Best choice",
  "BEST_PRICE_GUARANTEE": "Best price guarantee",
  "BETTER_GUEST_EXPERIENCE": "Better Guest Experience",
  "BHUTAN": "Bhutan",
  "BIG_TIP_WARNING_MESSAGE": "is a very big tip. Are you sure you want to proceed?",
  "BILLING": "Billing",
  "BILL_TO": "Bill to",
  "BOLIVIA": "Bolivia",
  "BONUS_INFORMATION_NOT_AVAILABLE": "Bonus information is not available",
  "BONUS_IS_WAITING": "bonus is waiting",
  "BOOK": "Book",
  "BOOKING": "Booking",
  "BOOKINGS": "Bookings",
  "BOOKINGS_FILTER_ACTIVE": "Active",
  "BOOKINGS_FILTER_ALL": "All",
  "BOOKINGS_FILTER_CANCELED": "Canceled",
  "BOOKINGS_FILTER_COMPLETED": "Completed",
  "BOOKING_CANCELED": "Booking canceled",
  "BOOKING_CATEGORY": "Category",
  "BOOKING_CHANGED": "Booking changed",
  "BOOKING_CONFIRMATION_VIA_EMAIL": "A booking confirmation will be sent to you by email",
  "BOOKING_CONFIRMATION_VIA_SMS": "You'll see your booking confirmation as soon as you book.",
  "BOOKING_CONFIRMED": "Booking confirmed!",
  "BOOKING_CONTACT_AVAILABLE_AT_CHECK_IN": "Contact details become available at check-in",
  "BOOKING_COULD_NOT_BE_CHANGED": "Booking could not be changed",
  "BOOKING_DETAILS": "Booking details",
  "BOOKING_FEE": "Booking fee",
  "BOOKING_FLOW_TAB_TITLE": "Booking Flow",
  "BOOKING_FOR": "Booking for",
  "BOOKING_ID": "Booking ID",
  "BOOKING_ID_COPIED": "Booking ID copied",
  "BOOKING_ID_COPY_FAILED": "Couldn't copy the booking ID",
  "BOOKING_INCIDENT_EXPLANATION": "The customer reported an incident related with your location",
  "BOOKING_MINIMUM_AVERAGE_REVENUE_TOOLTIP": "Guaranteed minimum earnings + tip",
  "BOOKING_OPTIONS": "Booking options",
  "BOOKING_PAGE_WELCOME_CHAT_MESSAGE": "You can always get back here using the link we have just sent you via email/SMS.",
  "BOOKING_PAGE_WELCOME_CHAT_TITLE": "Welcome to your booking page!",
  "BOOKING_PROGRESS": "Booking status",
  "BOOKING_PROGRESS_CANCELED": "The booking has been canceled",
  "BOOKING_PROGRESS_CANCELED_SUBTEXT": "No charge will be made. If you paid a deposit, it will be refunded.",
  "BOOKING_PROGRESS_CHECKED_IN": "Checked in",
  "BOOKING_PROGRESS_CHECKED_OUT": "Checked out",
  "BOOKING_PROGRESS_CONFIRMED": "Booking confirmed",
  "BOOKING_PROGRESS_PAYMENT_SUCCESSFUL": "Payment successful",
  "BOOKING_PROTECTION_INCLUDED": "Every booking includes protection from listing inaccuracies and other issues like trouble checking in",
  "BOOKING_READY_TIMER_STARTED": "Your booking is ready and we have started your storage timer",
  "BOOKING_STORAGE_ACCESS_EXPIRED": "Your access to the storage room has expired",
  "BOOKING_SUMMARY": "Booking summary",
  "BOOKING_TIMELINE": "Your booking timeline",
  "BOOKING_TIMELINE_SELF_SERVICE_DROP_OFF_HINT": "Start the storage timer below when you arrive to get access to the storage room",
  "BOOKING_TIMELINE_SELF_SERVICE_PICK_UP_HINT": "Collect your bags from the storage room, then select Pick up below to end your storage",
  "BOOKING_TIMELINE_START_TIMER_SHORT": "Start the storage timer below when you arrive",
  "BOOKING_WAS_CHANGED_SUCCESSFULLY": "The changes you requested were successfully applied",
  "BOOK_AHEAD_FOR_BEST_RATES": "Book now, pay later. Free cancellation. Online booking only.",
  "BOOK_NOW": "Book now",
  "BOOK_NOW_PAY_LATER_FREE_CANCELLATION_DEADLINE": "Book now, pay later. Free cancellation until {{time}} on your drop-off day. Online booking only.",
  "BOOK_NOW_PAY_LATER_ONLINE_ONLY": "Book now, pay later. Online booking only.",
  "BOOK_ONLINE": "Book online",
  "BOOK_WITH_PAYMENT_PROVIDER": "Book with",
  "BOOST_FOOT_TRAFFIC": "Boost Foot Traffic",
  "BOOST_YOUR_EARNINGS_UP_TO_100_PERCENT": "Boost Your Earnings Up To 100%",
  "BOSNIA_AND_HERZEGOVINA": "Bosnia and Herzegovina",
  "BOSTON": "Boston",
  "BOTSWANA": "Botswana",
  "BRUNEI": "Brunei",
  "BULGARIA": "Bulgaria",
  "BUSINESS_CATEGORY": "Business Category",
  "BUSINESS_CATEGORY_DESCRIPTION": "Choose the category that best describes your business.",
  "BUSINESS_CATEGORY_MISSING_DESCRIPTION": "Help us understand your business category for better service optimization.",
  "BUSINESS_CATEGORY_MISSING_TITLE": "Business Category Required",
  "BUSINESS_GOALS": "Business Goals",
  "BUSINESS_GOALS_DESCRIPTION": "Select all that apply — you can change these anytime.",
  "BUSINESS_LEGAL_NAME": "Business Legal Name",
  "BUSINESS_NAME": "Business Name",
  "BUSINESS_PROFILES": "Business Profiles",
  "BUSINESS_TYPE": "Business Type",
  "BUSINESS_TYPE_ALL": "All types",
  "BUSINESS_TYPE_MOST_COMMON": "Most common",
  "CAMBODIA": "Cambodia",
  "CAMERA_STARTING": "Camera starting",
  "CANADA": "Canada",
  "CANCEL": "Cancel",
  "CANCELED_BOOKING": "Canceled booking",
  "CANCELLATION_FEE": "Cancellation fee",
  "CANCELLATION_FEE_EXPLANATION_DEADLINE": "We charge a flat fee per bag for cancellations after the free-cancellation deadline, to help cover the cost of space that goes unused.",
  "CANCELLATION_FEE_EXPLANATION_PART_1": "When you make a booking, we reserve the space for your bags, thus preventing others from utilizing it.",
  "CANCELLATION_FEE_EXPLANATION_PART_2": "We charge a flat fee per bag to help cover the cost of unused space due to late cancellations.",
  "CANCELLATION_FEE_INFO_BODY": "A flat fee per bag for cancellations after the free-cancellation deadline, to help cover the cost of space that goes unused.",
  "CANCELLATION_FEE_INFO_HEADER": "Cancellation fee",
  "CANCELLED": "Canceled",
  "CANCEL_BOOKING": "Cancel booking",
  "CANCEL_DEADLINE_PASSED": "The free-cancellation deadline, {{deadline}} local time at the storage location, has passed.",
  "CANCEL_FAILED": "Your booking can no longer be canceled",
  "CANCEL_FREE_UNTIL_DEADLINE": "You can cancel free of charge until {{deadline}} (local time at the storage location).",
  "CANCEL_FREE_WITHIN_GRACE": "You can cancel free of charge within 15 minutes of making your booking.",
  "CANCEL_GRACE_PASSED": "The 15-minute window for free cancellation after booking has passed.",
  "CANCEL_INVITATION": "Cancel invitation",
  "CANCEL_REASON_ASKED_TO_PAY_OTHER_SERVICE": "Was asked to pay directly or use other service",
  "CANCEL_REASON_CHANGE_OF_PLANS": "Change of plans / didn't need it after all",
  "CANCEL_REASON_DONT_UNDERSTAND_HOW_THIS_WORKS": "I don't understand how this works",
  "CANCEL_REASON_DUPLICATE_BOOKING": "Duplicate booking / booked multiple times",
  "CANCEL_REASON_FELT_UNSAFE": "Location or staff made me feel unsafe",
  "CANCEL_REASON_FOUND_OTHER_OPTION": "Found other storage option (please elaborate)",
  "CANCEL_REASON_FOUND_OTHER_OPTION_SIMPLE": "Found other storage option",
  "CANCEL_REASON_LOCATION_CLOSED_AT_ARRIVAL": "Location was closed when I arrived",
  "CANCEL_REASON_OTHER": "Other reason (please explain)",
  "CANCEL_REASON_STAFF_DIDNT_KNOW_ABOUT_SERVICE": "The staff didn't know about the service",
  "CANCEL_REASON_STORAGE_NOT_SECURE": "Luggage storage did not feel secure",
  "CANCEL_REASON_UNABLE_TO_FIND_LOCATION": "Couldn't find the location",
  "CANCEL_REASON_UNSUITABLE_OPENING_HOURS": "Opening hours don't suit my needs",
  "CANCEL_UNTIL_MIDNIGHT": "Free cancellation, any time.",
  "CANCEL_UNTIL_MIDNIGHT_EXPLANATION": "You can cancel your booking free of charge any time.",
  "CANCEL_YOU_WILL_BE_CHARGED": "You will be charged",
  "CAPACITY": "Capacity",
  "CAPACITY_SHORT": "Capacity",
  "CHANGE": "Change",
  "CHANGE_DISCOUNT_CODE": "Change Promo Code",
  "CHANGE_PASSWORD": "Change password",
  "CHANGE_PASSWORD_MISMATCH": "Passwords must be the same",
  "CHANGE_PASSWORD_REQUIRED": "Please enter a valid password with at least 8 characters, including one uppercase letter, one lowercase letter, one number, and one special character",
  "CHANGE_TIP_AT_PICK_UP": "You can change the tip amount at pick-up",
  "CHAT_FOR_HELP": "Feel free to use our live chat service if you have any questions.",
  "CHAT_WIDGET_HEADER": "Chat",
  "CHAT_WITH_SUPPORT": "Chat with support",
  "CHECKED_IN": "Checked in",
  "CHECKED_OUT": "Checked out",
  "CHECKING_IN": "Checking in…",
  "CHECKING_OUT": "Checking Out",
  "CHECK_IN": "Check In",
  "CHECK_IN_BOOKING": "Check in booking",
  "CHECK_IN_CONFIRMATION": "Yes, I am at the shop now",
  "CHECK_IN_CONNECTION": "Internet",
  "CHECK_IN_DATE": "Check-in date",
  "CHECK_IN_EXPLANATION_1": "Ready to hand over your bags?",
  "CHECK_IN_EXPLANATION_2": "This will activate insurance for your luggage",
  "CHECK_IN_NOT_YET": "No, don't check me in yet",
  "CHECK_OUT": "Check Out",
  "CHECK_OUT_AND_SHOW_RECEIPT": "be sure to check out and show the the final price to the staff",
  "CHECK_OUT_BOOKING": "Check out booking",
  "CHECK_OUT_CONFIRMATION": "Yes, I am at the shop now",
  "CHECK_OUT_EXPLANATION_1": "Ready to collect your bags?",
  "CHECK_OUT_EXPLANATION_2": "Your luggage will no longer be insured",
  "CHECK_OUT_NOT_YET": "No, don't check me out yet",
  "CHECK_OUT_THIS_STORAGE_LOCATION": "Check out this LuggageHero storage location",
  "CHICAGO": "Chicago",
  "CHILE": "Chile",
  "CHOICE_OF_PRICING_MODEL": "You choose whether you want to pay per hour or per day when you make a booking",
  "CHOOSE": "choose",
  "CHOOSE_ANOTHER_SHOP": "Choose another",
  "CHOOSE_A_REASON": "Choose a reason",
  "CHOOSE_COVERAGE_LONG": "Choose what kind of coverage you want",
  "CHOOSE_DATES_AND_CANCEL_EXPLANATION": "Choose your dates. You can cancel your booking at any time.",
  "CHOOSE_DATES_EXPLANATION": "Choose your dates. You can drop off and pick up any time within the opening hours.",
  "CHOOSE_LANGUAGE_TITLE": "What's your preferred language?",
  "CHOOSE_LOCATION_ADDRESS_DIRECTIONS_AFTER": "Choose the most convenient storage location. Address and directions are provided after booking.",
  "CHOOSE_NEW_PASSWORD_TO_COMPLETE_RESET": "Choose a new password to complete the reset",
  "CHOOSE_PASSWORD": "Choose a password",
  "CHOOSE_PASSWORD_MIN_LENGTH": "Choose password (min. 8 characters)",
  "CHOOSE_PAYMENT_METHOD": "Choose payment method",
  "CHOOSE_PAYMENT_METHOD_TO_CONFIRM_BOOKING_FOR_BAGS": "Choose a payment method to confirm your booking for",
  "CHOOSE_STORAGE_LOCATION_AND_MAKE_A_BOOKING": "Choose a storage location based on your needs and make a booking to get the full address and directions",
  "CHOOSE_TIMES_AND_BAGS": "Choose your times and how many bags",
  "CHOOSE_WHAT_KIND_OF_STORAGE_YOU_PREFER": "Choose which type of storage you prefer",
  "CITY": "City",
  "CLEAR": "Clear",
  "CLOSE": "Close",
  "CLOSED": "Closed",
  "CLOSES": "Closes",
  "CLOSES_AT": "Closes at",
  "CLOSING_SOON": "Closing soon",
  "CODE": "Code",
  "COLLECTING_BAGS_NOT_YET": "Not yet",
  "COLLECTING_BAGS_QUESTION": "Are you collecting your bags?",
  "COLLECTING_BAGS_YES": "Yes",
  "COLLECT_BAGS_AT": "Collect your bags from the storage room at",
  "COLOMBIA": "Colombia",
  "COMING_SOON": "Coming soon",
  "COMING_SOON_TEXT": "Coming soon",
  "COMMENTS": "Comments",
  "COMPLETED": "Completed",
  "COMPLETED_BOOKING": "Completed booking",
  "COMPLETED_PAYMENT_ONLINE": "Completed payment online",
  "COMPLETED_PAYOUT_LABEL": "Completed Payout",
  "COMPLETE_CAPTCHA_TO_CONTINUE": "Please complete the CAPTCHA to continue",
  "COMPLETE_ORGANIZATION": "Complete organization",
  "COMPLETE_ORGANIZATION_DESCRIPTION": "Complete your business profile to maximize your earnings and get the most out of the LuggageHero platform.",
  "CONFIRM": "Confirm",
  "CONFIRMED": "Confirmed",
  "CONFIRMED_BOOKING": "Confirmed booking",
  "CONFIRMED_HOURS_FOR": "Confirmed hours for",
  "CONFIRM_BOOKING": "Confirm booking",
  "CONFIRM_CANCEL_BOOKING": "Cancel my booking",
  "CONFIRM_CHANGES": "Confirm changes",
  "CONFIRM_DELETE_PAYMENT_METHOD": "Are you sure you want to remove this payment method? This action cannot be undone.",
  "CONFIRM_DELETE_TAX_ITEM": "Delete this tax item?",
  "CONFIRM_DROPOFF": "Confirm dropoff",
  "CONFIRM_EXPLANATION_TEXT": "Confirm your acceptance by providing your phone number. We’ll send you a one-time code that will confirm your acceptance",
  "CONFIRM_LOGOUT": "Confirm logout",
  "CONFIRM_LOGOUT_MESSAGE": "You will need to sign in again to manage your locations.",
  "CONFIRM_NEW_PASSWORD": "Confirm new password",
  "CONFIRM_PASSWORD": "Confirm password",
  "CONFIRM_PICKUP": "Confirm pickup",
  "CONFIRM_REMOVE_IMAGE": "Do you want to remove this image? This action cannot be undone.",
  "CONFIRM_REMOVE_MEMBER": "Do you want to remove this member?",
  "CONFIRM_RESET_PASSWORD_PART_1": "We will send a new password to",
  "CONFIRM_RESET_PASSWORD_PART_2": "Your old password will no longer work after this",
  "CONFIRM_RESET_PASSWORD_TO_EMAIL": "We will send a new password to {{email}}. Your old password will no longer work after this.",
  "CONNECT": "Connect",
  "CONNECTED_TEXT": "Account successfully connected!",
  "CONNECTION_STATUS": "Connection status",
  "CONNECT_FAILED": "Connection failed",
  "CONNECT_PAYOUT_ACCOUNT": "Connect your payout account",
  "CONNECT_PAYOUT_PRIVACY_DESC": "Your account information is handled entirely by Stripe and stored securely on their platform.",
  "CONNECT_PAYOUT_PRIVACY_TITLE": "LuggageHero never sees your bank details",
  "CONNECT_PAYOUT_SCHEDULE_DESC": "Earnings from completed bookings are automatically transferred to your bank at the end of each payout period.",
  "CONNECT_PAYOUT_SCHEDULE_TITLE": "Automatic payouts",
  "CONNECT_PAYOUT_STRIPE_BADGE_TEXT": "Secured by Stripe",
  "CONNECT_PAYOUT_STRIPE_SUBTITLE": "You'll be redirected to Stripe to complete setup securely.",
  "CONNECT_PAYOUT_TIME_DESC": "Stripe will guide you through a short onboarding — business details and bank account.",
  "CONNECT_PAYOUT_TIME_TITLE": "Takes about 5 minutes",
  "CONNECT_PAYOUT_WHAT_TO_EXPECT_HEADING": "What to expect",
  "CONTACT": "Contact",
  "CONTACT_FOR_EMAIL_OR_PHONE_CHANGE": "If you need to change your email or phone number, please contact us",
  "CONTACT_INFO": "Contact info",
  "CONTACT_US": "Contact us",
  "CONTINUE": "Continue",
  "CONTINUE_TO_STRIPE": "Continue to Stripe",
  "CONTINUE_TO_STRIPE_CAPTION": "You'll be redirected to Stripe and returned here when done.",
  "CONTINUE_WITH_EMAIL": "Continue with e-mail",
  "CONTINUE_WITH_PHONE": "Continue with phone",
  "CONTINUE_WITH_SMS": "Save phone number",
  "COPENHAGEN": "Copenhagen",
  "COPY": "Copy",
  "COPY_BOOKING_ID": "Copy booking ID",
  "COPY_BOOKING_LINK": "Copy booking link",
  "COPY_INVITE_LINK": "Copy invite link",
  "COPY_LINK": "Copy link",
  "COPY_TO": "Copy to:",
  "COPY_TO_ALL": "All",
  "COPY_TO_NEXT": "Next",
  "COPY_TO_PREVIOUS": "Previous",
  "COSTA_RICA": "Costa Rica",
  "COTE_DIVOIRE": "Cote d'Ivoire",
  "COULDNT_DETECT_SEALS": "No security seals detected, please retake the photo",
  "COULD_NOT_BE_CHARGED": "could not be charged",
  "COUNTRY": "Country",
  "COVERAGE": "coverage",
  "COVERAGE_BASIC": "Basic",
  "COVERAGE_CARDS_ADD_INSTEAD": "Add insurance for {{price}} instead",
  "COVERAGE_CARDS_BASIC_BELONGINGS": "Clothes and personal belongings",
  "COVERAGE_CARDS_CONFIRM_DECLINE": "I understand my luggage is not insured, and I accept responsibility for any loss.",
  "COVERAGE_CARDS_CONTINUE_WITHOUT": "Continue without insurance",
  "COVERAGE_CARDS_COVERED_NOTE": "Your luggage is covered up to {{amount}} per bag",
  "COVERAGE_CARDS_DECLINED_BODY": "For just {{price}}, your luggage is covered up to {{amount}}. Enjoy your day without worrying.",
  "COVERAGE_CARDS_DECLINED_TITLE": "You chose not to insure your luggage",
  "COVERAGE_CARDS_ELECTRONICS": "Electronics like iPads, laptops and cameras",
  "COVERAGE_CARDS_EVERYTHING_IN_BASIC": "Everything in Basic",
  "COVERAGE_CARDS_NONE_SUBTITLE": "Your luggage is stored without insurance",
  "COVERAGE_CARDS_SUBTITLE": "Enjoy your day without worrying about your bags",
  "COVERAGE_CARDS_THEFT_LOSS_DAMAGE": "Theft, loss and damage",
  "COVERAGE_PREMIUM": "Premium",
  "COVERAGE_UP_TO_X_AMOUNT": "Coverage up to",
  "COVERAGE_X_AMOUNT_PER_BAG": "{{amount}} coverage per bag",
  "CREATE": "Create",
  "CREATE_ACCOUNT": "Create account",
  "CREATE_ANOTHER": "Create Another",
  "CREATE_ANOTHER_STORAGE_LOCATION": "Create another storage location?",
  "CREATE_APP_TEXT": "Create app text",
  "CREATE_HOTELS_HERO_STORAGE_LOCATION_FAILURE": "Could not create the HotelsHero storage location. Please try again.",
  "CREATE_HOTELS_HERO_STORAGE_LOCATION_SUCCESS": "HotelsHero storage location created",
  "CREATE_NEW_AREA_CAPACITY_STEP_DESCRIPTION": "Specify how many luggage items you are able to store.",
  "CREATE_NEW_AREA_GENERAL_STEP_DESCRIPTION": "Which kind of storage option do you offer and where is it located?",
  "CREATE_NEW_AREA_SECURITY_STEP_DESCRIPTION": "Select your security solution. If you don’t have one select None.",
  "CREATE_ORGANIZATION": "Create organization",
  "CREATE_STORAGE_LOCATION": "Create Storage Location",
  "CREATE_STORAGE_LOCATION_FAILURE": "Could not create the storage location. Please try again.",
  "CREATE_STRIPE_ACCOUNT": "Create Stripe account",
  "CREATING_STORAGE_LOCATION": "Creating storage location",
  "CREATING_YOUR_BOOKING": "Creating your booking…",
  "CROATIA": "Croatia",
  "CURRENTLY_LINKED_TO": "Currently linked to",
  "CURRENT_PASSWORD": "Current password",
  "CUSTOMER": "Customer",
  "CUSTOMER_SUPPORT_SHORT": "Support",
  "CYPRUS": "Cyprus",
  "CZECH_REPUBLIC": "Czech Republic",
  "DASHBOARD_AUTH_REGISTER_PAGE_DESCRIPTION": "Create your personal login to access the LuggageHero partner dashboard, where you'll manage bookings, locations, and payouts.",
  "DASHBOARD_AUTH_REGISTER_PAGE_TITLE": "Create your account",
  "DASHBOARD_NOTIFICATIONS_BACK_TO_PROFILE": "Back to profile",
  "DASHBOARD_NOTIFICATIONS_PREFERENCES_FAILED": "Could not save preferences. Please try again.",
  "DASHBOARD_NOTIFICATIONS_PUSH": "Push notifications",
  "DASHBOARD_NOTIFICATIONS_PUSH_INTRO": "Choose which events trigger a push notification on your device.",
  "DASHBOARD_NOTIFICATIONS_PUSH_MOBILE_ONLY": "Manage your push notification settings in the LuggageHero app.",
  "DASHBOARD_NOTIFICATIONS_TYPE_BAGS_DROPPED_OFF": "Bags dropped off",
  "DASHBOARD_NOTIFICATIONS_TYPE_BAGS_PICKED_UP": "Bags picked up",
  "DASHBOARD_NOTIFICATIONS_TYPE_BONUS": "Bonuses earned",
  "DASHBOARD_NOTIFICATIONS_TYPE_BOOKING_CANCELED": "Booking cancelled",
  "DASHBOARD_NOTIFICATIONS_TYPE_BOOKING_CREATED": "New booking",
  "DASHBOARD_NOTIFICATIONS_TYPE_BOOKING_PAID": "Booking paid",
  "DASHBOARD_NOTIFICATIONS_TYPE_CERTIFIED": "Certification updates",
  "DASHBOARD_NOTIFICATIONS_TYPE_DEACTIVATED": "Storage location deactivated",
  "DASHBOARD_NOTIFICATIONS_TYPE_HEROKIT_SHIPPED": "HeroKit shipped",
  "DASHBOARD_NOTIFICATIONS_TYPE_INCIDENT_REPORTED": "Incident reported",
  "DASHBOARD_NOTIFICATIONS_TYPE_ONBOARDING": "Getting started",
  "DASHBOARD_NOTIFICATIONS_TYPE_PAYOUT": "Payouts",
  "DASHBOARD_NOTIFICATIONS_TYPE_REVIEW_ADDED": "New review",
  "DASHBOARD_NOTIFICATIONS_TYPE_SETUP_TASKS": "Setup reminders",
  "DASHBOARD_NOTIFICATIONS_TYPE_VAT": "VAT reminders",
  "DASHBOARD_NOTIFICATIONS_WHATSAPP": "WhatsApp",
  "DASHBOARD_NOTIFICATIONS_WHATSAPP_ADD_NUMBER": "Add a phone number",
  "DASHBOARD_NOTIFICATIONS_WHATSAPP_CONSENT": "Receive updates from LuggageHero on WhatsApp",
  "DASHBOARD_NOTIFICATIONS_WHATSAPP_CONSENT_FAILED": "Could not save your WhatsApp choice. Please try again.",
  "DASHBOARD_NOTIFICATIONS_WHATSAPP_INTRO": "Choose whether LuggageHero can message you on WhatsApp, and which updates you receive.",
  "DASHBOARD_NOTIFICATIONS_WHATSAPP_LOAD_FAILED": "Could not load WhatsApp settings. Please try again.",
  "DASHBOARD_NOTIFICATIONS_WHATSAPP_MARKETING": "News and tips",
  "DASHBOARD_NOTIFICATIONS_WHATSAPP_MARKETING_INTRO": "Occasional updates about LuggageHero features, reminders and rewards.",
  "DASHBOARD_NOTIFICATIONS_WHATSAPP_NO_NUMBER": "Add a mobile number to receive WhatsApp messages",
  "DASHBOARD_NOTIFICATIONS_WHATSAPP_SENDING_TO": "Messages go to",
  "DASHBOARD_NOTIFICATIONS_WHATSAPP_UTILITY": "Booking and account updates",
  "DASHBOARD_NOTIFICATIONS_WHATSAPP_UTILITY_INTRO": "Messages about your bookings, payouts and locations.",
  "DASHBOARD_NOTIFICATIONS_WHATSAPP_VERIFY_BODY": "Enter the code we sent on WhatsApp to",
  "DASHBOARD_NOTIFICATIONS_WHATSAPP_VERIFY_CANCEL": "Cancel",
  "DASHBOARD_NOTIFICATIONS_WHATSAPP_VERIFY_CHANGE_NUMBER": "Use a different number",
  "DASHBOARD_NOTIFICATIONS_WHATSAPP_VERIFY_CODE_LABEL": "Code",
  "DASHBOARD_NOTIFICATIONS_WHATSAPP_VERIFY_CONFIRM": "Confirm",
  "DASHBOARD_NOTIFICATIONS_WHATSAPP_VERIFY_FAILED": "We could not confirm your number. Try again.",
  "DASHBOARD_NOTIFICATIONS_WHATSAPP_VERIFY_RESEND_IN": "You can request a new code in",
  "DASHBOARD_NOTIFICATIONS_WHATSAPP_VERIFY_SEND": "Send code",
  "DASHBOARD_NOTIFICATIONS_WHATSAPP_VERIFY_SEND_FAILED": "We could not send a code to that number on WhatsApp.",
  "DASHBOARD_NOTIFICATIONS_WHATSAPP_VERIFY_SEND_TO": "We'll send a code on WhatsApp to",
  "DASHBOARD_NOTIFICATIONS_WHATSAPP_VERIFY_TITLE": "Confirm your number",
  "DASHBOARD_NOTIFICATIONS_WHATSAPP_VERIFY_WRONG_CODE": "That code was not right. Try again.",
  "DASHBOARD_ORGANIZATION_BUSINESS_CATEGORY_HOSTEL_DESCRIPTION": "Manage one or more hostels for better guest experience and revenue potential.",
  "DASHBOARD_ORGANIZATION_BUSINESS_CATEGORY_HOTEL_DESCRIPTION": "Manage one or more hotels for improved guest experience and revenue potential.",
  "DASHBOARD_ORGANIZATION_BUSINESS_CATEGORY_LOCAL_BUSINESS_DESCRIPTION": "Manage one or more local businesses for enhanced customer experience and revenue growth.",
  "DASHBOARD_ORGANIZATION_BUSINESS_GOAL_BETTER_GUEST_EXPERIENCE_DESCRIPTION": "Offer guests convenient, secure, and hassle-free luggage storage, enhancing their overall satisfaction and improving your hotel’s ratings.",
  "DASHBOARD_ORGANIZATION_BUSINESS_GOAL_BETTER_GUEST_EXPERIENCE_TITLE": "Better Guest Experience",
  "DASHBOARD_ORGANIZATION_BUSINESS_GOAL_BOOST_FOOT_TRAFFIC_DESCRIPTION": "Attract more customers to your business by offering convenient luggage storage services, increasing dwell time and encouraging additional purchases.",
  "DASHBOARD_ORGANIZATION_BUSINESS_GOAL_NEW_REVENUE_STREAM_DESCRIPTION": "Unlock additional income by monetizing unused space through effortless self-service luggage storage, attracting more guests and increasing profitability",
  "DASHBOARD_ORGANIZATION_BUSINESS_GOAL_NEW_REVENUE_STREAM_TITLE": "New Revenue Streams",
  "DASHBOARD_ORGANIZATION_BUSINESS_GOAL_STAFF_EFFICIENCY_DESCRIPTION": "Free up staff from manual luggage handling tasks, allowing them to focus on more meaningful guest interactions and other important responsibilities.",
  "DASHBOARD_ORGANIZATION_BUSINESS_GOAL_STAFF_EFFICIENCY_TITLE": "Staff Efficiency",
  "DASHBOARD_ORGANIZATION_WIZARD_STEP_GOALS_BODY": "Select one or multiple goals from signing up.",
  "DASHBOARD_ORGANIZATION_WIZARD_STEP_GOALS_HEADER": "Select Goals",
  "DASHBOARD_ORGANIZATION_WIZARD_STEP_GOALS_TITLE": "Goals",
  "DASHBOARD_ORGANIZATION_WIZARD_STEP_NAME_BODY": "What is the official / legal name of your business?",
  "DASHBOARD_ORGANIZATION_WIZARD_STEP_NAME_HEADER": "Legal Business Name",
  "DASHBOARD_ORGANIZATION_WIZARD_STEP_NAME_TITLE": "Name",
  "DASHBOARD_ORGANIZATION_WIZARD_STEP_TYPE_BODY": "Let us know which kind of business your are running.",
  "DASHBOARD_ORGANIZATION_WIZARD_STEP_TYPE_HEADER": "Select Business Category",
  "DASHBOARD_ORGANIZATION_WIZARD_STEP_TYPE_TITLE": "Business Category",
  "DASHBOARD_ORGANIZATION_WIZARD_TITLE": "Business setup",
  "DASHBOARD_PARTNER_INTRO_CTA": "Let's get started",
  "DASHBOARD_PARTNER_INTRO_EYEBROW": "Become a partner",
  "DASHBOARD_PARTNER_INTRO_FREE_BADGE": "Free to list",
  "DASHBOARD_PARTNER_INTRO_STEP_ACCOUNT_DESC": "Create your login to get started.",
  "DASHBOARD_PARTNER_INTRO_STEP_ACCOUNT_LABEL": "Account",
  "DASHBOARD_PARTNER_INTRO_STEP_ACCOUNT_TAG": "Start here",
  "DASHBOARD_PARTNER_INTRO_STEP_LOCATION_DESC": "Add your address, space, and opening hours.",
  "DASHBOARD_PARTNER_INTRO_STEP_LOCATION_LABEL": "Location",
  "DASHBOARD_PARTNER_INTRO_STEP_ORGANIZATION_DESC": "Tell us about your business.",
  "DASHBOARD_PARTNER_INTRO_STEP_ORGANIZATION_LABEL": "Organization",
  "DASHBOARD_PARTNER_INTRO_SUBTITLE": "Turn your spare space into income and start taking bookings from travelers nearby.",
  "DASHBOARD_PARTNER_INTRO_TIME": "Ready in about 5 minutes",
  "DASHBOARD_PARTNER_INTRO_TITLE": "List your business on LuggageHero",
  "DASHBOARD_PERFORMANCE_AVERAGE_DAILY_PROFIT": "Average Daily Profit",
  "DASHBOARD_PERFORMANCE_AVERAGE_DAILY_PROFIT_INCLUDING_VAT": "Average Daily Profit - including VAT",
  "DASHBOARD_PERFORMANCE_DAILY_BOOKINGS": "Daily Bookings",
  "DASHBOARD_PERFORMANCE_DAILY_PROFIT": "Daily Profit",
  "DASHBOARD_PERFORMANCE_DAILY_PROFIT_INCLUDING_VAT": "Daily Profit - including VAT",
  "DASHBOARD_PERFORMANCE_PROFIT": "Profit",
  "DASHBOARD_PERFORMANCE_PROFIT_INCLUDING_VAT": "Profit - including VAT",
  "DASHBOARD_REGISTER_FORM_TITLE": "Complete your free account",
  "DASHBOARD_SIGNAGE_BADGE_CONNECTED": "Activated",
  "DASHBOARD_SIGNAGE_BENEFIT_FOOT_TRAFFIC": "Attract more foot traffic with dynamic displays",
  "DASHBOARD_SIGNAGE_BENEFIT_MULTIPLY_EARNINGS": "Multiply your earnings with increased visibility",
  "DASHBOARD_SIGNAGE_CONFIRM_CONNECTION_DESCRIPTION": "You are about to connect your signage to the storage location:",
  "DASHBOARD_SIGNAGE_CONFIRM_CONNECTION_TITLE": "Confirm Connection",
  "DASHBOARD_SIGNAGE_CONFIRM_CONNECTION_WARNING": "Once activated, this sticker goes live for walk-in customers right away.",
  "DASHBOARD_SIGNAGE_CONNECTED_DESCRIPTION": "Your storage location is now visible on digital signage displays.",
  "DASHBOARD_SIGNAGE_CONNECTED_HEADLINE": "Digital signage is connected",
  "DASHBOARD_SIGNAGE_CONNECTED_TOAST": "Signage activated for {{shop}}",
  "DASHBOARD_SIGNAGE_CONNECT_BUTTON": "Activate signage",
  "DASHBOARD_SIGNAGE_CONNECT_FAILED": "Failed to activate signage. Please check your PIN and try again.",
  "DASHBOARD_SIGNAGE_CONNECT_FAILED_BAD_REQUEST_LINE_1": "This PIN code couldn't be activated.",
  "DASHBOARD_SIGNAGE_CONNECT_FAILED_BAD_REQUEST_LINE_2": "It may be incorrect or require manual activation. Please contact support.",
  "DASHBOARD_SIGNAGE_CONNECT_WIZARD_TITLE": "Activate signage",
  "DASHBOARD_SIGNAGE_DISCONNECT_BUTTON": "Disconnect Signage",
  "DASHBOARD_SIGNAGE_DISCONNECT_CANCEL": "Cancel",
  "DASHBOARD_SIGNAGE_DISCONNECT_CONFIRM": "Disconnect",
  "DASHBOARD_SIGNAGE_DISCONNECT_CONFIRMATION_MESSAGE": "Are you sure you want to disconnect the digital signage from this storage location? This will remove the QR code and stop displaying this location on digital signs.",
  "DASHBOARD_SIGNAGE_DISCONNECT_CONFIRMATION_TITLE": "Disconnect Signage",
  "DASHBOARD_SIGNAGE_DISCONNECT_FAILED": "Failed to disconnect signage. Please try again.",
  "DASHBOARD_SIGNAGE_DISCONNECT_SUCCESS": "Signage disconnected successfully.",
  "DASHBOARD_SIGNAGE_DISCONNECT_WARNING_TEXT": "This action will remove the QR code from digital signage displays and cannot be undone.",
  "DASHBOARD_SIGNAGE_EMPTY_DESCRIPTION": "Grab a piece from your Welcome Box, find its PIN, and activate it to start welcoming walk-in customers.",
  "DASHBOARD_SIGNAGE_EMPTY_TITLE": "No stickers activated yet",
  "DASHBOARD_SIGNAGE_FROM_STORAGE_LOCATION": "from this storage location.",
  "DASHBOARD_SIGNAGE_HEADLINE": "Connect signage to increase bookings",
  "DASHBOARD_SIGNAGE_HERO_CODE_BUTTON": "Show HeroCode",
  "DASHBOARD_SIGNAGE_ITEM_WINDOW_STICKERS": "HeroCode window display sticker(s)",
  "DASHBOARD_SIGNAGE_KIT_SUBTITLE": "These are the HeroCode items sent to your shop. Activate each one — the PIN is right under the QR code.",
  "DASHBOARD_SIGNAGE_KIT_TITLE": "Activate your signage",
  "DASHBOARD_SIGNAGE_NOKIT_BENEFIT_EARNINGS_DESC": "Every walk-in booking adds to your monthly payout.",
  "DASHBOARD_SIGNAGE_NOKIT_BENEFIT_EARNINGS_TITLE": "Higher earnings",
  "DASHBOARD_SIGNAGE_NOKIT_BENEFIT_OFFICIAL_DESC": "Branded signage signals you're a trusted storage point.",
  "DASHBOARD_SIGNAGE_NOKIT_BENEFIT_OFFICIAL_TITLE": "Look official",
  "DASHBOARD_SIGNAGE_NOKIT_BENEFIT_TRAFFIC_DESC": "Walk-in travelers spot your shop and drop their bags.",
  "DASHBOARD_SIGNAGE_NOKIT_BENEFIT_TRAFFIC_TITLE": "More foot traffic",
  "DASHBOARD_SIGNAGE_NOKIT_BODY": "Once your Welcome Box arrives, activate your stickers on this page. Each one connects this shop to nearby travelers looking for storage.",
  "DASHBOARD_SIGNAGE_NOKIT_CHIP": "Welcome Box on the way",
  "DASHBOARD_SIGNAGE_NOKIT_TITLE": "Your signage lives here",
  "DASHBOARD_SIGNAGE_PAGE_HEADING": "Signage Management",
  "DASHBOARD_SIGNAGE_PAGE_SUBTITLE": "Activate and manage the stickers that bring in walk-in customers.",
  "DASHBOARD_SIGNAGE_PIN_ENTRY_DESCRIPTION": "Find the number at the end of the URL printed on your LuggageHero marketing materials.",
  "DASHBOARD_SIGNAGE_PIN_ENTRY_HELPER_TEXT": "Look for a URL like qr.luggagehero.com/52300 or lughe.ro/52300 — your PIN is the number at the end.",
  "DASHBOARD_SIGNAGE_PIN_ENTRY_PLACEHOLDER": "e.g. 52300",
  "DASHBOARD_SIGNAGE_PIN_ENTRY_TITLE": "Enter Your Signage PIN",
  "DASHBOARD_SIGNAGE_PIN_HINT": "PIN is right under the QR code",
  "DASHBOARD_SIGNAGE_QR_CODES_LABEL": "QR Codes",
  "DASHBOARD_SIGNAGE_QR_CODE_ACTIVE": "Active",
  "DASHBOARD_SIGNAGE_QR_CODE_LABEL": "QR Code",
  "DASHBOARD_SIGNAGE_REMOVE_QR_CODE_CANCEL": "Cancel",
  "DASHBOARD_SIGNAGE_REMOVE_QR_CODE_CONFIRM": "Remove",
  "DASHBOARD_SIGNAGE_REMOVE_QR_CODE_CONFIRMATION_MESSAGE": "Are you sure you want to remove this QR code from the storage location? This will stop displaying this QR code on digital signs.",
  "DASHBOARD_SIGNAGE_REMOVE_QR_CODE_CONFIRMATION_TITLE": "Remove QR Code",
  "DASHBOARD_SIGNAGE_REMOVE_QR_CODE_FAILED": "Failed to remove QR code. Please try again.",
  "DASHBOARD_SIGNAGE_REMOVE_QR_CODE_SUCCESS": "QR code removed successfully.",
  "DASHBOARD_SIGNAGE_SELECT_LOCATION_FIRST": "Please select a storage location first",
  "DASHBOARD_SIGNAGE_STATUS_CONNECTED": "Signage connected",
  "DASHBOARD_SIGNAGE_STATUS_PENDING_CONNECTION": "Signage not connected",
  "DASHBOARD_SIGNAGE_STORAGE_LOCATION": "Storage Location",
  "DASHBOARD_SIGNAGE_WARNING": "Warning",
  "DASHBOARD_SIGNAGE_WIZARD_FINISH_BUTTON": "Finish",
  "DASHBOARD_SIGNAGE_WIZARD_NEXT_BUTTON": "Next",
  "DASHBOARD_SIGNAGE_YOUR_SIGNAGE_SUBTITLE": "Stickers you've activated across your shops.",
  "DASHBOARD_SIGNAGE_YOUR_SIGNAGE_TITLE": "Your signage",
  "DASHBOARD_SIGNAGE_YOU_ARE_ABOUT_TO_REMOVE_QR_CODE_FROM": "You are about to remove QR code",
  "DASHBOARD_STORAGE_LOCATION_DUPLICATE_CONTINUE": "Continue setting up {{name}}",
  "DASHBOARD_STORAGE_LOCATION_DUPLICATE_HEADING": "You already have a location at this address",
  "DASHBOARD_STORAGE_LOCATION_DUPLICATE_HINT": "Choose how to continue",
  "DASHBOARD_STORAGE_LOCATION_DUPLICATE_NEW_BODY": "For a separate storage space at the same address — e.g. a second shop in the building.",
  "DASHBOARD_STORAGE_LOCATION_DUPLICATE_NEW_TITLE": "Add a new location here",
  "DASHBOARD_STORAGE_LOCATION_DUPLICATE_OPEN_BODY": "Open it to see or change its details.",
  "DASHBOARD_STORAGE_LOCATION_DUPLICATE_OPEN_TITLE": "Go to {{name}}",
  "DASHBOARD_STORAGE_LOCATION_DUPLICATE_RESUME_BODY": "Pick up where you left off. Nothing you entered is lost.",
  "DASHBOARD_STORAGE_LOCATION_DUPLICATE_RESUME_TITLE": "Finish setting up {{name}}",
  "DASHBOARD_STORAGE_LOCATION_DUPLICATE_STATUS_DRAFT": "setup not finished. What do you want to do?",
  "DASHBOARD_STORAGE_LOCATION_DUPLICATE_STATUS_SET_UP": "already set up. What do you want to do?",
  "DASHBOARD_STORAGE_LOCATION_ONBOARDING_PAGE_DESCRIPTION": "Add your first luggage storage location and start your revenue journey today.",
  "DASHBOARD_STORAGE_LOCATION_ONBOARDING_PAGE_TITLE": "Add Your First Location",
  "DASHBOARD_STORAGE_LOCATION_WIZARD_FINISH_BUTTON": "Finish",
  "DASHBOARD_STORAGE_LOCATION_WIZARD_STEP_AREA_SETUP_BODY": "Add one or multiple storage areas at your location.",
  "DASHBOARD_STORAGE_LOCATION_WIZARD_STEP_AREA_SETUP_HEADER": "Area setup",
  "DASHBOARD_STORAGE_LOCATION_WIZARD_STEP_AREA_SETUP_TITLE": "Area setup",
  "DASHBOARD_STORAGE_LOCATION_WIZARD_STEP_BASIC_INFORMATION_BODY": "Let us get to know your location a little better.",
  "DASHBOARD_STORAGE_LOCATION_WIZARD_STEP_BASIC_INFORMATION_HEADER": "General",
  "DASHBOARD_STORAGE_LOCATION_WIZARD_STEP_BASIC_INFORMATION_TITLE": "General",
  "DASHBOARD_STORAGE_LOCATION_WIZARD_STEP_CONTACT_INFO_BODY": "Add the contact details and notification preferences for this location.",
  "DASHBOARD_STORAGE_LOCATION_WIZARD_STEP_CONTACT_INFO_HEADER": "Contact Info",
  "DASHBOARD_STORAGE_LOCATION_WIZARD_STEP_CONTACT_INFO_TITLE": "Contact Info",
  "DASHBOARD_STORAGE_LOCATION_WIZARD_STEP_MEMBER_SETUP_BODY": "Let us know who will be managing this location.",
  "DASHBOARD_STORAGE_LOCATION_WIZARD_STEP_MEMBER_SETUP_HEADER": "Manager setup",
  "DASHBOARD_STORAGE_LOCATION_WIZARD_STEP_MEMBER_SETUP_TITLE": "Manager setup",
  "DASHBOARD_STORAGE_LOCATION_WIZARD_STEP_OPENING_HOURS_SETUP_BODY": "You can always change the opening hours later in the 'General' section of your storage location settings.",
  "DASHBOARD_STORAGE_LOCATION_WIZARD_STEP_OPENING_HOURS_SETUP_HEADER": "Opening hours",
  "DASHBOARD_STORAGE_LOCATION_WIZARD_STEP_OPENING_HOURS_SETUP_TITLE": "Opening hours",
  "DASHBOARD_STORAGE_LOCATION_WIZARD_STEP_TOS_BODY": "Please review the key points of our partner agreement before creating your location.",
  "DASHBOARD_STORAGE_LOCATION_WIZARD_STEP_TOS_HEADER": "Terms of Service",
  "DASHBOARD_STORAGE_LOCATION_WIZARD_STEP_TOS_TITLE": "Terms of service",
  "DASHBOARD_STORAGE_LOCATION_WIZARD_TITLE": "Add location",
  "DASHBOARD_STORAGE_LOCATION_WIZARD_TOS_ACCEPT_LABEL": "I have read and agree to the Terms of Service",
  "DASHBOARD_STORAGE_LOCATION_WIZARD_TOS_POINT_1_BODY": "LuggageHero provides the platform, marketplace listing, customer support, insurance or bag guarantee, and automated payouts. Your job is to store luggage safely and reliably.",
  "DASHBOARD_STORAGE_LOCATION_WIZARD_TOS_POINT_1_TITLE": "You store, we handle the rest",
  "DASHBOARD_STORAGE_LOCATION_WIZARD_TOS_POINT_2_BODY": "You are responsible for keeping your address, opening hours, and storage capacity up to date in the dashboard at all times.",
  "DASHBOARD_STORAGE_LOCATION_WIZARD_TOS_POINT_2_TITLE": "Keep your info accurate",
  "DASHBOARD_STORAGE_LOCATION_WIZARD_TOS_POINT_3_BODY": "Always verify ownership using the traveler's digital booking confirmation before releasing any luggage.",
  "DASHBOARD_STORAGE_LOCATION_WIZARD_TOS_POINT_3_TITLE": "Only release bags to the right person",
  "DASHBOARD_STORAGE_LOCATION_WIZARD_TOS_POINT_4_BODY": "LuggageHero charges a storage fee commission, a per-bag fee, and a payment processing fee. Current rates are published in the Help Center.",
  "DASHBOARD_STORAGE_LOCATION_WIZARD_TOS_POINT_4_TITLE": "Fees and commissions apply",
  "DASHBOARD_STORAGE_LOCATION_WIZARD_TOS_POINT_5_BODY": "Your visibility and program eligibility depend on maintaining positive ratings, low incident rates, and consistent operational quality.",
  "DASHBOARD_STORAGE_LOCATION_WIZARD_TOS_POINT_5_TITLE": "Performance standards matter",
  "DASHBOARD_STORAGE_LOCATION_WIZARD_TOS_READ_FULL_AGREEMENT": "Read the full agreement",
  "DASHBOARD_SUPERHERO_PAGE_HEADER": "SuperHero",
  "DASHBOARD_SUPERHERO_PAGE_TITLE": "SuperHero",
  "DASHBOARD_SUPERHERO_TOS_WIZARD_FINISH_BUTTON": "I accept",
  "DASHBOARD_SUPERHERO_TOS_WIZARD_NEXT_BUTTON": "Continue",
  "DASHBOARD_SUPERHERO_TOS_WIZARD_SELECT_LOCATION_PROMPT": "Select the location you want to enroll",
  "DASHBOARD_SUPERHERO_TOS_WIZARD_TITLE": "SuperHero Partner Program",
  "DASHBOARD_WHATSAPP_PROMPT_ACCEPT": "Yes, message me on WhatsApp",
  "DASHBOARD_WHATSAPP_PROMPT_BODY": "LuggageHero can send you booking and account updates on WhatsApp. You choose which ones, and you can turn it off at any time.",
  "DASHBOARD_WHATSAPP_PROMPT_DECLINE": "No thanks",
  "DASHBOARD_WHATSAPP_PROMPT_SAVE_FAILED": "Could not save your choice. Please try again.",
  "DASHBOARD_WHATSAPP_PROMPT_TITLE": "Get updates on WhatsApp?",
  "DASHBOARD_WIZARD_GENERAL_ADDRESS_DESCRIPTION": "Travelers use this to find you. Search for your business or street address.",
  "DASHBOARD_WIZARD_GENERAL_BUSINESS_DESCRIPTION": "Shown to travelers when they book.",
  "DASHBOARD_WIZARD_GENERAL_BUSINESS_HEADING": "Your business",
  "DASHBOARD_WIZARD_GENERAL_ENTER_MANUALLY": "Not on Google Maps? Enter the address manually",
  "DASHBOARD_WIZARD_GENERAL_HINT": "Add {{missing}} to continue",
  "DASHBOARD_WIZARD_GENERAL_HINT_ADDRESS": "address",
  "DASHBOARD_WIZARD_GENERAL_HINT_NAME": "business name",
  "DASHBOARD_WIZARD_GENERAL_HINT_TYPE": "business type",
  "DASHBOARD_WIZARD_GENERAL_MAP_CAPTION": "Pin in the wrong spot? You can adjust it later in Location settings.",
  "DASHBOARD_WIZARD_GENERAL_MAP_EMPTY_BODY": "Add an address to see where travelers will find you.",
  "DASHBOARD_WIZARD_GENERAL_MAP_EMPTY_TITLE": "Your pin appears here",
  "DASHBOARD_WIZARD_GENERAL_MAP_PREVIEW": "Map preview",
  "DASHBOARD_WIZARD_GENERAL_NAME_PLACEHOLDER": "e.g. Central Berlin Café",
  "DASHBOARD_WIZARD_GENERAL_SEARCH_INSTEAD": "Search Google Maps instead",
  "DASHBOARD_WIZARD_GENERAL_SEARCH_PLACEHOLDER": "Search your business or address",
  "DASHBOARD_WIZARD_GENERAL_STREET_AND_NUMBER": "Street and number",
  "DASHBOARD_WIZARD_HOURS_BODY": "Travelers can only book during these hours. You can change them later in Location settings.",
  "DASHBOARD_WIZARD_HOURS_HEADER": "When can travelers drop off and pick up?",
  "DASHBOARD_WIZARD_HOURS_HINT": "Check the hours for {{day}}",
  "DASHBOARD_WIZARD_NEXT_AREA_SETUP": "Next: Area setup",
  "DASHBOARD_WIZARD_STEP_OF": "Step {{n}} of {{total}}",
  "DATE": "Date",
  "DATE_RANGE": "Date range",
  "DAY": "day",
  "DAYS": "days",
  "DAY_AHEAD_PRICE": "Day-ahead price",
  "DAY_AHEAD_STORAGE": "Day-ahead storage",
  "DAY_AHEAD_STORAGE_PAY_AS_YOU_GO": "Day-ahead storage, pay as you go",
  "DAY_STORAGE": "Day storage",
  "DELETE": "Delete",
  "DELETE_ACCOUNT": "Delete Account",
  "DELETE_ACCOUNT_REQUEST_RECEIVED": "Your request for account deletion has been received. We strive to process most requests within 48 hours. Your will receive a notification when the process is completed.",
  "DELETE_ACCOUNT_WARNING": "Deleting your account will also remove all your personal information from our database.",
  "DELETE_MY_ACCOUNT": "Delete my account",
  "DELETE_USER_CONFIRM_1": "Are you sure you want to delete your account?",
  "DELETE_USER_CONFIRM_2": "IMPORTANT: You will no longer be able to log in and access your bookings. This action cannot be undone.",
  "DENMARK": "Denmark",
  "DEPARTING": "Departing",
  "DEPOSIT_BAGS_AT": "Deposit your bags in the storage room at",
  "DEPOSIT_BAGS_IN_STORAGE_AREA": "Go ahead and deposit your bags in the storage area",
  "DESCRIPTION": "Description",
  "DETAILS": "Details",
  "DID_NOT_RECEIVE_A_CODE": "Didn't receive a code?",
  "DID_YOU_PRINT": "Did you print your signage material?",
  "DIRECTIONS_AFTER_PAYMENT_INFO": "Address shown after adding payment method",
  "DIRECTIONS_AFTER_PAYMENT_METHOD": "Directions will be shown after adding a payment method",
  "DISCOUNT_APPLIED": "Discount applied",
  "DISCOUNT_CODE": "Discount code",
  "DISCOUNT_CODE_APPLIED": "Discount code applied",
  "DISCOUNT_VOUCHER_EXPLANATION": "If you have a voucher or promo code, provide it here and we will make sure to add it to your next booking.",
  "DISMISS": "Dismiss",
  "DISTANCE_AWAY": "away",
  "DOES_NOT_RECOMMEND_THIS_LOCATION": "Does not recommend this location",
  "DOMINICAN_REPUBLIC": "Dominican Republic",
  "DONE": "Done",
  "DO_NOT_CHANGE": "Don't change",
  "DO_NOT_TAKE_SCREENSHOT": "Do not take screenshot",
  "DO_YOU_WANT_TO_CANCEL_YOUR_BOOKING": "Do you want to cancel your booking as well? You won't be charged",
  "DO_YOU_WANT_TO_CANCEL_YOUR_BOOKING_TOO": "Do you want to cancel your booking as well? Canceling because of an incident is free of charge.",
  "DROPOFF_CONFIRM": "Confirm drop-off",
  "DROPOFF_CONFIRMED": "Drop-off confirmed",
  "DROPOFF_CONTINUE": "Continue drop-off",
  "DROPOFF_COVER_LAST_CHANCE": "Insurance can't be added after drop-off",
  "DROPOFF_COVER_NOT_COVERED": "Your bags are not insured yet",
  "DROPOFF_COVER_SUBTITLE": "Your bags are not covered yet. Cover is paid with the rest of your booking at pick-up.",
  "DROPOFF_COVER_UNAVAILABLE": "We could not add insurance right now. You can still drop off your bags.",
  "DROPOFF_HEADER_BOOKING": "Drop off · booking {{reference}}",
  "DROPOFF_INSURANCE_BASIC": "Basic insurance",
  "DROPOFF_INSURANCE_PREMIUM": "Premium insurance",
  "DROPOFF_READY_DEPOSIT_BAGS_AT_LOCATION": "Start the timer and deposit your bags in the storage room at {{location}}",
  "DROPOFF_READY_HAND_OVER_LUGGAGE_AT_LOCATION": "Start the timer and hand your luggage over to the staff at {{location}}",
  "DROPOFF_SLIDE_TO_CONFIRM": "Slide to confirm drop-off",
  "DROPOFF_TAKE_A_PHOTO_OF_YOUR_LUGGAGE_PART_1": "To get started, take a picture of the bags you wish to store",
  "DROPOFF_TAKE_A_PHOTO_OF_YOUR_LUGGAGE_PART_2": "This will make them easy to locate upon pickup",
  "DROPOFF_WELCOME_STEP_INTRO_MESSAGE": "Let's guide you through the process of dropping off your luggage safely. You can do everything yourself right here from your smartphone.",
  "DROPOFF_WELCOME_STEP_INTRO_TITLE": "Intro",
  "DROPOFF_WELCOME_STEP_OPTIONS_TITLE": "Options",
  "DROPOFF_WELCOME_STEP_SELECT_BAGS_TITLE": "Luggage",
  "DROPOFF_WITHOUT_COVER": "Drop off without insurance",
  "DROPPED_OFF": "Dropped off",
  "DROP_OFF": "Drop off",
  "DROP_OFF_YOUR_LUGGAGE": "Drop off your luggage",
  "DUE_NOW": "Due now",
  "DYNAMIC_CODE": "Dynamic code",
  "EACH_BAG_IS_INSURED": "Each bag is insured for up to",
  "EARNINGS": "Earnings",
  "EARNINGS_INFO_ARIA_LABEL": "About earnings",
  "EARNINGS_INFO_BODY": "Your minimum guarantee and any bonus are added to your payout, not to individual bookings.",
  "EARNINGS_INFO_TITLE": "Earnings per booking",
  "EARNINGS_LAST_30_DAYS": "Earnings last 30 days",
  "EARNINGS_TIP_INCLUDED": "incl. tip",
  "EARNING_RATE": "Earning Rate",
  "EARNING_RATE_CARD_TITLE": "Min. Bag Guarantee",
  "EARNING_RATE_EXPLAIN_BULLET_1": "A traveler stores their bag for only a few hours",
  "EARNING_RATE_EXPLAIN_BULLET_2": "A discount was applied to the booking",
  "EARNING_RATE_EXPLAIN_CARD_UNLOCKED_WITH_WALK_INS": "Unlocked when customers without a booking scan your HeroCode.",
  "EARNING_RATE_EXPLAIN_EARN_A_GUARANTEED_MIN_AMOUNT_EVEN_WHEN": "Earn a guaranteed minimum amount per stored bag, even when:",
  "ECUADOR": "Ecuador",
  "EDIT": "Edit",
  "EDIT_AREA": "Edit Area",
  "EDIT_REVIEW": "Edit review",
  "EGYPT": "Egypt",
  "ELITE_PARTNER_TOOLTIP": "HeroElite partners are experienced and excellently located with an average rating higher than 4.7",
  "EL_SALVADOR": "El Salvador",
  "EMAIL": "E-mail",
  "EMAIL_ADDRESS": "Email Address",
  "EMAIL_EXPLANATION": "Receive directions and check-in link via e-mail. This service is free of charge.",
  "EMAIL_INPUT_PLACEHOLDER": "Enter your email address",
  "EMAIL_MISSING": "e-mail missing",
  "EMAIL_NOT_RECEIVED": "Did you not get the email?",
  "EMAIL_REQUIRED": "E-mail is required",
  "ENDING_IN": "ending in",
  "ENGLISH_TRANSLATION": "English Translation",
  "ENGLISH_TRANSLATION_PLACEHOLDER": "Book now",
  "ENTER_CARD_DETAILS": "Enter your card details",
  "ENTER_ONETIME_PASSWORD": "Enter the code we just sent you",
  "ENTER_ORGANIZATION_NAME": "Enter organization name",
  "ENTER_PIN": "Enter PIN",
  "ENTER_VERIFICATION_CODE_EMAIL": "Enter the verification code sent to your email",
  "ERROR_ADDING_PAYMENT_CARD": "There was an error adding the payment card. Please try again.",
  "ERROR_ADDING_PAYMENT_METHOD": "Something went wrong while adding your payment method. Please try again.",
  "ERROR_DELETING_TAX_ITEM": "Error deleting tax item",
  "ERROR_INITIATING_PAYMENT": "Something went wrong while starting the payment. Please try again.",
  "ERROR_LOADING_PAYOUT_METHODS": "Failed to load payout methods. Please check your connection and try again.",
  "ERROR_LOADING_PERFORMANCE_DATA": "Could not load performance data",
  "ERROR_LOADING_SHOPS": "Could not load storage locations. Please try again.",
  "ERROR_LOADING_TAXES": "Error loading taxes",
  "ERROR_REMOVING_PAYMENT_METHOD": "Failed to remove payment method. Please check your connection and try again.",
  "ESTONIA": "Estonia",
  "ETHIOPIA": "Ethiopia",
  "EXACT_ADDRESS_AND_DIRECTIONS_AFTER_BOOKING": "Book now, pay later",
  "EXCEPTIONAL_OPENING_HOURS": "Exceptions",
  "EXCEPTIONAL_OPENING_HOURS_EXPLANATION": "Set specific opening hours for individual dates. These override normal and holiday opening hours. Useful for temporary closures or special hours.",
  "EXCLUSIVE": "Exclusive",
  "EXPECTED_DROP_OFF": "Expected drop-off time",
  "EXPECTED_PICK_UP": "Expected pickup time",
  "EXPECTED_TIME": "Expected time",
  "EXPECTED_TIME_EXPLANATION": "This is not binding. You can show up any time within the opening hours of the shop.",
  "EXTERNAL_BOOKING": "External booking",
  "FAILED_TO_COMPLETE_PAYMENT": "Failed to complete payment online",
  "FEEDBACK": "Feedback",
  "FEEDBACK_RECEIVED": "Your feedback was received!",
  "FEWER_BAGS": "Fewer bags",
  "FILTER": "Filter",
  "FILTERS_BUTTON_TEXT": "Filter",
  "FILTER_BY_BOOKING_TAG": "Filter by booking tag",
  "FILTER_BY_BOOKING_TAG_TEXT": "Apply a filter so the message is only sent for bookings that are tagged by LuggageHero",
  "FILTER_SHOPS": "Filter shops",
  "FINAL_PRICE": "Final price",
  "FINDING_STORAGE_LOCATIONS": "Finding storage locations nearby",
  "FIND_SHOP": "Find shop",
  "FINLAND": "Finland",
  "FIRST_SHOP_BADGE": "Recommended",
  "FIRST_TIME_USER": "First time user?",
  "FIRST_TIME_USING_LUGGAGEHERO": "Looks like it's your first time using LuggageHero",
  "FLAT_RATE": "Flat rate",
  "FLAT_RATE_EXPLANATION": "Pay less when storing longer",
  "FLEXIBLE_BOOKING": "Flexible booking",
  "FLEXIBLE_BOOKINGS_TOOLTIP": "You can change the dates if your plans change, and you are free to show up anytime within the opening hours of your storage location.",
  "FORGOT_PASSWORD": "Forgot your password?",
  "FOR_BAGS": "For",
  "FOR_FACILITATING_SALES_IN_SAME_PERIOD": "For facilitating sales in the same period",
  "FOR_TIME_PERIOD": "For",
  "FRANCE": "France",
  "FREE": "Free",
  "FREE_CANCELLATION": "Free cancellation",
  "FREE_CANCELLATION_POLICY_EXPLANATION": "You can cancel free of charge until {{time}} on your drop-off day, local time at the storage location, or within 15 minutes of booking if that is later.",
  "FREE_CANCELLATION_POLICY_SAME_DAY_EXPLANATION": "You can cancel free of charge until {{time}} on your drop-off day, local time at the storage location, or within 15 minutes of booking for same-day bookings.",
  "FREE_CANCELLATION_UNTIL": "Free cancellation until {{deadline}}",
  "FREE_CANCELLATION_UNTIL_DROPOFF_MORNING": "Free cancellation until {{time}} on your drop-off day",
  "FREE_CANCELLATION_UNTIL_EXPLANATION": "You can cancel your booking free of charge until {{deadline}}, local time at the storage location.",
  "FREE_CANCELLATION_WITHIN_GRACE": "Free cancellation within 15 minutes of booking",
  "FREE_CANCELLATION_WITHIN_GRACE_EXPLANATION": "You can cancel your booking free of charge within 15 minutes of making it.",
  "FREE_SPACE": "Free space",
  "FREE_STORAGE_OF_X_BAGS": "Free storage of",
  "FREE_WIFI": "Free Wi-Fi",
  "FRIDAY": "Friday",
  "FROM": "From",
  "FROM_CENTER_OF": "From the centre of",
  "FROM_SELECTED_LOCATION": "from selected location",
  "FROM_STORAGE_LOCATION": "from this storage location.",
  "FROM_YOUR_LOCATION": "from your location",
  "FULLY_BOOKED": "Fully booked",
  "FULL_NAME": "Full Name",
  "FULL_SCREEN": "Full screen",
  "GABON": "Gabon",
  "GAMBIA": "Gambia",
  "GENERAL": "General",
  "GENERAL_MENU_SECTION": "General",
  "GENERAL_TAB_TITLE": "General",
  "GENERIC_ERROR": "Something went wrong. Please try again.",
  "GEO_ERROR_TITLE": "Your location is unavailable",
  "GEO_PERMISSION_DENIED": "You have not given us permission to access your current location",
  "GEO_POSITION_UNAVAILABLE": "Your current position cannot be determined at this time",
  "GEO_TIMEOUT": "The request took too long to complete",
  "GERMANY": "Germany",
  "GET": "Get",
  "GET_A_SECURITY_SEAL_AND_ATTACH_IT": "Get a security seal and attach it to your bag",
  "GET_DIRECTIONS": "Get directions",
  "GET_HELP_WITH_ACCESS_CODE": "Get help",
  "GET_IN_TOUCH": "Get in touch",
  "GET_LATEST_VERSION": "Get latest version",
  "GET_STARTED": "Get started",
  "GHANA": "Ghana",
  "GIBRALTAR": "Gibraltar",
  "GIVE_FEEDBACK": "Give feedback",
  "GOOGLE": "Google",
  "GO_TO": "Go to",
  "GO_TO_LOGIN": "Go to login",
  "GO_TO_MY_BOOKING": "Go to my booking",
  "GO_TO_PAYMENT": "Go to payment",
  "GO_TO_STORAGE_LOCATION": "Head to the storage location at your convenience",
  "GREECE": "Greece",
  "GROUP_DISCOUNT_APPLIES": "This discount applies to bookings of 5 bags or more",
  "GUATEMALA": "Guatemala",
  "GUEST": "Guest",
  "GUESTY_API_KEY_MISSING": "Please provide your Guesty API key to connect with LuggageHero",
  "GUESTY_STEP1_HEADLINE": "Connect LuggageHero app",
  "GUESTY_STEP1_TEXT": "Log in to your Guesty account and find and connect the Luggagehero app in the",
  "GUESTY_STEP2_HEADLINE": "Copy Guesty API key",
  "GUESTY_STEP2_TEXT": "Copy your Guesty API key, come back to this page and paste it into the input field and click Connect",
  "GUESTY_STEP3_HEADLINE": "Configure auto message",
  "GUESTY_STEP3_TEXT": "Use the custom variable {{luggagehero}} in your Guesty auto messages to include a unique LuggageHero booking link",
  "GUESTY_STEP4_HEADLINE": "You're all set",
  "GUESTY_STEP4_TEXT": "Your guests will receive an exclusive discount of 2 hours free storage, and you earn 15% commision",
  "GUEST_DROPOFF_ACCESS_INSTRUCTIONS": "Open the storage room with this code. Place your bags inside and close the door behind you.",
  "GUEST_DROPOFF_ANSWER_TO_CONTINUE": "Choose an answer above to continue",
  "GUEST_DROPOFF_PLACED_MY_BAGS": "I've placed my bags",
  "GUEST_EXPLANATION": "This customer is a guest who has stayed at your hotel",
  "GUEST_INSURANCE_ADD_TO_BE_COVERED": "You can add insurance here if you want to be covered.",
  "GUEST_INSURANCE_NOT_INSURED": "It is not insured during storage.",
  "GUEST_INSURANCE_QUESTION": "Do you want to insure your luggage?",
  "GUEST_INSURANCE_STORED_AT": "Your luggage is stored in a self-service luggage room at {{hotel}}.",
  "GUEST_MOVEMENT_OPTION": "Are you arriving or departing?",
  "GUYANA": "Guyana",
  "HAND_OVER_YOUR_LUGGAGE": "Hand over your luggage",
  "HAND_YOUR_BAGS_OVER_TO_THE_STAFF": "Hand your bags over to a member of the staff or place the bags as directed by the staff.",
  "HAS_WIFI": "Wi-Fi available",
  "HAVE_AN_ACCOUNT_QUESTION": "Have an account?",
  "HAVE_A_DISCOUNT_CODE": "Have a promo code?",
  "HAVE_A_VOUCHER_OR_PROMO_CODE": "Have a voucher or promo code?",
  "HAVE_A_VOUCHER_OR_PROMO_CODE_MINI": "Have a promo code?",
  "HELP_MORE_PEOPLE_FIND_THIS_SHOP": "Help more people find this shop",
  "HELP_MORE_TRAVELERS_DISCOVER_LUGGAGEHERO": "Help more travelers discover LuggageHero",
  "HELP_OTHERS_FIND_US": "Help other travelers find us!",
  "HELP_OTHER_TRAVELERS": "Help other travelers",
  "HELP_US_IMPROVE": "Help us improve",
  "HERE": "here",
  "HERO_CODE": "HeroCode",
  "HERO_CODE_MODAL_DESCRIPTION": "Always remember to make your LuggageHero customers scan this unique HeroCode with their phone before storing the bagage. This will insure that every storage session will run smoothly and enable all tracking and transactional automations.",
  "HERO_CODE_MODAL_INFOBOX_BUTTON_TEXT": "Make a Request",
  "HERO_CODE_MODAL_INFOBOX_TEXT": "Up your storage game with our free Starter Package. Stickers and more.",
  "HERO_CODE_MODAL_INFOBOX_TITLE": "Request a Free Starter Pack",
  "HERO_LEVEL_ELITE": "SuperHero",
  "HERO_LEVEL_PRO": "SuperHero",
  "HIDE_ACCESS_CODE": "Hide",
  "HIDE_PASSWORD": "Hide password",
  "HIDE_SUMMARY": "Hide",
  "HIGHLY_RATED": "Highly rated",
  "HIGH_DEMAND": "In high demand!",
  "HOLIDAY_BULK_ACTION_CLOSED": "All closed",
  "HOLIDAY_BULK_ACTION_OPEN_24_HOURS": "All open 24 hours",
  "HOLIDAY_BULK_ACTION_OPEN_AS_NORMAL": "All open as normal",
  "HOLIDAY_OPENING_HOURS": "Public holidays",
  "HOLIDAY_OPENING_HOURS_EXPLANATION_PART_1": "Indicate your opening hours on recurring public holidays below. These settings will be applied for all future occurrences of each holiday.",
  "HONEYMOON_BADGE_NO_DISCOUNT": "New on LuggageHero",
  "HONEYMOON_BADGE_WITH_DISCOUNT": "New on LuggageHero · save {{percentage}}%",
  "HONEYMOON_ORDER_LINE_TOOLTIP_BODY": "Discount applied because this is a new storage location on LuggageHero.",
  "HONEYMOON_REDUCE_RATES": "New storage location",
  "HONG_KONG": "Hong Kong",
  "HOSTEL": "Hostel",
  "HOTEL": "Hotel",
  "HOTELS_FILTER": "Hotels",
  "HOUR": "hour",
  "HOURS": "hours",
  "HOW_CAN_WE_IMPROVE": "How can we improve?",
  "HOW_DROP_OFF_WORKS_MODAL_EYEBROW": "Partner guide",
  "HOW_DROP_OFF_WORKS_MODAL_KEY_RULE_BOLD": "Every booking needs both taps.",
  "HOW_DROP_OFF_WORKS_MODAL_KEY_RULE_POST": " Check in at drop-off and out at pick-up, or the payment won't complete.",
  "HOW_DROP_OFF_WORKS_MODAL_LEAD_BOLD_IN": "in",
  "HOW_DROP_OFF_WORKS_MODAL_LEAD_BOLD_OUT": "out",
  "HOW_DROP_OFF_WORKS_MODAL_LEAD_MID": " when the bag arrives, and ",
  "HOW_DROP_OFF_WORKS_MODAL_LEAD_POST": " when it leaves. Everything in between, the storage timer and the payment, runs on its own.",
  "HOW_DROP_OFF_WORKS_MODAL_LEAD_PRE": "Check a booking ",
  "HOW_DROP_OFF_WORKS_MODAL_LEGEND_AUTO": "Happens automatically",
  "HOW_DROP_OFF_WORKS_MODAL_LEGEND_YOU": "You do this",
  "HOW_DROP_OFF_WORKS_MODAL_STEP1_BODY_BOLD": "their own phone",
  "HOW_DROP_OFF_WORKS_MODAL_STEP1_BODY_POST": " and checks in. No booking yet? Have them scan your HeroCode.",
  "HOW_DROP_OFF_WORKS_MODAL_STEP1_BODY_PRE": "The customer opens their booking on ",
  "HOW_DROP_OFF_WORKS_MODAL_STEP1_EYEBROW": "Drop-off · Check in",
  "HOW_DROP_OFF_WORKS_MODAL_STEP1_FOOTNOTE_BOLD": "HeroCode",
  "HOW_DROP_OFF_WORKS_MODAL_STEP1_FOOTNOTE_POST": " creates it.",
  "HOW_DROP_OFF_WORKS_MODAL_STEP1_FOOTNOTE_PRE": "No booking means a walk-in. The ",
  "HOW_DROP_OFF_WORKS_MODAL_STEP1_TITLE": "Check the booking in",
  "HOW_DROP_OFF_WORKS_MODAL_STEP2_BODY_BOLD": "push, SMS or email",
  "HOW_DROP_OFF_WORKS_MODAL_STEP2_BODY_POST": ", and the check-in appears in your Bookings view.",
  "HOW_DROP_OFF_WORKS_MODAL_STEP2_BODY_PRE": "You're notified by ",
  "HOW_DROP_OFF_WORKS_MODAL_STEP2_EYEBROW": "Confirmed",
  "HOW_DROP_OFF_WORKS_MODAL_STEP2_FOOTNOTE_BOLD": "logged",
  "HOW_DROP_OFF_WORKS_MODAL_STEP2_FOOTNOTE_POST": ", and the storage timer starts.",
  "HOW_DROP_OFF_WORKS_MODAL_STEP2_FOOTNOTE_PRE": "Bags are now ",
  "HOW_DROP_OFF_WORKS_MODAL_STEP2_TITLE": "You get the confirmation",
  "HOW_DROP_OFF_WORKS_MODAL_STEP3_BODY_BOLD": "their phone",
  "HOW_DROP_OFF_WORKS_MODAL_STEP3_BODY_POST": ", or scans your HeroCode again.",
  "HOW_DROP_OFF_WORKS_MODAL_STEP3_BODY_PRE": "On return, the customer checks out from ",
  "HOW_DROP_OFF_WORKS_MODAL_STEP3_EYEBROW": "Pick-up · Check out",
  "HOW_DROP_OFF_WORKS_MODAL_STEP3_FOOTNOTE_BOLD": "completes the payment",
  "HOW_DROP_OFF_WORKS_MODAL_STEP3_FOOTNOTE_POST": ". No cash to handle.",
  "HOW_DROP_OFF_WORKS_MODAL_STEP3_FOOTNOTE_PRE": "Check-out ",
  "HOW_DROP_OFF_WORKS_MODAL_STEP3_TITLE": "Check the booking out",
  "HOW_DROP_OFF_WORKS_MODAL_TITLE": "Two taps run the whole job",
  "HOW_IT_WORKS": "How it works",
  "HOW_IT_WORKS_EXPLANATION": "Luggage storage the easy way. Make a booking and go to the location to drop off your bags. Pick them back up whenever you want within the listed opening hours.",
  "HOW_IT_WORKS_NATIVE_INTRO_TAGLINE": "The LuggageHero app lets you find luggage storage when and where you need it",
  "HOW_IT_WORKS_TEXT": "The LuggageHero platform is self-service for the guest. All you need to do is set up the integration once as outlined in the steps below.",
  "HOW_MANY_BAGS_DROP_OFF": "Confirm how many bags you are storing",
  "HOW_MANY_BAGS_SHORT": "How many bags?",
  "HOW_WAS_YOUR_EXPERIENCE_WITH": "How was your experience with",
  "HUNGARY": "Hungary",
  "ICELAND": "Iceland",
  "ID": "ID",
  "IMAGES": "Images",
  "IMAGES_CAN_TAKE_TIME": "It can take several minutes after uploading completes before new images are ready and displayed correctly. Hit Finish once the files are transferred and check back later.",
  "IMAGE_REMOVED": "Image removed successfully",
  "IMPORTANT_COLON": "Important:",
  "IMPROVE_EXP": "Improve your guest experience and reduce friction",
  "IN": "in",
  "INCIDENT": "Incident",
  "INCIDENTS_INFO_PANEL_BODY": "Incidents are issues reported by travelers — most commonly: staff asked the traveler to pay directly, the location was closed on arrival, or staff were unaware of the LuggageHero service. Incidents affect where you rank on LuggageHero, and repeated unresolved incidents can lead to your listing being removed from the platform.",
  "INCIDENTS_INFO_PANEL_TITLE": "Incidents affect your ranking — and can lead to listing removal",
  "INCIDENT_ASKED_TO_PAY_DIRECTLY": "I was asked to pay directly to the store",
  "INCIDENT_DETAILS": "Incident Details",
  "INCIDENT_LOCATION_CLOSED_ON_ARRIVAL": "The location was closed when I arrived",
  "INCIDENT_LOCATION_REFUSED_BAGS": "The location refused to hold my bags",
  "INCIDENT_RATIO": "Incident Ratio",
  "INCIDENT_REPORT_NOTICE": "Your report will be shared with the business owner, and the storage location may be deactivated while we review the issue",
  "INCIDENT_REPORT_SUCCESS_BODY": "We have received your incident report. Please reach out to our support team via chat if you need any further assistance.",
  "INCIDENT_REPORT_SUCCESS_TITLE": "Thank you!",
  "INCIDENT_STAFF_UNAWARE_OF_SERVICE": "The staff was unaware of the service",
  "INCIDENT_TAKE_PICTURE_AND_MAKE_A_NOTE": "Please take a picture of the storefront and make a note about your experience.",
  "INCIDENT_TYPE_INCIDENT_ASKED_TO_PAY_DIRECTLY": "Asked to pay store",
  "INCIDENT_TYPE_INCIDENT_LOCATION_CLOSED_ON_ARRIVAL": "Closed on arrival",
  "INCIDENT_TYPE_INCIDENT_LOCATION_REFUSED_BAGS": "Refused bags",
  "INCIDENT_TYPE_INCIDENT_STAFF_UNAWARE_OF_SERVICE": "Staff unaware",
  "INCIDENT_TYPE_INCIDENT_UNABLE_TO_FIND_LOCATION": "Can't find location",
  "INCLUDED_IN_PRICE_SHORT": "Included",
  "INCLUDES": "Includes",
  "INCLUDES_SHORT": "Incl.",
  "INDONESIA": "Indonesia",
  "INFO": "Info",
  "INSTEAD_OF": "Instead of",
  "INSURANCE": "Insurance",
  "INSURANCE_COVERAGE": "Insurance coverage",
  "INSURANCE_FEE": "Insurance fee",
  "INVALID": "not valid",
  "INVALID_BANK_ACCOUNT_NUMBER": "Invalid account number",
  "INVALID_EMAIL": "Invalid email address",
  "INVALID_NAME": "Invalid name",
  "INVALID_PHONE_NUMBER": "Invalid phone number",
  "INVALID_PHONE_NUMBER_COUNTRY": "Invalid phone number. Make sure the country code is included (e.g. '+44 1234567890')",
  "INVITATION_PENDING": "Invitation pending",
  "INVITE": "Invite",
  "INVITE_MEMBER_FAILURE": "Failed to invite member",
  "INVITE_NEW_MEMBER": "Invite new member",
  "INVOICE": "Invoice",
  "INVOICE_DATE": "Invoice date",
  "INVOICE_NUMBER": "Invoice no.",
  "INVOICE_V2_BALANCE_CARRIED_OVER": "This balance will be carried over to your next invoice",
  "INVOICE_V2_BALANCE_HEADING": "You are owed",
  "INVOICE_V2_BALANCE_IN_YOUR_FAVOR": "Balance in your favor",
  "INVOICE_V2_BALANCE_OWED": "Balance owed to LuggageHero",
  "INVOICE_V2_BILL_TO": "Billed to",
  "INVOICE_V2_COMMISSION": "Commission",
  "INVOICE_V2_DATE_LABEL": "Invoice date",
  "INVOICE_V2_FEES_HEADING": "Fees for facilitating sales:",
  "INVOICE_V2_FUNDS_AVAILABLE_ON": "The funds will be available on {{ date }}",
  "INVOICE_V2_IN_SHOP_TIPS": "In-shop tips",
  "INVOICE_V2_LUGGAGEHERO_FEES": "LuggageHero fees",
  "INVOICE_V2_LUGGAGEHERO_FEES_INCL_VAT": "LuggageHero fees (incl. VAT)",
  "INVOICE_V2_MINIMUM_REVENUE_GUARANTEE": "Minimum revenue guarantee",
  "INVOICE_V2_NUMBER_LABEL": "Invoice no.",
  "INVOICE_V2_PERIOD_LINE": "In the period {{ period }}",
  "INVOICE_V2_PREVIOUS_BALANCE": "Previous balance",
  "INVOICE_V2_RECEIVED_DIRECTLY": "Paid directly to you",
  "INVOICE_V2_SALES_SUMMARY": "Total sales of {{ amount }} on behalf of your customers",
  "INVOICE_V2_SALES_SUMMARY_WITH_TIPS": "Total sales of {{ amount }} and {{ tips }} tips on behalf of your customers",
  "INVOICE_V2_SERVICE_FEES": "Service fees",
  "INVOICE_V2_TITLE": "Invoice",
  "INVOICE_V2_TOTAL": "Total",
  "INVOICE_V2_TOTAL_EXCL_VAT": "Total (excl. VAT)",
  "INVOICE_V2_TOTAL_INCL_VAT": "Total (incl. VAT)",
  "INVOICE_V2_TOTAL_SALES": "Total sales collected by LuggageHero",
  "INVOICE_V2_TOTAL_TIPS": "Total tips earned",
  "INVOICE_V2_UNDEDUCTED_TAX": "Undeducted tax",
  "INVOICE_V2_VAT": "VAT ({{ percent }})",
  "INVOICE_V2_VAT_NUMBER_LABEL": "VAT number",
  "IN_SHOP_TIPS": "Tips already received",
  "IN_STORE_DISPLAY": "In-store display",
  "IRELAND": "Ireland",
  "ISRAEL": "Israel",
  "IS_NOT_VALID": "is not valid",
  "ITALY": "Italy",
  "ITEMS": "Items",
  "JAMAICA": "Jamaica",
  "JAPAN": "Japan",
  "JORDAN": "Jordan",
  "KAZAKHSTAN": "Kazakhstan",
  "KEEPS_TRACK_OF_HOW_LONG_YOU_STORE": "Keeps track of how long you store your bags",
  "KENYA": "Kenya",
  "KEYCARD": "Keycard",
  "KEY_CARD_GENERIC_EXPLANATION": "Use your issued key card",
  "KNOW_MORE": "Want to know more, or need help setting up the integration?",
  "KUWAIT": "Kuwait",
  "LANDING_PAGES_DESCRIPTION": "Every published storage location landing page.",
  "LANDING_PAGES_TITLE": "Store landing pages",
  "LANDING_PAGE_CURATIONS_ADD_SHOP_LABEL": "Add a storage location",
  "LANDING_PAGE_CURATIONS_ADD_SHOP_PLACEHOLDER": "Search by name",
  "LANDING_PAGE_CURATIONS_ALREADY_ADDED": "Already added",
  "LANDING_PAGE_CURATIONS_BACK": "Back to top locations",
  "LANDING_PAGE_CURATIONS_CANCEL": "Cancel",
  "LANDING_PAGE_CURATIONS_DELETE": "Delete curation",
  "LANDING_PAGE_CURATIONS_DELETED": "Curation deleted",
  "LANDING_PAGE_CURATIONS_DELETE_CONFIRM": "Delete this curation?",
  "LANDING_PAGE_CURATIONS_DELETE_CONFIRM_NO": "Cancel",
  "LANDING_PAGE_CURATIONS_DELETE_CONFIRM_YES": "Yes, delete",
  "LANDING_PAGE_CURATIONS_DELETE_ERROR": "Could not delete the curation. Please try again.",
  "LANDING_PAGE_CURATIONS_DESCRIPTION": "Choose and order the storage locations shown on each landing page.",
  "LANDING_PAGE_CURATIONS_DRAG_HANDLE": "Drag to reorder",
  "LANDING_PAGE_CURATIONS_DUPLICATE_PATH": "A curation already exists for this URL path.",
  "LANDING_PAGE_CURATIONS_EDIT_TITLE": "Edit curation",
  "LANDING_PAGE_CURATIONS_EMPTY": "No landing pages curated yet",
  "LANDING_PAGE_CURATIONS_HAS_MISSING": "Some locations are no longer available and will not be shown.",
  "LANDING_PAGE_CURATIONS_LIST_EMPTY": "No locations added yet. Search above to add the first.",
  "LANDING_PAGE_CURATIONS_LIST_LABEL": "Locations in display order",
  "LANDING_PAGE_CURATIONS_LOADING": "Loading…",
  "LANDING_PAGE_CURATIONS_LOAD_ERROR": "Could not load curations. Please try again.",
  "LANDING_PAGE_CURATIONS_LOCATION_COUNT": "{{count}} locations",
  "LANDING_PAGE_CURATIONS_LOCATION_COUNT_ONE": "{{count}} location",
  "LANDING_PAGE_CURATIONS_MISSING_SHOP": "No longer available",
  "LANDING_PAGE_CURATIONS_MOVE_DOWN": "Move down",
  "LANDING_PAGE_CURATIONS_MOVE_UP": "Move up",
  "LANDING_PAGE_CURATIONS_NEW": "New curation",
  "LANDING_PAGE_CURATIONS_NEW_TITLE": "New curation",
  "LANDING_PAGE_CURATIONS_NO_MATCH": "No landing pages match your search",
  "LANDING_PAGE_CURATIONS_NO_SHOP_MATCH": "No storage locations match",
  "LANDING_PAGE_CURATIONS_PATH_HINT": "The URL path of the landing page, starting with a slash.",
  "LANDING_PAGE_CURATIONS_PATH_INVALID": "Enter a valid URL path, e.g. /london.",
  "LANDING_PAGE_CURATIONS_PATH_LABEL": "Landing page URL path",
  "LANDING_PAGE_CURATIONS_PATH_PLACEHOLDER": "/london or /london/victoria-station",
  "LANDING_PAGE_CURATIONS_REMOVE": "Remove",
  "LANDING_PAGE_CURATIONS_SAVE": "Save",
  "LANDING_PAGE_CURATIONS_SAVED": "Curation saved",
  "LANDING_PAGE_CURATIONS_SAVE_ERROR": "Could not save. Please try again.",
  "LANDING_PAGE_CURATIONS_SEARCH": "Search by URL path",
  "LANDING_PAGE_CURATIONS_STALE_EDIT": "Someone else changed this curation. Please reload and try again.",
  "LANDING_PAGE_CURATIONS_TITLE": "Top locations per landing page",
  "LANGUAGE": "Preferred Language",
  "LAOS": "Laos",
  "LAST": "Last",
  "LAST_NAME": "Last name",
  "LATE_CANCELLATIONS": "Late cancellations",
  "LATVIA": "Latvia",
  "LEARN_MORE": "Learn more",
  "LEAVE_A_REVIEW": "Leave a review",
  "LEAVE_FEEDBACK": "Leave feedback",
  "LEAVE_GOOGLE_REVIEW": "Leave Google review",
  "LEAVE_TRUSTPILOT_REVIEW": "Review on Trustpilot",
  "LESS": "Less",
  "LET_US_DO_THE_REST": "Let us do the rest",
  "LET_US_DO_THE_REST_TEXT": "Your bookings are automatically tagged by LuggageHero if there are relevant storage options available",
  "LIECHTENSTEIN": "Liechtenstein",
  "LINK_COPIED": "Link copied!",
  "LISBON": "Lisbon",
  "LIST_VIEW": "List view",
  "LITHUANIA": "Lithuania",
  "LIVE_SCREEN_MUST_BE_PRESENTED_TO_STAFF": "Live screen must be presented to staff",
  "LOADING": "Loading...",
  "LOADING_DASHBOARD_DATA": "Loading dashboard data...",
  "LOADING_SHOPS_MESSAGE": "Hold on, we are finding local heroes for you...",
  "LOADING_STORAGE_LOCATIONS": "Loading storage locations",
  "LOAD_MORE_REVIEWS": "Load more reviews...",
  "LOAD_MORE_SHOPS": "Load more...",
  "LOCAL_BUSINESS": "Local Business",
  "LOCATION": "Location",
  "LOCATIONS": "Locations",
  "LOCATIONS_FOUND": "Locations found",
  "LOCATION_ALREADY_HAS_A_LIVE_LISTING": "Already has a live listing",
  "LOCATION_NAME": "Location name",
  "LOCATION_NOT_AVAILABLE": "The storage location is not available to store your bags on the selected dates. Change the dates or choose another location.",
  "LOCATION_NOT_AVAILABLE_WITH_YOUR_SELECTION": "Location not available with your selection",
  "LOCATION_SEARCH_FAILED": "The location search failed. Try again.",
  "LOCKERS": "Lockers",
  "LOGIN_ERROR_MESSAGE": "Login could not be completed. Please check your connection and try again.",
  "LOGIN_ERROR_TITLE": "Login failed",
  "LOG_IN": "Log in",
  "LOG_IN_WITH_EMAIL": "Log in",
  "LOG_OUT": "Log out",
  "LONDON": "London",
  "LOOKING_FOR_BOOKING": "Looking for your booking?",
  "LOOKING_FOR_SHOP_TRANSACTIONS": "Looking for shop transactions?",
  "LUGGAGEHERO_BOOKING_AT_LOCATION": "LuggageHero booking at",
  "LUGGAGEHERO_PAYMENT_VERIFICATION_LABEL": "LuggageHero Payment Verification",
  "LUGGAGE_STORAGE": "Luggage storage",
  "LUGGAGE_STORAGE_AT": "Luggage storage at",
  "LUGGAGE_STORAGE_IN_A_NEW_WAY": "Luggage storage in a new and safe way",
  "LUGGAGE_STORAGE_ON_DEMAND": "Luggage storage on-demand",
  "LUXEMBOURG": "Luxembourg",
  "MACAU": "Macau",
  "MADAGASCAR": "Madagascar",
  "MADRID": "Madrid",
  "MAKE_ANOTHER_BOOKING": "Make another booking",
  "MAKE_A_BOOKING": "Make a booking",
  "MAKE_NOTE_AND_REPORT": "Please make a note about your experience and submit the report",
  "MAKE_SURE_CONTACT_INFO_IS_UP_TO_DATE": "Make sure your contact information is accurate, so we can reach you regarding your bookings",
  "MAKE_SURE_TAG_NUMBERS_VISIBLE": "Make sure the number on each security seal is visible in the photo",
  "MALAYSIA": "Malaysia",
  "MALTA": "Malta",
  "MAP_VIEW": "Map view",
  "MARKETPLACE": "Marketplace",
  "MARKETPLACE_TAB_TITLE": "Marketplace",
  "MAURITIUS": "Mauritius",
  "MAXIMUM_EARNING_RATE_UNLOCKED": "Max. earning rate unlocked",
  "MAX_DISTANCE_FROM_ADDRESS": "Maximum distance from address",
  "MAX_IMAGE_SIZE": "Max file size: 5 megabytes (MB)",
  "MAYBE_LATER": "Maybe later",
  "MEXICO": "Mexico",
  "MIGHT_AFFECT_THESE_HOURS": "might affect these hours",
  "MINIMUM_BAG_GUARANTEE": "Minimum bag guarantee",
  "MINIMUM_X_HOURS_PREFIX": "Your location must be open at least",
  "MINIMUM_X_HOURS_SUFFIX": "hours per week",
  "MIN_15_CHARACTERS": "Min. 15 characters",
  "MISSING_INFORMATION": "Missing information",
  "MISSING_TIP_CHOICE_ALERT": "Please choose a tipping option",
  "MODAL_ACCOUNT_CONNECTED": "Account connected",
  "MODAL_MSG_FAIL_KEY": "The API key didn't work. Are you sure you got it right?",
  "MODIFY_BOOKING_CTA": "Modify booking",
  "MODIFY_BOOKING_INSTEAD": "Want to change something instead?",
  "MODIFY_BOOKING_SHORT": "Modify",
  "MOLDOVA": "Moldova",
  "MONACO": "Monaco",
  "MONDAY": "Monday",
  "MONGOLIA": "Mongolia",
  "MONTREAL": "Montreal",
  "MORE": "More",
  "MORE_BAGS": "More bags",
  "MORE_INFO": "More info",
  "MORE_REASONS": "Show more reasons",
  "MOROCCO": "Morocco",
  "MOST_POPULAR": "Most popular",
  "MOZAMBIQUE": "Mozambique",
  "MULTI_BAG_REDUCE_STORAGE_RATES": "Volume discount",
  "MULTI_DAY_BOOKING_EXPLANATION": "The customer booked for multiple days",
  "MULTI_DAY_DISCOUNT": "Multi-day discount",
  "MULTI_DAY_REDUCE_STORAGE_RATES": "Multi-day discount",
  "MULTI_DAY_STORAGE_FILTER": "Multi-day storage",
  "MY_BOOKINGS": "My bookings",
  "MY_LOCATION": "My location",
  "NAME": "Name",
  "NAME_INPUT_PLACEHOLDER": "Enter your name",
  "NAME_IS_REQUIRED": "Name is required",
  "NAME_OPTIONAL": "Name (optional)",
  "NAME_REQUIRED_ERROR": "Name is required",
  "NAMIBIA": "Namibia",
  "NATIVE_APP_PROMO_CARD_HEADLINE": "Get the LuggageHero Dashboard app",
  "NATIVE_APP_PROMO_DESCRIPTION": "Run your storage from the floor, not the back office.",
  "NATIVE_APP_PROMO_DISMISS": "Dismiss",
  "NATIVE_APP_PROMO_OPEN": "Open",
  "NATIVE_APP_PROMO_SCAN_HINT": "Scan with your phone to install",
  "NATIVE_APP_PROMO_TITLE": "LuggageHero Dashboard",
  "NAV_ACCOUNT": "Account",
  "NAV_BOOKINGS": "Bookings",
  "NAV_BUSINESS_PROFILES": "Business profiles",
  "NAV_CLOSE_MENU": "Close the menu",
  "NAV_COLLAPSE_SIDEBAR": "Collapse the menu",
  "NAV_CREATE_USER": "Create user",
  "NAV_GROUP_ACCOUNT": "Account",
  "NAV_GROUP_LOCATION": "Location",
  "NAV_GROUP_OPERATIONS": "Operations",
  "NAV_HELP": "Help",
  "NAV_HOME": "Home",
  "NAV_INCIDENTS": "Incidents",
  "NAV_LANDING_PAGES": "Landing pages",
  "NAV_LANDING_PAGE_CURATIONS": "Top locations",
  "NAV_LOCATIONS": "Locations",
  "NAV_MENU_SUBTITLE": "Access all features and settings",
  "NAV_MENU_TITLE": "Navigation menu",
  "NAV_ORGANIZATION": "Organization",
  "NAV_ORGANIZATIONS": "Organizations",
  "NAV_ORGANIZATION_SETTINGS": "Organization",
  "NAV_PAYOUT": "Payout",
  "NAV_PERFORMANCE": "Performance",
  "NAV_PROFILE": "Profile",
  "NAV_REVIEWS": "Reviews",
  "NAV_SETTINGS": "Settings",
  "NAV_SIGNAGE": "Signage",
  "NAV_SUPERHERO": "SuperHero",
  "NAV_TRANSLATIONS": "Translations",
  "NEARBY": "Nearby",
  "NEAREST_TO": "Nearest to",
  "NEED_HELP": "Need help?",
  "NETHERLANDS": "Netherlands",
  "NEVER_MORE_THAN": "and never more than",
  "NEW": "New",
  "NEW_PASSWORD": "New password",
  "NEW_PAYMENT_CARD": "New payment card",
  "NEW_PAYMENT_METHOD": "New payment method",
  "NEW_REVENUE_STREAM": "New Revenue Stream",
  "NEW_STORAGE_LOCATION": "New storage location",
  "NEW_VERSION_AVAILABLE": "New version available!",
  "NEW_YORK_CITY": "New York City",
  "NEW_ZEALAND": "New Zealand",
  "NEXT": "Next",
  "NEXT_OCCURRENCE": "Next occurrence:",
  "NEXT_PAYOUT": "Next payout",
  "NEXT_PAYOUT_PERIOD_SUMMARY": "For {{period}} · {{count}} bookings",
  "NEXT_STEP": "Next step",
  "NIGER": "Niger",
  "NIGERIA": "Nigeria",
  "NO": "No",
  "NONE": "None",
  "NORTH_MACEDONIA": "North Macedonia",
  "NORWAY": "Norway",
  "NOTIFICATIONS_CONTACT": "Primary contact name",
  "NOTIFICATIONS_CONTACT_IS_REQUIRED": "Please enter the name of the primary contact person for the shop",
  "NOTIFICATIONS_EMAIL_IS_REQUIRED": "Provide at least one email address that will receive booking related notifications",
  "NOTIFICATION_BOOKING_CONFIRMATION": "Booking confirmation",
  "NOTIFICATION_CHECK_IN_CONFIRMATION": "Check-in confirmation",
  "NOTIFICATION_CHECK_OUT_CONFIRMATION": "Check-out confirmation",
  "NOTIFICATION_ONLINE_PAYMENT_FAILED": "Online Payment Failed",
  "NOTIFICATION_ONLINE_PAYMENT_SUCCESSFUL": "Online Payment Successful",
  "NOTIFICATION_PREFERENCES": "Notification preferences",
  "NOT_MODIFIED_TOOLTIP": "You haven't made any changes to the booking",
  "NOT_RELEVANT_QUESTION": "Not relevant for you?",
  "NO_ACCOUNT_YET": "Don't have an account yet?",
  "NO_ACTIVE_BOOKINGS": "No active bookings",
  "NO_ACTIVE_INCIDENTS": "No active incidents",
  "NO_BOOKINGS": "No bookings",
  "NO_BOOKINGS_FOUND": "No bookings found",
  "NO_BOOKING_FOUND": "No booking found",
  "NO_BUSINESS_PROFILES_MATCH_YOUR_SEARCH": "No business profiles match your search",
  "NO_CAMERA_ACCESS_WARNING": "Oops! It looks like we are unable to use the camera on your device. Make sure you have granted permission in your browser or device settings and then try again.",
  "NO_CANCELED_BOOKINGS": "No canceled bookings",
  "NO_CHARGE": "No charge",
  "NO_CHARGE_YET": "You will not be charged yet",
  "NO_COMPLETED_BOOKINGS": "No completed bookings",
  "NO_COVERAGE": "No coverage",
  "NO_COVERAGE_SELECTED": "No coverage selected",
  "NO_EMAIL_RECEIPT_CONFIRMATION": "You will not receive a receipt when you don't provide an email address",
  "NO_EXCEPTIONS_CONFIGURED": "No exceptional opening hours configured yet",
  "NO_HOLIDAYS_AVAILABLE": "No holidays available",
  "NO_INCIDENTS_FOUND": "No incidents found",
  "NO_INCIDENTS_REPORTED": "Has reported no incidents",
  "NO_LANDING_PAGES_MATCH_YOUR_SEARCH": "No landing pages match your search",
  "NO_LIABILITY_WITHOUT_COVERAGE": "The hotel is not liable for your belongings while in storage",
  "NO_LIABILITY_WITHOUT_COVERAGE_STORAGE_LOCATION": "The storage location is not liable for your belongings while in storage",
  "NO_NAME_SET": "No name set",
  "NO_ORGANIZATIONS": "No organizations",
  "NO_ORGANIZATIONS_MESSAGE": "No organizations found",
  "NO_ORGANIZATION_SELECTED": "No organization selected",
  "NO_OVERNIGHT_STORAGE": "No overnight or multi-day storage",
  "NO_PAYMENT_AT_THIS_STEP": "No payment will be made now.",
  "NO_PAYMENT_METHODS": "You have no payment methods saved in your account.",
  "NO_PAYMENT_METHOD_SELECTED": "No payment method selected",
  "NO_PAYOUT_METHODS_DESC": "Connect your bank account via Stripe to start receiving payouts.",
  "NO_PAYOUT_METHODS_TITLE": "No payout methods configured",
  "NO_RESULTS": "No results",
  "NO_REVIEWS_FOUND": "Once customers leave reviews, they will appear here.",
  "NO_REVIEWS_YET": "No reviews yet",
  "NO_SHOPS_FOUND": "No shops found in the selected area",
  "NO_SHOW_FEE_EXPLANATION": "If you don't cancel and you don't show up, you will be charged a no-show fee equivalent to one full day of storage.",
  "NO_SHOW_FEE_ONE_DAY_STORAGE": "No-show fee: One full day of storage",
  "NO_STORAGE_LOCATIONS_FOUND": "No storage locations found",
  "NO_STORAGE_LOCATIONS_MATCH_YOUR_SEARCH": "No storage locations match your search",
  "NO_STORAGE_LOCATIONS_NEAR_THIS_LISTING": "No storage locations found near this listing. Paste a location ID to reach one further away.",
  "NO_TAX_ADDED_YET": "No tax settings added yet.",
  "NO_THANKS": "No thanks",
  "NO_THANKS_RATING_IS_ENOUGH": "No thanks, rating is enough",
  "NO_UPCOMING_BOOKINGS": "No upcoming bookings",
  "NO_VAT_NUMBER": "I don't have a VAT number",
  "NO_WIFI": "No Wi-Fi",
  "NO_WIFI_AT_THIS_SHOP": "No Wi-Fi",
  "NO_WIFI_AT_THIS_SHOP_EXPLANATION": "Use your own mobile data connection to check in from your smartphone when you arrive at the shop.",
  "NO_WIFI_AT_THIS_SHOP_TOOLTIP": "You must have a working data plan on your phone to be able to drop your luggage off here.",
  "NUMBER_MUST_BE_READABLE_IN_PICTURE": "The number must be readable in the picture",
  "NUMBER_OF_BAGS": "Number of bags",
  "NUMBER_OF_ROOMS": "Number of rooms",
  "OFFER_FILTER": "Offers",
  "OFF_THE_FINAL_STORAGE_PRICE": "off the final storage price",
  "OF_TOTAL_SALES": "of total sales",
  "OK_BUTTON": "OK",
  "OK_GOT_IT": "OK, got it",
  "OK_I_HAVE_SEALS": "OK, I have the security seals",
  "OLD_PASSWORD": "Old password",
  "OMAN": "Oman",
  "ONBOARDING_GUIDE_BANNER_CTA": "Download the guide",
  "ONBOARDING_GUIDE_BANNER_DESCRIPTION": "The onboarding guide walks you through how it works — taking bags in, keeping them safe, handing them back and getting paid. Ten minutes now, and your whole team knows the routine.",
  "ONBOARDING_GUIDE_BANNER_EYEBROW": "Getting started",
  "ONBOARDING_GUIDE_BANNER_FILE_HINT": "PDF · opens in a new tab",
  "ONBOARDING_GUIDE_BANNER_FILE_HINT_NATIVE": "PDF · save it or open it in another app",
  "ONBOARDING_GUIDE_BANNER_HEADLINE": "Up and running in 10 minutes",
  "ONBOARDING_GUIDE_BANNER_INTRO": "Ten minutes now, and your whole team knows the routine.",
  "ONBOARDING_GUIDE_BANNER_OPEN_FAILED": "We could not open the guide. Please try again.",
  "ONBOARDING_GUIDE_BANNER_STEP_GET_PAID": "Get paid",
  "ONBOARDING_GUIDE_BANNER_STEP_HAND_BACK": "Hand them back",
  "ONBOARDING_GUIDE_BANNER_STEP_KEEP_SAFE": "Keep them safe",
  "ONBOARDING_GUIDE_BANNER_STEP_TAKE_IN": "Take bags in",
  "ONBOARDING_GUIDE_BANNER_TITLE": "How storage works, start to finish",
  "ONLINE_BOOKING_REQUIRED_USP_DESCRIPTION": "This store does not accept cash or walk-ins. Free cancellation at any time. Book now, pay later.",
  "ONLINE_BOOKING_REQUIRED_USP_DESCRIPTION_DEADLINE": "This storage location does not accept cash or walk-ins. Free cancellation until {{time}} on your drop-off day. Book now, pay later.",
  "ONLINE_BOOKING_REQUIRED_USP_DESCRIPTION_NO_DEADLINE": "This storage location does not accept cash or walk-ins. Book now, pay later.",
  "ONLINE_BOOKING_REQUIRED_USP_TITLE": "Online booking required",
  "ONLINE_PRESENCE": "Online presence",
  "ONLY_AVAILABLE_SHOPS": "Only show shops that are open and have space available at the selected time",
  "ONLY_INSURED_WHILE_TIMER_RUNNING": "NOTE: Your bags are only insured while the timer is running.",
  "ONLY_PAY_FOR_THE_TIME_SPENT": "Only pay for the time spent",
  "ONLY_SHOPS_WITH_WIFI": "Only show shops that offer Wi-Fi",
  "ON_DATE": "On",
  "ON_MOST_POPULAR_ACTIVITIES_IN_CITY": "on the most popular things to do in",
  "ON_PLATFORM": "on",
  "ON_SOURCE": "on",
  "OPEN": "Open",
  "OPENING_HOURS": "Opening hours",
  "OPENING_HOURS_24_HOURS": "24 hours",
  "OPENING_HOURS_ADD_HOURS": "Add hours",
  "OPENING_HOURS_ADD_SLOT": "Add time slot",
  "OPENING_HOURS_CHECK": "Check hours",
  "OPENING_HOURS_CLOSED_NOTE": "No drop-offs or pick-ups",
  "OPENING_HOURS_CLOSES": "Closes",
  "OPENING_HOURS_COPY_MONDAY": "Use Monday's hours for all days",
  "OPENING_HOURS_ERROR_FORMAT": "Use HH:MM",
  "OPENING_HOURS_ERROR_ORDER": "Closing must be after opening",
  "OPENING_HOURS_ERROR_OVERLAP": "Overlaps the slot above",
  "OPENING_HOURS_FIX_BEFORE_CLOSE": "Fix the hours above before closing",
  "OPENING_HOURS_GOOGLE_NOTICE_BODY": "Check each day before you continue.",
  "OPENING_HOURS_GOOGLE_NOTICE_TITLE": "Filled in from Google Maps.",
  "OPENING_HOURS_OPENS": "Opens",
  "OPENING_HOURS_REMOVE_SLOT": "Remove time slot",
  "OPENING_HOURS_TO": "to",
  "OPENING_HOURS_UPDATE_LATER": "No opening hours were found on Google for this location. You can set them now or update them later from the location settings.",
  "OPENING_HOURS_USE_FOR_ALL": "Use these hours for all days",
  "OPENING_HOURS_WEEKLY": "Weekly hours",
  "OPENING_SOON": "Opening soon",
  "OPENS": "Opens",
  "OPEN_24_HOURS": "Open 24 hours",
  "OPEN_AS_NORMAL": "Open as normal",
  "OPEN_LATE": "Open late",
  "OPTIONAL": "Optional",
  "OPTIONS": "Options",
  "OR": "or",
  "ORDER_SIGNAGE": "Hero Code",
  "ORDER_SIGNAGE_ADMIN_ONLY": "Admin only",
  "ORDER_SIGNAGE_BY": "by",
  "ORDER_SIGNAGE_CANCELLED": "Cancelled",
  "ORDER_SIGNAGE_CONFIRM_TITLE": "Confirm Order",
  "ORDER_SIGNAGE_DELETE": "Delete",
  "ORDER_SIGNAGE_DELETE_CONFIRM": "Delete",
  "ORDER_SIGNAGE_DELETE_CONFIRM_MESSAGE": "Are you sure you want to delete this order? This action cannot be undone.",
  "ORDER_SIGNAGE_DELETE_CONFIRM_TITLE": "Delete Order",
  "ORDER_SIGNAGE_DELETE_SUCCESS": "Order deleted successfully",
  "ORDER_SIGNAGE_DELIVERY_ADDRESS": "Delivery Address",
  "ORDER_SIGNAGE_EDIT": "Edit",
  "ORDER_SIGNAGE_ESTIMATED_DELIVERY": "Estimated Delivery Date",
  "ORDER_SIGNAGE_HISTORY": "Order History",
  "ORDER_SIGNAGE_HISTORY_COUNT": "order(s).",
  "ORDER_SIGNAGE_HISTORY_SORTED": "Sorted newest first.",
  "ORDER_SIGNAGE_MARKETING_MATERIAL": "Marketing Material",
  "ORDER_SIGNAGE_NOTES": "Notes",
  "ORDER_SIGNAGE_NO_ORDERS": "No orders yet",
  "ORDER_SIGNAGE_ORDER": "Order",
  "ORDER_SIGNAGE_PLACED_AT": "Placed",
  "ORDER_SIGNAGE_PLACED_BY": "Placed by",
  "ORDER_SIGNAGE_PRODUCT": "Product",
  "ORDER_SIGNAGE_PRODUCTS": "Products",
  "ORDER_SIGNAGE_QUANTITY": "Quantity",
  "ORDER_SIGNAGE_STATUS": "Status",
  "ORDER_SIGNAGE_SUCCESS": "Order placed successfully",
  "ORDER_SIGNAGE_UPDATE_SUCCESS": "Order updated successfully",
  "ORDER_SIGNAGE_WELCOME_BOX": "Welcome Box",
  "ORDER_SIGNAGE_WELCOME_BOX_PRODUCT_DESC": "All items included",
  "ORGANIZATION_NAME": "Organization Name",
  "ORGANIZATION_OWNER_MUST_ACCEPT_TERMS_OF_SERVICE": "The organization owner must accept the terms of service",
  "OR_CONNECT_WITH": "Or connect with",
  "OTHERWISE_MAKE_NOTE_AND_REPORT": "Otherwise, please make a note about your experience and submit the report",
  "OTHER_STORAGE_OPTIONS_EXPLANATION": "If this place doesn't suit your needs, check out our many other storage locations.",
  "OTHER_TIP_AMOUNT": "Other",
  "OUR_BOOKINGS_ARE_FLEXIBLE": "Our bookings are flexible",
  "OVERNIGHT_STORAGE": "Overnight and multi-day storage allowed",
  "OWNER_PHONE_NOT_VERIFIED": "Owner's phone is not verified",
  "PAID": "Paid",
  "PAID_DIRECTLY_TO_YOU": "paid directly to you",
  "PAID_VIA_LUGGAGGEHERO": "paid via luggagehero.com",
  "PAKISTAN": "Pakistan",
  "PANAMA": "Panama",
  "PARAGUAY": "Paraguay",
  "PARIS": "Paris",
  "PARTNERS_RECEIVE_ALL_TIPS": "Our storage partners receive 100% of tips they earn",
  "PASSWORD": "Password",
  "PASSWORDS_DO_NOT_MATCH": "Passwords do not match",
  "PASSWORD_CHANGED_SUCCESSFULLY": "Password changed successfully",
  "PASSWORD_COMPLEXITY_ERROR": "Password must contain at least one uppercase letter, one lowercase letter, one number, and one special character",
  "PASSWORD_INPUT_PLACEHOLDER": "Enter your password",
  "PASSWORD_MIN_LENGTH_ERROR": "Password must contain at least 8 characters",
  "PASSWORD_REQUIRED": "Enter your password to log in",
  "PASSWORD_REQUIRED_ERROR": "Password is required",
  "PASTE_GUESTY_KEY": "Paste your Guesty API key",
  "PASTE_SMOOBU_KEY": "Paste your Smoobu API key",
  "PAYING_IN_THE_SHOP": "Paying in the shop",
  "PAYMENT": "Payment",
  "PAYMENT_CARD": "Payment card",
  "PAYMENT_CARD_ADDED": "Payment card added",
  "PAYMENT_CHARGED_AUTOMATICALLY": "Payment will be charged to your card automatically when you check out",
  "PAYMENT_FAILED": "Payment failed",
  "PAYMENT_FAILED_PART_1": "We were unable to charge the final price of",
  "PAYMENT_FAILED_PART_2": "to your card. You can retry the payment below.",
  "PAYMENT_METHOD": "Payment method",
  "PAYMENT_METHOD_BEFORE_DIRECTIONS_ALERT": "You need to add a payment method before you can get directions",
  "PAYMENT_METHOD_BEFORE_START_TIMER_ALERT": "You need to add a payment method before you can start the timer",
  "PAYMENT_METHOD_DIRECT": "Paid in shop",
  "PAYMENT_METHOD_MISSING": "Payment method missing",
  "PAYMENT_METHOD_READY": "You are all set and ready for check-in when you are at the shop",
  "PAYMENT_METHOD_REQUIRED": "Payment info required",
  "PAYMENT_METHOD_SELECTED": "Payment method selected",
  "PAYMENT_OPTIONS": "Payment options",
  "PAYMENT_SUCCEEDED": "Payment succeeded",
  "PAYMENT_VERIFICATION_FOOTNOTE": "We reserve a small amount now to verify your card. Final price will be charged upon pickup.",
  "PAYOUT": "Balance transferred via Stripe",
  "PAYOUTS_NO_LOCATIONS_DESC": "There are no payouts because no storage locations were found for this organization.",
  "PAYOUTS_NO_LOCATIONS_TITLE": "No payouts available",
  "PAYOUTS_NO_PAYOUTS_DESC": "Once payouts are generated, they will appear here.",
  "PAYOUTS_NO_PAYOUTS_TITLE": "No payouts yet",
  "PAYOUTS_NO_SHOW_SUBTITLE": "No-show — no payout",
  "PAYOUTS_OVERVIEW": "Payouts Overview",
  "PAYOUT_INVOICE_AMOUNT_OWED_FOR_SERVICE": "Amount owed to LuggageHero",
  "PAYOUT_INVOICE_AMOUNT_RECEIVABLE": "Due from LuggageHero",
  "PAYOUT_INVOICE_AMOUNT_RECEIVED_DIRECTLY": "Amount received directly",
  "PAYOUT_INVOICE_COMMISSION": "Commission",
  "PAYOUT_INVOICE_EXCL_VAT": "excl. VAT",
  "PAYOUT_INVOICE_FEES_PLUS_VAT": "(LuggageHero fees + VAT)",
  "PAYOUT_INVOICE_FINAL_BALANCE_DUE": "Balance in your favor",
  "PAYOUT_INVOICE_IN_THE_PERIOD": "in the period",
  "PAYOUT_INVOICE_ON_BEHALF_OF_YOUR_CUSTOMERS": "on behalf of your customers",
  "PAYOUT_INVOICE_PREVIOUS_BALANCE": "Balance from previous period",
  "PAYOUT_INVOICE_SERVICE_FEE_VAT": "VAT",
  "PAYOUT_INVOICE_TOTAL": "Total",
  "PAYOUT_INVOICE_TOTAL_SALES": "Total sales on behalf of your customers in the same period",
  "PAYOUT_METHOD": "Payout Method",
  "PAYOUT_SERVICE_FEE": "Service fee",
  "PAYOUT_TAB_TITLE": "Payout",
  "PAYOUT_UNDEDUCTED_TAX": "Undeducted tax",
  "PAYOUT_WALLET": "Wallet",
  "PAYPAL_WINDOW_NOT_OPENED": "We couldn't complete your payment with PayPal. Please use a different payment method.",
  "PAY_AS_YOU_GO": "Pay as you go",
  "PAY_AS_YOU_GO_DASH": "Pay-as-you-go",
  "PAY_AS_YOU_GO_EXPLANATION": "Hourly pricing for short term storage",
  "PAY_BY_THE_HOUR": "Pay by the hour",
  "PAY_BY_THE_HOUR_ONLY_FOR_WHAT_YOU_NEED": "Pay by the hour and only for the time you use",
  "PAY_FIXED_PRICE_FOR_FULL_DAY_STORAGE": "Pay a fixed price up front for a full day of storage",
  "PAY_IN_SHOP": "Pay in shop",
  "PAY_IN_SHOP_EXPLANATION": "If you are unable to complete the payment, please show this receipt and pay at the shop instead.",
  "PAY_LATER": "Pay later",
  "PAY_NOW": "Pay now",
  "PAY_THE_STAFF": "Please pay the staff in the shop",
  "PAY_UP_FRONT": "Flat rate",
  "PAY_USING_ANY_METHOD_SUPPORTED_BY_SHOP": "NOTE: You can pay using any payment method accepted by the shop",
  "PENDING_ACTIVATION": "Pending activation",
  "PENDING_ACTIVATION_APPROVAL_NOTE": "Most locations are approved within 1–2 business days.",
  "PENDING_ACTIVATION_EARNING_RATE_SUBTITLE": "You keep a share of every booking, paid out directly to your bank account.",
  "PENDING_ACTIVATION_EARNING_RATE_TITLE": "Your earning rate",
  "PENDING_ACTIVATION_GO_TO_SETUP_TASKS": "Go to setup tasks",
  "PENDING_ACTIVATION_HOW_DROPOFF_WORKS_SUBTITLE": "Travelers book and pay in the app, then check in with you at the counter.",
  "PENDING_ACTIVATION_HOW_DROPOFF_WORKS_TITLE": "How drop-off works",
  "PENDING_ACTIVATION_HOW_IT_WORKS_EYEBROW": "How it works",
  "PENDING_ACTIVATION_NEED_HELP_GETTING_STARTED": "Need help getting started?",
  "PENDING_ACTIVATION_NEED_HELP_WITH_LOCATION": "Need help with this location?",
  "PENDING_ACTIVATION_REVIEW_BODY": "Your location is being reviewed — there's nothing more to do right now. Here's how storage works, so you're ready the day it goes live.",
  "PENDING_ACTIVATION_REVIEW_EYEBROW": "While you wait",
  "PENDING_ACTIVATION_REVIEW_HEADING": "Get ready for your first bookings",
  "PENDING_ACTIVATION_SETUP_BODY": "Almost there. Complete the setup checklist above to submit your location for review. We'll turn on bookings as soon as it's approved.",
  "PENDING_ACTIVATION_SETUP_BODY_V2": "Almost there. Finish the setup checklist above and we'll review your location and turn on bookings.",
  "PENDING_ACTIVATION_SETUP_EYEBROW": "Before you go live",
  "PENDING_ACTIVATION_SETUP_HEADING": "Finish setup to open for bookings",
  "PENDING_ACTIVATION_STATUS_ONLY_BODY": "Your new location just needs a quick review before it starts taking bookings. Your other locations keep running as normal — nothing to do here for now.",
  "PENDING_ACTIVATION_STATUS_ONLY_EYEBROW": "New location",
  "PENDING_ACTIVATION_STATUS_ONLY_HEADING": "This location is under review",
  "PENDING_ACTIVATION_WALK_IN_BONUS_SUBTITLE": "Send walk-in guests to the app and earn a little extra on each one.",
  "PENDING_ACTIVATION_WALK_IN_BONUS_TITLE": "Walk-in bonus",
  "PENDING_TASKS_ACTIVATE_SIGNAGE_DESCRIPTION": "Your marketing materials are on the way. Activate each piece of signage so guests can find and book you.",
  "PENDING_TASKS_ACTIVATE_SIGNAGE_LABEL": "Activate HeroCode",
  "PENDING_TASKS_ADD_OPENING_HOURS_DESCRIPTION": "Tell us when you are open so travelers only book while you can take their bags.",
  "PENDING_TASKS_ADD_OPENING_HOURS_LABEL": "Add your opening hours",
  "PENDING_TASKS_ADD_PAYOUT_ACCOUNT_DESCRIPTION": "Connect your bank account for payouts",
  "PENDING_TASKS_ADD_PAYOUT_ACCOUNT_LABEL": "Add Payout Account",
  "PENDING_TASKS_CONNECT_BUSINESS_PROFILE_DESCRIPTION": "Link your Google listing so your reviews and photos build trust with travelers.",
  "PENDING_TASKS_CONNECT_BUSINESS_PROFILE_LABEL": "Connect your Google Business Profile",
  "PENDING_TASKS_CREATE_PAYOUT_ACCOUNT_DESCRIPTION": "Add your payout account to receive payments",
  "PENDING_TASKS_CREATE_PAYOUT_ACCOUNT_LABEL": "Create payout account",
  "PENDING_TASKS_DONE_SUFFIX": "done",
  "PENDING_TASKS_EU_VAT_DECISION_DESCRIPTION": "Tell us whether your business has a VAT number so we can calculate your payouts correctly.",
  "PENDING_TASKS_EU_VAT_DECISION_LABEL": "Confirm your VAT status",
  "PENDING_TASKS_FINISH_SETTING_UP_PREFIX": "Finish setting up",
  "PENDING_TASKS_GO_LIVE_BLOCKED_HINT": "Almost there — finish the steps required to go live and we’ll review your storage location.",
  "PENDING_TASKS_GO_LIVE_HEADLINE_MANY": "You're {{count}} steps from going live",
  "PENDING_TASKS_GO_LIVE_HEADLINE_ONE": "You're one step from going live",
  "PENDING_TASKS_GO_LIVE_HEADLINE_READY": "You're ready to go live",
  "PENDING_TASKS_GO_LIVE_SUBLINE": "Finish the steps below, then send your storage location to us and we’ll make it live.",
  "PENDING_TASKS_GO_LIVE_SUBLINE_READY": "Send it to us and we’ll make it live. The rest of your setup can follow afterwards.",
  "PENDING_TASKS_HIDE_COMPLETED": "Hide completed tasks",
  "PENDING_TASKS_NO_PENDING_TASKS": "No pending tasks",
  "PENDING_TASKS_PANEL_TITLE": "Pending Tasks",
  "PENDING_TASKS_PAYOUT_ACCOUNT_NOT_VERIFIED_DESCRIPTION": "Verify your payout account to receive payments",
  "PENDING_TASKS_PAYOUT_ACCOUNT_NOT_VERIFIED_LABEL": "Payout account not verified",
  "PENDING_TASKS_PAYOUT_ACCOUNT_VERIFIED_DESCRIPTION": "Your payout account is verified and ready to receive payments",
  "PENDING_TASKS_PAYOUT_ACCOUNT_VERIFIED_LABEL": "Payout account verified",
  "PENDING_TASKS_PRINT_SIGNAGE_DESCRIPTION": "Download and print your signage material",
  "PENDING_TASKS_PRINT_SIGNAGE_LABEL": "Print Signage",
  "PENDING_TASKS_REQUEST_REVIEW_ACTION": "Send my storage location for review",
  "PENDING_TASKS_REQUEST_REVIEW_ERROR": "We could not send your storage location for review. Please try again.",
  "PENDING_TASKS_ROW_STATE_DONE": "Done",
  "PENDING_TASKS_ROW_STATE_TODO": "Not done",
  "PENDING_TASKS_SHOW_COMPLETED": "Show completed tasks ({{count}})",
  "PENDING_TASKS_SIGNAGE_OR_APP_DESCRIPTION": "Do either one so walk-in travelers can recognise your storage location and you can manage bookings on the go.",
  "PENDING_TASKS_SIGNAGE_OR_APP_LABEL": "Print your signage or get the app",
  "PENDING_TASKS_START_NOW": "Start now",
  "PENDING_TASKS_STEPS_LEFT_LABEL": "Steps left",
  "PENDING_TASKS_UNDER_REVIEW_NOTE": "We're reviewing your storage location and will make it live for you.",
  "PENDING_TASKS_UPDATE_CONTACT_INFO_DESCRIPTION": "Add a primary contact and an email or phone number so we can reach you about bookings and payouts.",
  "PENDING_TASKS_UPDATE_CONTACT_INFO_LABEL": "Update your contact info",
  "PENDING_TASKS_UPDATE_HOLIDAY_HOURS_DESCRIPTION": "Set special opening hours for holidays",
  "PENDING_TASKS_UPDATE_HOLIDAY_HOURS_LABEL": "Update Holiday Hours",
  "PENDING_TASKS_UPLOAD_STOREFRONT_IMAGES_DESCRIPTION": "Add photos of your storefront",
  "PENDING_TASKS_UPLOAD_STOREFRONT_IMAGES_LABEL": "Upload Storefront Images",
  "PENDING_TASKS_VERIFY_PHONE_NUMBER_DESCRIPTION": "Verify your phone number so we can reach you instantly for bookings and support.",
  "PENDING_TASKS_VERIFY_PHONE_NUMBER_LABEL": "Add a verified phone number",
  "PEOPLE_GAVE_FEEDBACK": "people gave feedback after using LuggageHero!",
  "PERFORMANCE": "Performance",
  "PERFORMANCE_CONDITIONS_PANEL_TITLE": "Performance Conditions",
  "PERFORMANCE_LAST_30_DAYS": "Performance last 30 days",
  "PERIOD": "Period",
  "PERIOD_CUSTOM": "Custom",
  "PERIOD_LAST_14_DAYS": "Last 14 days",
  "PERIOD_LAST_30_DAYS": "Last 30 days",
  "PERIOD_LAST_60_DAYS": "Last 60 days",
  "PERIOD_LAST_7_DAYS": "Last 7 days",
  "PERIOD_LAST_90_DAYS": "Last 90 days",
  "PERIOD_LAST_MONTH": "Last Month",
  "PERIOD_LAST_QUARTER": "Last Quarter",
  "PERIOD_MONTH_TO_DATE": "Month To Date",
  "PERIOD_QUARTER_TO_DATE": "Quarter To Date",
  "PERIOD_YEAR_TO_DATE": "Year To Date",
  "PERU": "Peru",
  "PER_BAG": "per bag",
  "PER_BAG_STORED": "per bag stored",
  "PER_DAY_SHORT": "/day",
  "PER_HOUR": "Per hour",
  "PER_HOUR_SHORT": "/hour",
  "PER_WALK_IN_BONUS": "bonus on every 20 walk-in bookings",
  "PHILIPPINES": "Philippines",
  "PHONE": "Phone",
  "PHONE_COUNTRY_CODE_INVALID": "Not a valid country code",
  "PHONE_NUMBER": "Phone number",
  "PHONE_NUMBER_INVALID": "Not a valid phone number",
  "PHONE_NUMBER_MISSING": "No phone number provided",
  "PHONE_NUMBER_OPTIONAL": "Phone number (optional)",
  "PHONE_NUMBER_TOO_LONG": "Phone number too long",
  "PHONE_NUMBER_TOO_SHORT": "Phone number too short",
  "PHONE_REQUIRED_ERROR": "Phone number is required",
  "PHONE_VERIFICATION": "Phone Verification",
  "PHOTO_OF_LUGGAGE_RECOMMENDED": "We recommend taking a photo of your luggage so it is easy to find at pick-up",
  "PICKED_UP": "Picked up!",
  "PICKUP_CONFIRMED": "Pickup confirmed",
  "PICKUP_STEP_BODY": "Choose when you'll come back for your bags.",
  "PICKUP_STEP_BODY_DATE": "Choose the day you'll come back for your bags.",
  "PICKUP_STEP_DATE_LABEL": "Date",
  "PICKUP_STEP_HEADER": "Pick-up time",
  "PICKUP_STEP_HEADER_DATE": "Pick-up date",
  "PICKUP_STEP_NO_TIMES": "No pickup times are available right now. Please ask at the reception.",
  "PICKUP_STEP_PICK_A_DATE": "Pick a date",
  "PICKUP_STEP_TIME_HINT": "An approximate time is fine.",
  "PICKUP_STEP_TIME_LABEL": "Time",
  "PICKUP_STEP_TIME_MOVED": "The time you chose has passed, so we picked the next one. Please check it.",
  "PICKUP_TIME": "Pickup time",
  "PICK_UP": "Pick up",
  "PIN_CODE": "PIN Code",
  "PLATFORM_DISABLED_MESSAGE": "Your platform has been temporarily disabled. Please contact support for more information.",
  "PLEASE_ACCEPT_TERMS_TO_BECOME_SUPERHERO": "Please accept the terms of service to view the SuperHero page",
  "PLEASE_CHECK_YOUR_EMAIL": "Please check your email for a link to reset your password.",
  "PLEASE_READ_CANCELLATION_POLICY": "Please read about our cancellation policy",
  "PLEASE_USE_ADMIN_AREA_TO_COMPLETE_ONBOARDING": "Please use the admin area to complete the onboarding process.",
  "PLEASE_WAIT": "Please wait...",
  "PLUS_SERVICE_FEE": "+ {{fee}} service fee",
  "PMS_MEMBER_VERIFICATION_BODY": "Please submit your ",
  "PMS_MEMBER_VERIFICATION_HEADER": "Member Verification",
  "POLAND": "Poland",
  "PORTUGAL": "Portugal",
  "POSTAL_CODE": "Postal code",
  "PREMIUM_INSURANCE": "Premium insurance",
  "PREMIUM_STORAGE_LOCATION": "Premium",
  "PREMIUM_STORAGE_LOCATION_EXPLANATION": "Premium storage locations are hotels or other high-end establishments with attractive opening hours",
  "PRICE": "Price",
  "PRICES_APPLY_TO_ADVANCE_BOOKINGS": "Prices apply to bookings made in advance",
  "PRICE_DISCOUNT": "Discount",
  "PRICE_FOR_PAYG_BOOKINGS_UPON_PICKUP": "The price for pay-as-you-go bookings is calculated upon pickup",
  "PRICE_FROM": "from {{price}}",
  "PRICE_SERVICE_FEE": "Service fee",
  "PRICE_SERVICE_FEE_EXPLANATION_SHORT": "This helps us run our platform and offer services like customer support. It's a flat fee per bag.",
  "PRICE_STORAGE": "Storage",
  "PRICE_TIER_PER_DAY": "Per day",
  "PRICE_TIER_TABLE_DAY_AHEAD": "Day ahead",
  "PRICE_TIER_TABLE_SAME_DAY": "Same day",
  "PRICE_TIP": "Tip",
  "PRICE_TOTAL": "Total",
  "PRICING": "Pricing",
  "PRICING_MODEL_DAILY": "Daily pricing",
  "PRICING_MODEL_HOURLY": "Hourly pricing",
  "PRINT": "Print",
  "PROCEED_ANYWAY": "Proceed anyway?",
  "PROCEED_TO_MY_BOOKING": "Proceed to my booking",
  "PROCEED_TO_PICKUP": "Proceed to pickup",
  "PROCEED_UNCOVERED": "Proceed uncovered",
  "PROCEED_WITHOUT_EMAIL": "Proceed without email",
  "PROCESSING": "Processing…",
  "PROCESSING_IMAGE_LONG": "Processing image",
  "PRODUCT_FLAG_WINDOW": "Window Flag + Base",
  "PRODUCT_LUGGAGE_TAGS_50": "50× Re-usable Luggage Tags",
  "PRODUCT_SIGN_DESK": "HeroCode Desk Sign",
  "PRODUCT_SIGN_STREET": "LuggageHero Street Sign",
  "PRODUCT_STICKER_EXTERNAL": "External HeroCode Sticker",
  "PRODUCT_STICKER_INTERNAL": "Internal HeroCode Sticker",
  "PRODUCT_STICKER_LH": "LuggageHero Sticker",
  "PRODUCT_STICKER_MINI": "Mini HeroCode Sticker",
  "PROFESSION": "Profession",
  "PROFILE_CHANGE": "Change",
  "PROFILE_DETAILS": "Profile Details",
  "PROFILE_LOAD_FAILED": "Could not load your profile. Please try again.",
  "PROFILE_PHONE_UNLINKED": "Phone number unlinked.",
  "PROFILE_PHONE_UNLINK_FAILED": "Could not unlink the phone number. Please try again.",
  "PROFILE_ROW_EMAIL": "Email address",
  "PROFILE_ROW_FULL_NAME": "Full name",
  "PROFILE_ROW_LANGUAGE": "Preferred language",
  "PROFILE_ROW_PHONE": "SMS phone number",
  "PROFILE_SIGNED_IN_ON_THIS_DEVICE": "signed in on this device",
  "PROFILE_TITLE": "Profile",
  "PROFILE_UNLINK": "Unlink",
  "PROFILE_UNLINKING": "Unlinking",
  "PROFILE_UPDATED": "Profile updated.",
  "PROFILE_UPDATE_FAILED": "Could not update your profile. Please try again.",
  "PROFILE_VERIFIED": "Verified",
  "PROFILE_YOUR_DETAILS": "Your details",
  "PROFILE_YOUR_DETAILS_INTRO": "Used for booking notifications and account recovery.",
  "PROMOTIONS": "Promotions",
  "PROMO_CODE": "Promo code",
  "PROTECTION_INSURANCE_USP_TITLE": "Coverage up to $3,000 per bag",
  "PROVIDE_EMAIL_AND_PAYMENT_METHOD": "Provide your e-mail address, choose a payment method, and start the storage timer.",
  "PROVIDE_EMAIL_FOR_BOOKING": "Provide an email address to associate with your booking",
  "PROVIDE_EMAIL_TO_CONFIRM_DROPOFF": "Provide an email address to confirm your dropoff",
  "PRO_PARTNER_TOOLTIP": "HeroPro partners are experienced and popular storage locations with an average rating higher than 4.5",
  "PUBLISH_REVIEW": "Publish review",
  "PUSH_NOTIFICATION_RATIONALE_CANCEL": "Not now",
  "PUSH_NOTIFICATION_RATIONALE_CONFIRM": "Enable",
  "PUSH_NOTIFICATION_RATIONALE_HEADER": "Stay informed",
  "PUSH_NOTIFICATION_RATIONALE_MESSAGE": "Get instant alerts when customers book, check in, or leave a review — so you never miss a beat at your location.",
  "PUSH_PERMISSION_DENIED_DISMISS": "Not now",
  "PUSH_PERMISSION_DENIED_HEADER": "Notifications are off",
  "PUSH_PERMISSION_DENIED_MESSAGE": "You won't receive booking and incident alerts. Enable notifications for LuggageHero in your device Settings to stay informed.",
  "PUSH_PERMISSION_DENIED_OPEN_SETTINGS": "Open Settings",
  "QATAR": "Qatar",
  "QR_CODE_BOOKING": "Booking QR",
  "QR_CODE_MODAL_DESCRIPTION": "Show this QR code to your traveller to start a booking",
  "QR_CODE_MODAL_TITLE": "Booking QR Code",
  "QUICK_ACTIONS_PANEL_TITLE": "Quick Actions",
  "QUICK_ACTION_HOLIDAY_HOURS_LABEL": "Holiday Hours",
  "QUICK_ACTION_HOLIDAY_HOURS_SUBTEXT": "Set special opening hours",
  "QUICK_ACTION_OPENING_HOURS_LABEL": "Opening Hours",
  "QUICK_ACTION_OPENING_HOURS_SUBTEXT": "Update your opening hours",
  "QUICK_ACTION_PRINT_SIGNAGE_LABEL": "Print HeroCode",
  "QUICK_ACTION_PRINT_SIGNAGE_SUBTEXT": "Download & print QR",
  "RATED_THIS_LOCATION": "Rated this location without leaving a comment",
  "RATE_LUGGAGEHERO": "Rate LuggageHero",
  "RATE_US_ON": "Rate us on",
  "RATE_YOUR_EXPERIENCE": "Rate your experience",
  "RATE_YOUR_PICKUP_EXPERIENCE": "Rate your experience",
  "RATING": "rating",
  "RATINGS": "ratings",
  "RATINGS_AND_REVIEWS": "Ratings & Reviews",
  "RATINGS_AND_REVIEWS_EXPLAIN_DESCRIPTION": "Reviews help travelers trust your location and strongly influence your visibility on the platform. Locations with more recent 5-star reviews are more likely to appear higher in search and attract more bookings.",
  "RATINGS_AND_REVIEWS_EXPLAIN_HOW_TO_IMPROVE": "Tip: Ask customers to leave a review right after their visit. A steady flow of new reviews helps keep your location visible and competitive",
  "RATINGS_AND_REVIEWS_TOOLTIP": "More ratings improve your visibility on LuggageHero.",
  "RATINGS_AND_REVIEWS_WHY_IT_MATTERS": "Why reviews matter",
  "RATINGS_RECEIVED_LAST_30_DAYS": "Ratings received in last 30 days.",
  "RATING_ALREADY_SAVED": "Optional — your rating is already saved",
  "RATING_EXPLANATION": "How would you rate the shop?",
  "RATING_SAVED_INSTANTLY": "Saved instantly on tap",
  "READY_TO_COLLECT": "Ready to collect your luggage?",
  "READY_TO_GO": "You can go to the shop now",
  "READY_TO_HAND_IN": "Ready to hand in your luggage?",
  "READ_ALL_REVIEWS": "Read all reviews",
  "READ_REVIEWS": "Read reviews",
  "RECEIPT": "Receipt",
  "RECLAIM_YOUR_LUGGAGE": "Reclaim your luggage",
  "RECOMMENDED": "Recommended",
  "RECOMMENDS_THIS_LOCATION": "Recommends this location",
  "REDO_SEARCH_HERE": "Redo search here",
  "REGISTER": "Register",
  "REGISTER_USER_ERROR_MESSAGE": "The user account could not be created. Please check your connection and try again.",
  "REGISTER_USER_ERROR_TITLE": "User registration failed",
  "REGISTER_WITH_EMAIL": "Create account",
  "REMEMBER_TO_CHECK_IN": "Before handing your luggage over to the staff, remember to check in.",
  "REMEMBER_TO_STOP_THE_TIMER": "Remember to stop the storage timer when you return to collect your bags",
  "REMOVE": "Remove",
  "REMOVE_CODE": "Remove code",
  "REMOVE_FAILED": "Failed to remove image",
  "REMOVE_IMAGE": "Remove image",
  "REPEAT_PASSWORD": "Repeat password",
  "REPEAT_PASSWORD_INPUT_PLACEHOLDER": "Repeat your password",
  "REPORTED_AN_INCIDENT": "Reported an incident",
  "REPORTED_INCIDENT_ASKED_TO_PAY_DIRECTLY": "Reported they were asked to pay directly",
  "REPORTED_INCIDENT_LOCATION_CLOSED_ON_ARRIVAL": "Reported the location was closed",
  "REPORTED_INCIDENT_LOCATION_REFUSED_BAGS": "Reported they were refused storage",
  "REPORTED_INCIDENT_STAFF_UNAWARE_OF_SERVICE": "Reported staff was unaware of the service",
  "REPORTED_INCIDENT_UNABLE_TO_FIND_LOCATION": "Reported they were unable to find the location",
  "REPORT_INCIDENT": "Report incident",
  "REPORT_INCIDENT_AND_CANCEL": "Cancel booking and report incident",
  "REQUEST_ACCOUNT_DELETION": "Request Account Deletion",
  "REQUEST_ACCOUNT_DELETION_DESCRIPTION": "Submitting this request will initiate the account deletion process. A member of our team will reach out to you to verify your identity and confirm the deletion before any action is taken.",
  "REQUEST_ACCOUNT_DELETION_SUBMIT": "Request Account Deletion",
  "REQUEST_ACCOUNT_DELETION_SUCCESS": "Your account deletion request has been submitted.",
  "REQUEST_NEW_ACCESS_CODE": "Request new access code",
  "REQUEST_NEW_ACCESS_CODE_SHORT": "Request new",
  "REQUIRED": "Required",
  "REQUIREMENT_LIST_ACTIVATE_SIGNAGE_DESCRIPTION": "Activate your HeroCode signage so walk-in customers can scan it at your shop.",
  "REQUIREMENT_LIST_ACTIVATE_SIGNAGE_TEXT": "Activate your signage",
  "REQUIREMENT_LIST_ADD_PAYOUT_ACCOUNT_DESCRIPTION": "Add a payout account so we can pay out your earnings.",
  "REQUIREMENT_LIST_ADD_PAYOUT_ACCOUNT_TEXT": "Add a payout account",
  "REQUIREMENT_LIST_COMPLETE_REQUIRED_BOOKINGS": "Complete 5 Bookings",
  "REQUIREMENT_LIST_COMPLETE_REQUIRED_BOOKINGS_DESCRIPTION": "Complete the required number of bookings to qualify for the program",
  "REQUIREMENT_LIST_COMPLETE_REQUIRED_MINIMUM_WALKINS": "Minimum 1 Walk-in required",
  "REQUIREMENT_LIST_COMPLETE_REQUIRED_MINIMUM_WALKINS_DESCRIPTION": "Completed once a customer without a booking scan your HeroCode.",
  "REQUIREMENT_LIST_EXCLUSIVITY_AGREEMENT_SIGNED_DESCRIPTION": "Read and accept the SuperHero exclusivity agreement to join the program",
  "REQUIREMENT_LIST_EXCLUSIVITY_AGREEMENT_SIGNED_TEXT": "Accept Exclusivity Agreement",
  "REQUIREMENT_LIST_MINIMUM_RATING_DESCRIPTION": "Maintain an average rating of at least 4.6 across a minimum of 5 reviews.",
  "REQUIREMENT_LIST_MINIMUM_RATING_TEXT": "Get a 4.6+ average rating",
  "REQUIREMENT_LIST_PARTNER_PROGRAM_SIGNED_DESCRIPTION": "Read and accept the SuperHero partner agreement to join the program",
  "REQUIREMENT_LIST_PARTNER_PROGRAM_SIGNED_TEXT": "Accept Walk In Program",
  "REQUIREMENT_LIST_VERIFY_PHONE_DESCRIPTION": "Verify your phone number so we can reach you about your bookings.",
  "REQUIREMENT_LIST_VERIFY_PHONE_TEXT": "Verify your phone number",
  "RESERVE_FIRST_X_HOURS_PART_1": "We reserve the first",
  "RESERVE_FIRST_X_HOURS_PART_2": "+ fees when booking. Final price is calculated on pickup.",
  "RESET": "Reset",
  "RESET_FILTERS": "Reset Filters",
  "RESET_PASSWORD": "Reset password",
  "RESET_PASSWORD_DESCRIPTION": "Enter your e-mail and we will sent you a link to reset your password.",
  "RESET_PASSWORD_MISSING_EMAIL": "Enter the email address of the account to reset",
  "RESET_PASSWORD_RETRY": "Request new reset link",
  "RESET_PASSWORD_SEND_LINK_SUBMIT": "Send link",
  "RESET_PASSWORD_SUCCESS_MESSAGE": "We've emailed you a new password",
  "RESET_TO_GOOGLE_HOURS": "Reset to Google hours",
  "RESOLVE": "Resolve",
  "RESOLVED": "Resolved",
  "RESOLVE_INCIDENT": "Resolve Incident",
  "RESOLVING": "Resolving…",
  "RETAKE_PHOTO": "Retake photo",
  "RETRIEVING_ACCESS_CODE": "Retrieving access code",
  "RETRY": "Retry",
  "RETRYING_PAYMENT": "Retrying payment",
  "RETRY_PAYMENT_BUTTON": "Retry payment",
  "RETRY_PAYMENT_EXPLANATION_PART_1": "We were not able to charge the payment to your card. You can retry the payment below. If you want to try a different payment card, you have to add it in",
  "RETRY_PAYMENT_EXPLANATION_PART_2": "the payment method section",
  "RETRY_WITH": "Retry with",
  "RETURN_TO_BOOKING": "Return to booking",
  "REVENUE": "Revenue",
  "REVERSE_VAT_ADJUSTMENT": "Reverse VAT — Bag-Day Guarantee Adjustment",
  "REVIEWS": "Reviews",
  "REVIEWS_ALL_TIME": "All time",
  "REVIEWS_INFO_PANEL_BODY": "Your average rating and number of reviews determine how you rank on LuggageHero. Make sure to ask all travelers to leave a review on pick-up.",
  "REVIEWS_INFO_PANEL_TITLE": "Boost your revenue with more reviews",
  "REVIEWS_OF_OTHER_LOCATIONS": "Reviews of other locations",
  "REVIEW_EXPLANATION": "Leave a review",
  "REVIEW_FROM_GOOGLE": "Review from Google",
  "REVIEW_HEADLINE": "Headline",
  "REVIEW_NEW_BADGE": "New",
  "REVIEW_NO_BOOKING_ID": "No booking ID",
  "REVIEW_NO_COMMENTS": "No comments provided.",
  "REVIEW_POSTED": "Review posted!",
  "REVIEW_SATISFACTION_LEVEL_0": "Bad",
  "REVIEW_SATISFACTION_LEVEL_1": "OK",
  "REVIEW_SATISFACTION_LEVEL_2": "Great",
  "REVIEW_SHOP_COMMENTS_OPTIONAL": "Comments (optional)",
  "REVIEW_VIEW_BOOKING_DETAILS": "View booking details",
  "ROLE": "Role",
  "ROMANIA": "Romania",
  "ROME": "Rome",
  "RWANDA": "Rwanda",
  "SAFETY_BULLETS_1": "Your luggage is insured against damage, loss, and theft",
  "SAFETY_BULLETS_2": "Only certified local shops approved by LuggageHero",
  "SAFETY_BULLETS_3": "Every bag is secured with a unique one-time seal",
  "SAFETY_BULLETS_4": "Online customer service is on hand to assist 24/7",
  "SAINT_LUCIA": "Saint Lucia",
  "SAME_DAY_BAG_STORAGE_DAILY": "Same-day storage per day",
  "SAME_DAY_BAG_STORAGE_DAILY_INFO_BODY": "This rate applies to bookings made on the day of drop-off. You pay a fixed price for each day your bags are stored.",
  "SAME_DAY_BAG_STORAGE_DAILY_INFO_HEADER": "Same-day rate",
  "SAME_DAY_BAG_STORAGE_HOURLY": "Same-day storage per hour",
  "SAME_DAY_BAG_STORAGE_HOURLY_INFO_BODY": "This rate applies to bookings made on the day of drop-off. You pay for each hour your bags are stored.",
  "SAME_DAY_BAG_STORAGE_HOURLY_INFO_HEADER": "Same-day rate",
  "SAME_DAY_CANCELLATIONS": "Same-day cancellations",
  "SAN_FRANCISCO": "San Francisco",
  "SAN_MARINO": "San Marino",
  "SATISFACTION_EXPLANATION": "How was your experience overall?",
  "SATURDAY": "Saturday",
  "SAUDI_ARABIA": "Saudi Arabia",
  "SAVE": "Save",
  "SAVED_PAYMENT_METHODS": "Saved payment methods",
  "SAVE_CHANGES": "Save Changes",
  "SAVING_IMAGE": "Saving image",
  "SEARCH": "Search",
  "SEARCHING": "Searching…",
  "SEARCH_BUSINESS_PROFILES": "Search by storage location, listing name or ID",
  "SEARCH_LANDING_PAGES": "Search by name, slug or storage location",
  "SEARCH_LOCATION_BY_NAME_OR_ID": "Search for a storage location by name or ID",
  "SEARCH_NEAR_ADDRESS": "Find listings near an address",
  "SEARCH_ON_MOVE_MAP": "Search as I move the map",
  "SEARCH_TRANSLATIONS_PLACEHOLDER": "Search...",
  "SECURE_PAYMENTS": "Secure payments",
  "SECURE_YOUR_BAGS": "Secure your bags",
  "SECURITY": "Security",
  "SECURITY_SEAL_ORDER_DESCRIPTION": "Security seal",
  "SECURITY_SEAL_ORDER_DETAIL": "Tamper-proof seal fitted through the zippers of your bag",
  "SEE_EXAMPLE": "See example",
  "SEE_MORE_SHOPS": "See more shops",
  "SEE_SUPERHERO_STATUS_CTA_TEXT": "Check status",
  "SEE_WHAT_THEY_SAID": "See what they said.",
  "SELECT_BUSINESS_COUNTRY": "Select country where your business is registered",
  "SELECT_BUSINESS_TYPE": "Select Business Type",
  "SELECT_CANCEL_REASON": "Let us know why you are cancelling",
  "SELECT_COUNTRY": "Select country",
  "SELECT_EXCEPTION_DATE": "Select exception date",
  "SELECT_NUMBER_OF_BAGS_TO_STORE": "Select how many bags you wish to store",
  "SELECT_PAYMENT_METHOD": "Select payment method",
  "SELECT_PAYMENT_METHOD_TO_CONFIRM_BOOKING": "Select a payment method to confirm your booking",
  "SELECT_PAYMENT_METHOD_TO_CONFIRM_DROPOFF": "Select a payment method to confirm your drop-off",
  "SELECT_PROFESSION": "Select your profession",
  "SELECT_STORAGE": "Select storage",
  "SELECT_TIME": "Select time",
  "SEND_AGAIN": "Send again",
  "SEND_AGAIN_IN_REMAINING_DELAY": "Send again in",
  "SENEGAL": "Senegal",
  "SERBIA": "Serbia",
  "SET_NEW_PASSWORD": "Set new password",
  "SET_NEW_PASSWORD_TITLE": "Set new password",
  "SHARE_BOOKING": "Share booking",
  "SHARE_STORAGE_LOCATION": "Share storage location",
  "SHARE_VIA": "Share via",
  "SHOP": "Shop",
  "SHOP_BILLING_CONTACT": "Billing Contact",
  "SHOP_BILLING_TEXT": "Provide the email addresses that should receive invoices and payout notifications. Separate multiple entries by comma.",
  "SHOP_DETAILS_TITLE": "Storage Location",
  "SHOP_IMAGES_EXPLANATION": "Upload one or more images of the shop. The best images show the full facade from the street, making it easier for travelers to find you.",
  "SHOP_INACTIVE_MESSAGE": "This shop is not available",
  "SHOP_MANAGER": "Shop Manager",
  "SHOP_NOTIFICATIONS": "Notifications",
  "SHOP_NOTIFICATIONS_EXPLANATION_PART_1": "Provide the name of the primary contact person for the shop, and the phone numbers and email addresses that should receive operational messages (e.g. booking notifications).",
  "SHOP_NOTIFICATIONS_EXPLANATION_PART_2": "NOTE: Separate multiple email addresses and phone numbers by comma.",
  "SHOP_NOTIFICATIONS_TEXT": "Provide the phone numbers and email addresses that should receive transactional messages (e.g. booking notifications). Separate multiple entries by comma.",
  "SHOP_NOT_ON_GOOGLE": "Not on Google Maps",
  "SHOP_PROFILE_WIFI_EXPLANATION_PART_1": "The travelers need to connect to the internet from their smartphone to complete the check-in and check-out procedures.",
  "SHOP_PROFILE_WIFI_EXPLANATION_PART_2": "Indicate below if there is Wi-Fi available at the location. To make the process even smoother, provide the Wi-Fi access details.",
  "SHOP_SEARCH_GOOGLE": "Search Google Maps",
  "SHOP_SEARCH_GOOGLE_DESCRIPTION": "Use Google Maps to find the location you want to create. Then fill in the rest of the required information below.",
  "SHOP_STRIPE_EXPLANATION_CREATE_ACCOUNT": "Click the button below to create a Stripe account that will be connected with LuggageHero. You will receive an email from Stripe with further instructions on how to set up your account with them.",
  "SHOP_UNAVAILABLE_MESSAGE": "This shop is not available with your selection.",
  "SHORT_TERM_ONLY": "Short-term only",
  "SHOW_ACCESS_CODE": "Show",
  "SHOW_DROPOFF_CONFIRMATION_LONG": "View dropoff confirmation",
  "SHOW_LESS": "Show less",
  "SHOW_LIST": "Show list",
  "SHOW_MAP": "Show map",
  "SHOW_MORE": "Show more",
  "SHOW_PASSWORD": "Show password",
  "SHOW_PICKUP_CONFIRMATION": "When you return, stop the storage timer and show the pickup confirmation to reclaim your bags.",
  "SHOW_PICKUP_CONFIRMATION_IN_THE_APP_TO_RECLAIM": "Show the pickup confirmation displayed in the LuggageHero app to reclaim your bags",
  "SHOW_PICKUP_CONFIRMATION_LONG": "View pickup confirmation",
  "SHOW_PICKUP_CONFIRMATION_TO_RECLAIM": "Show the pickup confirmation displayed on your booking page to reclaim your bags.",
  "SHOW_SUMMARY": "Details",
  "SHOW_THE_RECEIPT_AND_PAY_IN_SHOP": "Show the pickup confirmation and pay the staff directly",
  "SHOW_THE_RECEIPT_TO_THE_STAFF": "Show the pickup confirmation to the staff to collect your bags",
  "SHOW_THIS_AND_HAND_OVER_BAGS_AT": "Show this screen and hand your bags over to the staff at",
  "SHOW_THIS_AND_PAY_DIRECTLY_AT": "Show this screen to the staff and pay directly at",
  "SHOW_THIS_TO_COLLECT_BAGS_AT": "Show this screen to the staff to collect your bags at",
  "SHOW_TO_HOTEL_STAFF_AND_HAND_OVER": "Show this screen to the hotel staff and hand over your luggage",
  "SHOW_TO_PARTNER_STAFF": "Show to partner staff",
  "SHOW_X_MORE_TAGS_POST": "more",
  "SHOW_X_MORE_TAGS_PRE": "Show",
  "SIGNAGEL_CONNECT_WIZARD_SUCCESS_DETAIL": "You can now close this window and return to your signage display.",
  "SIGNAGE_CONNECT_WIZARD_SUCCESS_DETAIL": "You can now close this window and return to your signage display.",
  "SIGNAGE_PAGE_HEADING": "Signage Management",
  "SIGNAGE_WIZARD_BANNER_CONNECTING_TO": "Activating for",
  "SIGNAGE_WIZARD_CONFIRM_DESCRIPTION": "Make sure this matches the sticker in your hand before you activate it.",
  "SIGNAGE_WIZARD_CONFIRM_ITEM_LABEL": "Item",
  "SIGNAGE_WIZARD_CONFIRM_PIN_LABEL": "Sticker PIN",
  "SIGNAGE_WIZARD_CONFIRM_SHOP_LABEL": "Shop",
  "SIGNAGE_WIZARD_CONFIRM_TITLE": "Check the details",
  "SIGNAGE_WIZARD_CONNECT_ANOTHER": "Activate another sticker for {{shop}}",
  "SIGNAGE_WIZARD_CONNECT_CTA": "Activate",
  "SIGNAGE_WIZARD_CONNECT_DIFFERENT_SHOP": "Activate a sticker on a different shop",
  "SIGNAGE_WIZARD_DONE": "Done",
  "SIGNAGE_WIZARD_SELECT_SHOP_DESCRIPTION_MULTI": "Choose the shop you're activating this signage on. Each sticker links to one shop.",
  "SIGNAGE_WIZARD_SELECT_SHOP_DESCRIPTION_SINGLE": "Confirm the shop you're activating this signage on.",
  "SIGNAGE_WIZARD_SELECT_SHOP_TITLE": "Which shop is this for?",
  "SIGNAGE_WIZARD_SELECT_TYPE_DESCRIPTION": "Pick the signage piece you're activating. The PIN is right under its QR code.",
  "SIGNAGE_WIZARD_SELECT_TYPE_TITLE": "Which item are you activating?",
  "SIGNAGE_WIZARD_SUCCESS_BODY": "It's now linked to {{shop}} and ready for walk-in customers to scan.",
  "SIGNAGE_WIZARD_SUCCESS_STEP_DESCRIPTION": "Your signage is now connected to the storage location and will start working shortly.",
  "SIGNAGE_WIZARD_SUCCESS_STEP_TITLE": "Signage Connected Successfully",
  "SIGNAGE_WIZARD_SUCCESS_TITLE": "Sticker activated",
  "SIGNED_IN_AS": "Signed in as",
  "SIGN_IN": "Sign in",
  "SIGN_IN_CODE_RATE_LIMITED": "Too many sign-in attempts. Please wait a while and try again.",
  "SIGN_IN_CODE_SEND_FAILED": "We couldn't send a code to this email. Please try again.",
  "SIGN_IN_TOGGLE_EMAIL": "E-mail",
  "SIGN_IN_TOGGLE_SMS": "Mobile",
  "SIGN_IN_WITH_APPLE": "Continue with Apple",
  "SIGN_IN_WITH_FACEBOOK": "Continue with Facebook",
  "SIGN_IN_WITH_GOOGLE": "Continue with Google",
  "SINGAPORE": "Singapore",
  "SKIP": "Skip",
  "SKIP_FOR_NOW": "Skip for now",
  "SLIDE_TO_CONFIRM": "Slide to confirm",
  "SLIDE_TO_CONFIRM_DROPOFF": "Slide to confirm dropoff",
  "SLIDE_TO_CONFIRM_PICKUP": "Slide to confirm pickup",
  "SLOVAKIA": "Slovakia",
  "SLOVENIA": "Slovenia",
  "SMART_LINK": "Your Smart Link",
  "SMART_LINK_TEXT": "With this link, your guests will see storage options relevant to their booking and automatically receive 2 hours of free storage",
  "SMOOBU_INTEGRATION_INFO": "With this integration between Smoobu and LuggageHero, your guests are automatically informed about relevant luggage storage options near the accommodation they booked.",
  "SMS_BOOKING_EXPLANATION": "Add your phone number in case we need to reach you about your booking.",
  "SMS_COMM_FEE": "SMS Notifications",
  "SMS_COMM_FEE_INFO_BODY": "We only send you information relevant to your booking. The price is a flat fee per booking regardless of how many messages you receive.",
  "SMS_COMM_FEE_INFO_HEADER": "Receive booking related notifications via SMS",
  "SMS_DELAY_EXPLANATION": "Optional. You can skip this step.",
  "SMS_EXPLANATION": "Add your phone number in case we need to reach you about your booking.",
  "SMS_PHONE_NUMBER": "SMS Phone Number",
  "SOMETHING_WENT_WRONG": "Something went wrong",
  "SOUTH_AFRICA": "South Africa",
  "SOUTH_KOREA": "South Korea",
  "SPACE_RESERVED_FOR": "Space reserved for",
  "SPAIN": "Spain",
  "SRI_LANKA": "Sri Lanka",
  "STAFF_EFFICIENCY": "Staff Efficiency",
  "STAFF_WORKING_HOURS_SAVED": "Staff working hours saved",
  "START_STORAGE_TIMER": "Start storage timer",
  "START_STORAGE_TIMER_ON_ARRIVAL": "Start the storage timer on arrival",
  "START_THE_STORAGE_TIMER": "Start the storage timer",
  "START_THE_STORAGE_TIMER_IN_THE_APP": "Upon arrival, start the storage timer in the LuggageHero app",
  "START_TIMER_AND_DEPOSIT_BAGS_AT": "Start the timer and deposit your bags in the storage room at",
  "START_TIMER_AND_HAND_OVER_LUGGAGE_AT": "Start the timer and hand your luggage over to the staff at",
  "STATIC_CODE": "Static code",
  "STATUS": "Status",
  "STATUS_CANCELLED_EXPLANATION": "This booking was canceled by the customer before arrival",
  "STATUS_CHECKED_IN_EXPLANATION": "The customer's luggage is currently in your custody",
  "STATUS_CONFIRMED_EXPLANATION": "The customer has confirmed this booking by adding a payment method",
  "STATUS_PAID_EXPLANATION": "The customer picked up their luggage and completed the payment online",
  "STATUS_PAYMENT_FAILED_EXPLANATION": "The customer could not complete the payment online. Charge them at your premises before handing back over the luggage.",
  "STATUS_ZERO_PAYMENT_PAID_EXPLANATION": "The customer picked up their luggage and completed the booking",
  "STAY_CHECKED_IN": "Leave storage timer running",
  "STEP_2_SUPEROHERO_TOS_ALL_WALK_IN_BAGS_DESCRIPTION": "All walk-in customers must be processed through the LuggageHero platform",
  "STEP_2_SUPEROHERO_TOS_ALL_WALK_IN_BAGS_HEADER": "All walk-in bags go through LuggageHero",
  "STEP_2_SUPEROHERO_TOS_CLEARLY_DISPLAY_SIGNAGE_DESCRIPTION": "Remove competitor marketing material.",
  "STEP_2_SUPEROHERO_TOS_CLEARLY_DISPLAY_SIGNAGE_HEADER": "Clearly display LuggageHero signage",
  "STEP_2_SUPEROHERO_TOS_EXCLUSIVITY_DESCRIPTION": "Every bag you store must be booked through the LuggageHero platform, and you will not offer luggage storage through any other provider",
  "STEP_2_SUPEROHERO_TOS_EXCLUSIVITY_HEADER": "LuggageHero is your exclusive luggage storage partner",
  "STEP_2_SUPEROHERO_TOS_NEVER_ACCEPT_CASH_DESCRIPTION": "Do not accept or request cash from customers",
  "STEP_2_SUPEROHERO_TOS_NEVER_ACCEPT_CASH_HEADER": "Never accept cash",
  "STEP_2_SUPEROHERO_TOS_PROGRAM_REQUIREMENTS_HEADER": "Program requirements",
  "STEP_3_SUPEROHERO_TOS_ACCOUNT_SUSPENSION_DESCRIPTION": "Your account will be suspended from the LuggageHero platform",
  "STEP_3_SUPEROHERO_TOS_AVOID_LOSING_BENEFITS_DESCRIPTION": "Failing to meet responsibilities will affect your LuggageHero program and SuperHero benefits.",
  "STEP_3_SUPEROHERO_TOS_AVOID_LOSING_BENEFITS_HEADER": "Avoid Losing your benefits",
  "STEP_3_SUPEROHERO_TOS_LOSE_BONUS_DESCRIPTION": "You will lose the bonus of",
  "STEP_3_SUPEROHERO_TOS_PAYOUTS_DISABLED_DESCRIPTION": "All pending payouts will be disabled",
  "STEP_3_SUPEROHERO_TOS_VISIBILITY_LIMIT_DESCRIPTION": "LuggageHero will limit your visibility across all platforms",
  "STEP_4_SUPEROHERO_TOS_COMMITMENT_HEADER": "Your commitment to LuggageHero",
  "STEP_4_SUPEROHERO_TOS_EXCLUSIVITY_LABEL": "I understand, and will ensure, that LuggageHero is my exclusive luggage storage partner and that every bag I store is booked through the LuggageHero platform.",
  "STEP_4_SUPEROHERO_TOS_FINAL_LABEL": "I understand and accept the SuperHero Agreement.",
  "STEP_4_SUPEROHERO_TOS_NO_CASH_LABEL": "I will not accept or request cash payments from customers who booked outside the platform.",
  "STEP_4_SUPEROHERO_TOS_READY_TO_START": "Ready to start?",
  "STEP_4_SUPEROHERO_TOS_READ_AGREEMENT_LINK": "See full agreement",
  "STEP_4_SUPEROHERO_TOS_STAFF_LABEL": "I will ensure my staff follows all LuggageHero’s processes and requirements.",
  "STEP_4_SUPEROHERO_TOS_WALK_INS_LABEL": " I understand, and will ensure, that all bags from walk-ins, must go through the LuggageHero.",
  "STEP_4_SUPEROHERO_TOS_WALK_IN_SUPPORT_EXCLUSIVITY_LABEL": "I will help any customer who arrives without a booking to check in through LuggageHero.",
  "STEP_4_SUPEROHERO_TOS_WALK_IN_SUPPORT_LABEL": "I will assist any walk-in customers without a booking to complete their check-in through LuggageHero.",
  "STOP_STORAGE_FOOTER": "Pressing the button above will stop the storage timer. The final price will be calculated and charged to your payment card.",
  "STOP_STORAGE_TIMER_AND_SHOW_RECEIPT": "Stop the storage timer and show the pickup confirmation to the staff",
  "STOP_THE_STORAGE_TIMER": "Stop the storage timer",
  "STOP_THE_STORAGE_TIMER_IN_THE_APP": "When you return to collect your luggage, stop the storage timer in the LuggageHero app",
  "STOP_TIMER_NOW": "Stop now",
  "STOP_TIMER_UPON_RETURN": "When you return to pick up your luggage, stop the storage timer from your booking page",
  "STORAGE_AREA": "Storage area",
  "STORAGE_AREA_ACCESS": "Storage room access",
  "STORAGE_AREA_ACCESS_CODE": "Storage room access code",
  "STORAGE_AREA_NAME": "Storage area name",
  "STORAGE_AREA_TAB_TITLE": "Storage Areas",
  "STORAGE_ENDED_COLLECT_BAGS_FROM_STORAGE_ROOM": "Your storage has ended. Collect your bags from the storage room if you have not already done so",
  "STORAGE_LOCATION": "Storage Location",
  "STORAGE_LOCATIONS": "Storage Locations",
  "STORAGE_LOCATION_ID": "Storage location ID",
  "STORAGE_LOCATION_MIN_X_BAGS": "To ensure they cover their costs, this storage location accepts bookings for minimum",
  "STORAGE_LOCATION_MIN_X_BAGS_COUNT": "To cover its costs, this storage location only accepts bookings for at least {{count}} bags",
  "STORAGE_LOCATION_SETTINGS_PAGE_TITLE": "Storage Location Settings",
  "STORAGE_LOCATION_STATUS": "Location Status",
  "STORAGE_PAY_AS_YOU_GO": "Storage, pay as you go",
  "STORAGE_PRICING": "Storage pricing",
  "STORAGE_ROOM": "Storage room",
  "STORAGE_ROOM_ACCESS_TEXT_PLACEHOLDER": "Additional access information (optional)",
  "STORAGE_ROOM_MISSING_DESCRIPTION": "Add your storage location details to start accepting bookings.",
  "STORAGE_ROOM_MISSING_TITLE": "Storage Room Setup Required",
  "STORAGE_SETTINGS_PAGE_TTLE": "Storage Settings",
  "STORAGE_SPACE": "Storage space",
  "STORAGE_TIMER": "Storage timer",
  "STORAGE_TIMER_DAYS": "D",
  "STORAGE_TIMER_ENABLED_AFTER_PAYMENT_METHOD": "You can start the storage timer after adding a payment method",
  "STORAGE_TIMER_ENSURES_YOU_PAY_ONLY_FOR_HOURS_SPENT": "Starting and stopping the storage timer ensures that you only pay for the hours you keep your luggage stored",
  "STORAGE_TIMER_EXPLANATION_PART_1_SHORT": "Start the timer when you drop your bags off, and stop it when you pick them back up.",
  "STORAGE_TIMER_EXPLANATION_PART_2": "Your bags are only insured while the timer is running.",
  "STORAGE_TIMER_HOURS": "H",
  "STORAGE_TIMER_MINUTES": "M",
  "STORAGE_TIMER_SECONDS": "S",
  "STORAGE_TIMER_WHY": "Why?",
  "STORED": "Stored",
  "STORES_ABOUT_DESCRIPTION": "This trusted local LuggageHero partner offers luggage storage near {{place}} in {{city}}. Book online in seconds, drop your bags, and enjoy the city without dragging your luggage around — every bag is insured and there's 24/7 support if you need a hand.",
  "STORES_ABOUT_DESCRIPTION_NO_LANDMARK": "This trusted local LuggageHero partner offers luggage storage in {{city}}. Book online in seconds, drop your bags, and enjoy the city without dragging your luggage around — every bag is insured and there's 24/7 support if you need a hand.",
  "STORES_ABOUT_THE_PLACE": "About the place",
  "STORES_BAGS": "{{count}} bags",
  "STORES_BASED_ON_REVIEWS": "Based on {{count}} reviews",
  "STORES_BOOK_NOW": "Book now",
  "STORES_BOOK_NOW_PAY_LATER": "Book now, pay later.",
  "STORES_CAPACITY": "Storage capacity",
  "STORES_CLOSED": "Closed",
  "STORES_CLOSES_AT": "Closes {{time}}",
  "STORES_DAY_FRIDAY": "Friday",
  "STORES_DAY_MONDAY": "Monday",
  "STORES_DAY_SATURDAY": "Saturday",
  "STORES_DAY_SUNDAY": "Sunday",
  "STORES_DAY_THURSDAY": "Thursday",
  "STORES_DAY_TUESDAY": "Tuesday",
  "STORES_DAY_WEDNESDAY": "Wednesday",
  "STORES_EXPLORE_NEAR_LANDMARK": "Explore more locations near {{landmark}}",
  "STORES_FINAL_CTA_INTRO": "Book {{name}} in under a minute —",
  "STORES_FINAL_CTA_SUFFIX": "insured bags, 24/7 support.",
  "STORES_FOOTER_ABOUT_US": "About Us",
  "STORES_FOOTER_AFFILIATE": "Affiliate Program",
  "STORES_FOOTER_APP_STORE_BADGE": "Download on the App Store",
  "STORES_FOOTER_BECOME_A_LOCATION": "Become a Location",
  "STORES_FOOTER_BLOG": "Blog",
  "STORES_FOOTER_COMPANY": "Company",
  "STORES_FOOTER_CONTACT": "Contact",
  "STORES_FOOTER_COPENHAGEN_OFFICE": "Copenhagen Office",
  "STORES_FOOTER_DISCOUNT_CODES": "Discount Codes",
  "STORES_FOOTER_EXPLORE_ALL_CITIES": "Explore all cities",
  "STORES_FOOTER_FAQ": "FAQ",
  "STORES_FOOTER_FOLLOW_US": "Follow Us",
  "STORES_FOOTER_FOR_HOTELS": "For Hotels and Hostels",
  "STORES_FOOTER_GOOGLE_PLAY_BADGE": "Get it on Google Play",
  "STORES_FOOTER_GUARANTEE": "LuggageHero Guarantee",
  "STORES_FOOTER_GUIDES": "Luggage Hero's 2026 Guides for all cities",
  "STORES_FOOTER_HELP_CENTER": "Help Center",
  "STORES_FOOTER_HOME": "Home",
  "STORES_FOOTER_HOW_IT_WORKS": "How It Works",
  "STORES_FOOTER_INVESTOR": "Investor",
  "STORES_FOOTER_JOBS": "Jobs",
  "STORES_FOOTER_MEDIA_COVERAGE": "Media Coverage",
  "STORES_FOOTER_NEW_YORK_OFFICE": "New York Office",
  "STORES_FOOTER_POPULAR_CITIES": "Popular Cities",
  "STORES_FOOTER_PRESS": "Press",
  "STORES_FOOTER_PRICING": "Pricing",
  "STORES_FOOTER_PRIVACY_POLICY": "Privacy Policy",
  "STORES_FOOTER_SITEMAP": "Sitemap",
  "STORES_FOOTER_SUPPORT": "Support",
  "STORES_FOOTER_TERMS": "Terms & Conditions",
  "STORES_FOOTER_TRADEMARK": "LuggageHero® is a registered trademark. All rights reserved.",
  "STORES_FREE_CANCELLATION": "Free cancellation",
  "STORES_FREE_CANCELLATION_LOWER": "free cancellation",
  "STORES_GETTING_HERE": "Getting here",
  "STORES_GETTING_THERE": "Getting there:",
  "STORES_H1": "Luggage storage {{place}}",
  "STORES_H1_NO_LANDMARK": "Luggage storage in {{city}}",
  "STORES_HERO_INTRO": "Don't drag your bags around {{city}}. Store your luggage near {{landmark}} from {{hourlyRate}}/hour or {{dailyRate}}/day per bag + {{serviceCharge}} service fee, and explore the city hands-free.",
  "STORES_HERO_INTRO_NO_LANDMARK": "Don't drag your bags around {{city}}. Store your luggage from {{hourlyRate}}/hour or {{dailyRate}}/day per bag + {{serviceCharge}} service fee, and explore the city hands-free.",
  "STORES_HIGHLY_RATED": "Highly Rated",
  "STORES_HOW_IT_WORKS_SUBTITLE": "Store your bags in 3 easy steps",
  "STORES_HOW_IT_WORKS_TITLE": "How it works",
  "STORES_INSURED_BAGS": "Insured bags",
  "STORES_KPI_BOOK_NOW_PAY_LATER": "Book now, pay later",
  "STORES_KPI_FLEXIBLE_BOOKING": "Flexible Booking",
  "STORES_KPI_FREE_CANCELLATION": "Free cancellation",
  "STORES_KPI_HOURLY_DAILY_RATES": "Hourly / Daily Rates",
  "STORES_LOCATION": "Location",
  "STORES_LUGGAGE_STORAGE_EYEBROW": "Luggage storage",
  "STORES_META_DESCRIPTION": "Store your luggage near {{place}} in {{city}} with LuggageHero.",
  "STORES_META_DESCRIPTION_NO_LANDMARK": "Store your luggage in {{city}} with LuggageHero.",
  "STORES_META_TITLE": "Luggage Storage {{place}} — {{city}}",
  "STORES_META_TITLE_NO_LANDMARK": "Luggage Storage in {{city}}",
  "STORES_MIN_FROM_LANDMARK": "{{minutes}} min from {{landmark}}",
  "STORES_MIN_WALK": "{{minutes}} min walk",
  "STORES_NAV_BECOME_A_LUGGAGEHERO": "Become a LuggageHero",
  "STORES_NAV_GET_THE_APP": "Get the App",
  "STORES_NEED_A_HAND": "Need a hand?",
  "STORES_OFFER_PER_DAY": "Per day, per bag",
  "STORES_OFFER_PER_HOUR": "Per hour, per bag",
  "STORES_OFFER_SERVICE_FEE": "Service fee",
  "STORES_ONLINE_BOOKING_ONLY": "Online booking only.",
  "STORES_OPENING_HOURS": "Opening hours",
  "STORES_OPENS_AT": "Opens {{time}}",
  "STORES_OPEN_LATE": "Open Late",
  "STORES_OPEN_NOW": "Open Now",
  "STORES_OR": "or",
  "STORES_PARTNER_SINCE": "LuggageHero Partner since {{year}}",
  "STORES_PER_BAG": "per bag",
  "STORES_PER_DAY": "/day",
  "STORES_PER_HOUR": "/hour",
  "STORES_POI_DISTANCE": "{{poi}} · {{minutes}} min",
  "STORES_PRICES_PER_BAG": "Prices per bag",
  "STORES_PRICE_FROM": "From",
  "STORES_PRICE_SERVICE_FEE": "+ {{fee}} service fee per bag",
  "STORES_PRICE_TABLE_DAY_AHEAD": "Day ahead",
  "STORES_PRICE_TABLE_PER_DAY": "Per day",
  "STORES_PRICE_TABLE_PER_HOUR": "Per hour",
  "STORES_PRICE_TABLE_SAME_DAY": "Same day",
  "STORES_PRICING_LINE": "{{hourlyRate}}/hour or {{dailyRate}}/day per bag + {{serviceCharge}} service fee.",
  "STORES_RATING_REVIEWS": "{{rating}} ({{count}} reviews)",
  "STORES_RATING_TRAVELER_REVIEWS": "{{rating}} · {{count}} traveler reviews",
  "STORES_READY_TO_EXPLORE": "Ready to explore {{city}} hands-free?",
  "STORES_REVIEWS": "{{count}} reviews",
  "STORES_REVIEWS_COUNT": "({{count}} reviews)",
  "STORES_SERVICE_FEE": "+ {{amount}} service fee",
  "STORES_SHOW_LESS": "Show less",
  "STORES_SHOW_MORE": "Show more",
  "STORES_STEP_DROP_OFF_DESC": "Go to the location, show your booking, and hand over your bags.",
  "STORES_STEP_DROP_OFF_TITLE": "Drop off",
  "STORES_STEP_EXPLORE_DESC": "Enjoy the city hands-free! Pick up your bags when you're ready.",
  "STORES_STEP_EXPLORE_TITLE": "Explore freely",
  "STORES_STEP_FIND_BOOK_DESC": "Search for a storage location near you and book online in seconds.",
  "STORES_STEP_FIND_BOOK_TITLE": "Find & book",
  "STORES_SUPPORT_247": "24/7 support",
  "STORES_SUPPORT_HERE_247": "Our support team is here 24/7.",
  "STORES_TOP_CHOICE": "Top choice",
  "STORES_TOP_HEADING": "{{count}} most popular storage locations out of {{total}} in {{place}}",
  "STORES_TOP_HEADING_FALLBACK": "Top Storage Locations",
  "STORES_TOP_HEADING_SINGULAR": "{{count}} most popular storage location out of {{total}} in {{place}}",
  "STORES_TYPE_FREE_SPACE": "Free Space",
  "STORES_TYPE_RETAIL_STORE": "Retail Store",
  "STORES_TYPE_STORAGE_ROOM": "Storage Room",
  "STORES_UP_TO_BAGS_PER_DAY": "Up to {{count}} bags/day",
  "STORES_VIEW_STORE": "View store",
  "STORES_WALK_INS_WELCOME": "Walk-ins welcome during opening hours, subject to space.",
  "STORES_WHAT_TRAVELLERS_SAY": "What travellers say",
  "STORES_WHY_ANYTIME": "Arrive anytime during the opening hours",
  "STORES_WHY_CHOOSE_TITLE": "Why Travelers Choose LuggageHero:",
  "STORES_WHY_COVERAGE": "Protection with coverage up to {{amount}}",
  "STORES_WHY_LOCATIONS": "More than 6000 trusted locations",
  "STORES_WHY_NO_LIMITS": "No size or weight limitations",
  "STORE_UP_TO": "Store up to",
  "STORE_UP_TO_X_BAGS_AT_THIS_RATE": "Store up to {{count}} bags at this rate",
  "STORE_YOUR_BAGS_SECURELY": "Store your bags securely with LuggageHero",
  "STORE_YOUR_LUGGAGE": "Store your luggage",
  "STREET": "Street",
  "STREET_MISSING_FROM_PLACE": "We couldn't determine the street from that result — please type a street name or pick a more specific place.",
  "STRIPE_ACCOUNT_COUNTRY": "Choose country",
  "STRIPE_ACCOUNT_FORM_GROUP_BUSINESS": "Company",
  "STRIPE_ACCOUNT_FORM_GROUP_COMPANY_ADDRESS": "Company Address",
  "STRIPE_ACCOUNT_FORM_GROUP_REPRESENTATIVE": "Company Representative",
  "STRIPE_ACCOUNT_FORM_GROUP_REPRESENTATIVE_ADDRESS": "Personal Address",
  "STRIPE_ACCOUNT_FORM_GROUP_REPRESENTATIVE_DOB": "Date of Birth",
  "STRIPE_ACCOUNT_LEGAL_ENTITY_ADDRESS_CITY": "City",
  "STRIPE_ACCOUNT_LEGAL_ENTITY_ADDRESS_LINE_1": "Address line 1",
  "STRIPE_ACCOUNT_LEGAL_ENTITY_ADDRESS_LINE_2": "Address line 2",
  "STRIPE_ACCOUNT_LEGAL_ENTITY_ADDRESS_POSTAL_CODE": "Postal code",
  "STRIPE_ACCOUNT_LEGAL_ENTITY_ADDRESS_STATE": "State",
  "STRIPE_ACCOUNT_LEGAL_ENTITY_BUSINESS_NAME": "Business name",
  "STRIPE_ACCOUNT_LEGAL_ENTITY_BUSINESS_TAX_ID": "Tax ID",
  "STRIPE_ACCOUNT_LEGAL_ENTITY_DOB_DAY": "Day",
  "STRIPE_ACCOUNT_LEGAL_ENTITY_DOB_MONTH": "Month",
  "STRIPE_ACCOUNT_LEGAL_ENTITY_DOB_YEAR": "Year",
  "STRIPE_ACCOUNT_LEGAL_ENTITY_FIRST_NAME": "First name",
  "STRIPE_ACCOUNT_LEGAL_ENTITY_LAST_NAME": "Last name",
  "STRIPE_ACCOUNT_LEGAL_ENTITY_PERSONAL_ADDRESS_CITY": "City",
  "STRIPE_ACCOUNT_LEGAL_ENTITY_PERSONAL_ADDRESS_LINE_1": "Address line 1",
  "STRIPE_ACCOUNT_LEGAL_ENTITY_PERSONAL_ADDRESS_LINE_2": "Address line 2",
  "STRIPE_ACCOUNT_LEGAL_ENTITY_PERSONAL_ADDRESS_POSTAL_CODE": "Postal code",
  "STRIPE_ACCOUNT_LEGAL_ENTITY_PERSONAL_ADDRESS_STATE": "State",
  "STRIPE_ACCOUNT_LEGAL_ENTITY_PERSONAL_ID_NUMBER": "ID number",
  "STRIPE_ACCOUNT_LEGAL_ENTITY_SSN_LAST4": "Social security number (last 4 digits)",
  "SUBMIT_FEEDBACK": "Submit feedback",
  "SUBMIT_REVIEW": "Submit review",
  "SUCCESS": "Success",
  "SUCCESSFULLY_CONNECTED": "You are connected with LuggageHero!",
  "SUMMARY": "Summary",
  "SUNDAY": "Sunday",
  "SUPERHERO_BENEFITS_PANEL_TITLE": "SuperHero Benefits",
  "SUPERHERO_BENEFIT_EARNING_RATE_TITLE": "Earning Rate Boost",
  "SUPERHERO_BENEFIT_VISIBILITY_BOOST_TITLE": "Visibility Boost",
  "SUPERHERO_BENEFIT_WALK_IN_BONUS_TITLE": "Walk-In Bonus Boost",
  "SUPERHERO_PARTNER_PROGRAM_ACCEPT_FAILED": "We could not record your acceptance. Please try again, or contact support if it keeps happening.",
  "SUPERHERO_PARTNER_PROGRAM_COMING_SOON_TEXT": "Get increased earnings, a minimum bag guarantee, and extra bonuses. Coming soon.",
  "SUPERHERO_PARTNER_PROGRAM_COMING_SOON_TITLE": "Coming soon...",
  "SUPERHERO_REQUIREMENTS_MINIMUM_BOOKINGS_MODAL_DESCRIPTION": "Complete at least 5 bookings to meet this requirement. A booking counts as “completed” when:",
  "SUPERHERO_REQUIREMENTS_MINIMUM_BOOKINGS_MODAL_DESCRIPTION_ITEM_1": "At drop-off, the traveler starts the storage timer from their booking page.",
  "SUPERHERO_REQUIREMENTS_MINIMUM_BOOKINGS_MODAL_DESCRIPTION_ITEM_2": "At pickup, the traveler stops the storage timer from their booking page.",
  "SUPERHERO_REQUIREMENTS_MINIMUM_BOOKINGS_MODAL_TITLE": "Complete 5 Bookings",
  "SUPERHERO_REQUIREMENTS_MINIMUM_WALKINS_MODAL_DESCRIPTION": "Ask walk-in customers to scan your HeroCode when they arrive.",
  "SUPERHERO_REQUIREMENTS_MINIMUM_WALKINS_MODAL_DESCRIPTION_2": "Order a HeroCode QR code via support, or print your own HeroCode from your in-store display page.",
  "SUPERHERO_REQUIREMENTS_MINIMUM_WALKINS_MODAL_DESCRIPTION_2_LINK": "print your own HeroCode",
  "SUPERHERO_REQUIREMENTS_MINIMUM_WALKINS_MODAL_DESCRIPTION_2_PREFIX": "Order a HeroCode QR code via support, or",
  "SUPERHERO_REQUIREMENTS_MINIMUM_WALKINS_MODAL_DESCRIPTION_2_SUFFIX": "from your in-store display page.",
  "SUPERHERO_REQUIREMENTS_MINIMUM_WALKINS_MODAL_DESCRIPTION_ITEM_1": "If they already have a LuggageHero booking, they'll start the storage timer at drop-off.",
  "SUPERHERO_REQUIREMENTS_MINIMUM_WALKINS_MODAL_DESCRIPTION_ITEM_2": "If they’re new, they'll create a booking immediately —– and it will count as a walk-in.",
  "SUPERHERO_REQUIREMENTS_MINIMUM_WALKINS_MODAL_TITLE": "Register your first walk-in",
  "SUPERHERO_REQUIREMENTS_PANEL_TITLE": "SuperHero Requirements",
  "SUPERHERO_REVOCATION_ADMIN_CANCEL_ACTION": "Cancel notice",
  "SUPERHERO_REVOCATION_ADMIN_CONFIRM": "This serves a contractual 15-day notice and notifies the partner by email and WhatsApp. Continue?",
  "SUPERHERO_REVOCATION_ADMIN_LIFT_ACTION": "Lift revocation",
  "SUPERHERO_REVOCATION_ADMIN_NOTE_LABEL": "Internal note (not shown to the partner)",
  "SUPERHERO_REVOCATION_ADMIN_PANEL_TITLE": "SuperHero participation (staff)",
  "SUPERHERO_REVOCATION_ADMIN_REASON_PLACEHOLDER": "Select a reason",
  "SUPERHERO_REVOCATION_ADMIN_SERVE_ACTION": "Serve 15-day notice",
  "SUPERHERO_REVOCATION_ADMIN_STATE_IN_PROGRAM": "In the program",
  "SUPERHERO_REVOCATION_ADMIN_STATE_LABEL": "Status:",
  "SUPERHERO_REVOCATION_ADMIN_STATE_NOTICE_SERVED": "Notice served",
  "SUPERHERO_REVOCATION_ADMIN_STATE_REVOKED": "Revoked",
  "SUPERHERO_REVOCATION_ENDS_ON_LABEL": "Participation ends:",
  "SUPERHERO_REVOCATION_NOTICE_DESCRIPTION": "You keep your SuperHero status and all its benefits until this date. Contact us if you think this is a mistake.",
  "SUPERHERO_REVOCATION_NOTICE_TITLE": "Your SuperHero participation is ending",
  "SUPERHERO_REVOCATION_REASON_AGREEMENT_BREACH_OTHER": "Agreement terms were not met",
  "SUPERHERO_REVOCATION_REASON_CASH_HANDLING": "Cash handling",
  "SUPERHERO_REVOCATION_REASON_LABEL": "Reason:",
  "SUPERHERO_REVOCATION_REASON_NO_WALK_IN_SUPPORT": "Walk-in guests were not accepted",
  "SUPERHERO_REVOCATION_REASON_QUALITY_COMPLAINTS": "Service quality",
  "SUPERHERO_REVOCATION_REVOKED_DESCRIPTION": "This location is no longer part of the SuperHero program. Contact us if you think this is a mistake.",
  "SUPERHERO_REVOCATION_REVOKED_TITLE": "Your SuperHero participation has ended",
  "SUPERHERO_WIZARD_STEP_1_DESCRIPTION": "Increase earnings by driving all walk-ins through LuggageHero",
  "SUPERHERO_WIZARD_STEP_1_DESCRIPTION_EXCLUSIVITY": "Increase earnings by putting all your luggage storage through LuggageHero",
  "SUPERHERO_WIZARD_STEP_1_SECTION_1_TITLE": "All bookings",
  "SUPERHERO_WIZARD_STEP_1_SECTION_2_TITLE": "Bonus",
  "SUPERHERO_WIZARD_STEP_1_SECTION_3_TITLE": "Increased visibility through multiple online channels",
  "SUPERHERO_WIZARD_STEP_1_TITLE": "LuggageHero's commitment to you",
  "SWEDEN": "Sweden",
  "SWITZERLAND": "Switzerland",
  "TAB_BAR_BOOKINGS": "Bookings",
  "TAB_BAR_BROWSE": "Browse",
  "TAB_BAR_CHAT": "Chat",
  "TAB_BAR_MENU": "Menu",
  "TAB_BAR_NEARBY": "Nearby",
  "TAIWAN": "Taiwan",
  "TAKE_A_PHOTO": "Take a photo",
  "TAKE_A_PHOTO_ALL_BAGS_VISIBLE": "Take a picture of the bags you want to store. All bags should be visible in the photo.",
  "TAKE_A_PHOTO_OF_YOUR_BAGS": "Take a photo of your bags",
  "TAKE_A_PHOTO_OF_YOUR_LUGGAGE": "Take a photo of your luggage",
  "TAKE_PHOTO_OF_SECURITY_SEALS": "Take a photo of your security seals",
  "TAKE_PHOTO_OF_SECURITY_SEALS_ON_YOUR_BAG": "Take a photo of the security seal on your bag",
  "TANZANIA": "Tanzania",
  "TARGET_MISSING_DESCRIPTION": "Set your business goals to help us provide relevant insights and recommendations.",
  "TARGET_MISSING_TITLE": "Business Goals Required",
  "TAXES_AND_SERVICE_CHARGES_INCLUDED": "Includes all taxes and service charges",
  "TAX_FEATURE_DISABLED_TEXT": "The tax settings feature is currently disabled.",
  "TAX_ITEM_DELETED": "Tax deleted",
  "TAX_ITEM_SAVED_ERROR": "Error saving tax item",
  "TAX_ITEM_SAVED_SUCCESSFULLY": "Tax item saved",
  "TAX_NAME_LABEL": "Tax Name",
  "TAX_RATE_PERCENT_LABEL": "Rate (%)",
  "TAX_SETTINGS": "Tax settings",
  "TERMS_OF_SERVICE": "Terms of service",
  "TERMS_OF_SERVICE_LINK_PRE_TEXT": "Please carefully read our",
  "TERMS_OF_SERVICE_LINK_TEXT": "Terms of Service",
  "TESTIMONIAL_BACK_STREET_COFFEE": "\"Partnering with LuggageHero has made our little café a convenient stop for travelers. People come in to leave their luggage, grab a coffee, and relax before catching their train or checking into their accommodation.\"",
  "TESTIMONIAL_BACK_STREET_COFFEE_ALT": "Small café storefront with outdoor seating.",
  "TESTIMONIAL_CITY_SOUVENIRS": "\"Since joining LuggageHero as a storage partner, we've turned our unused back room into a steady source of extra income. Travelers drop off their bags, get local tips from our staff, and often browse our souvenirs while they're here.\"",
  "TESTIMONIAL_CITY_SOUVENIRS_ALT": "Up close photo of typical London souvenirs such as magnets, keychains, cups and caps.",
  "TESTIMONIAL_EAST_CENTRAL_CYCLES": "\"As a bike shop, we didn't expect luggage storage to be something we'd offer, but it's turned into a useful side service with LuggageHero. Tourists leave their bags safely with us while they explore the city on rental bikes. Check-in and check-out are quick, our staff picked it up easily, and the extra income helps cover our fixed costs in quieter months.\"",
  "TESTIMONIAL_EAST_CENTRAL_CYCLES_ALT": "Bike shop front with bicycles displayed outside and a large window showing the workshop inside.",
  "THAILAND": "Thailand",
  "THANK_YOU_FOR_FEEDBACK": "Feedback received, thank you!",
  "THE_BALANCE_WILL_BE_TRANSFERRED_TO_NEXT_BILL": "The balance will be transferred to the next invoice",
  "THE_CODE": "The code",
  "THE_FUNDS_ARE_AVAILABLE_ON": "The funds will be available on",
  "THE_STORAGE_TIMER": "The Storage Timer",
  "THIS_SHOP_HAS_WIFI": "This LuggageHero offers free Wi-Fi",
  "THURSDAY": "Thursday",
  "TIME_TO_HAVE_FUN": "Time to have fun!",
  "TIP": "Tip",
  "TIPS": "Tips",
  "TIP_AMOUNT": "Tip amount",
  "TIP_AMOUNT_INVALID": "Please provide a valid amount for tip",
  "TIP_NO_MORE_THAN_X": "Please enter a tip of no more than",
  "TIP_THE_STAFF": "Tip the staff",
  "TITLE_MANAGER": "Manager",
  "TITLE_OWNER": "Owner",
  "TODAY": "Today",
  "TOGGLE_LIST": "List",
  "TOGGLE_MAP": "Map",
  "TOMORROW": "Tomorrow",
  "TOP": "Top",
  "TOTAL_SALES_OF": "Total sales of",
  "TOTAL_TIPS": "Total tips earned",
  "TRANSFERRING": "Transferring…",
  "TRANSFER_COMPLETED": "transfer completed.",
  "TRANSFER_GOOGLE_PUSH_PENDING": "transferred, but Google was not updated — the listing still points at the old shop's page. Open the shop and press \"Push to Google\" to finish the move.",
  "TRANSFER_KEEPS": "Keeps",
  "TRANSFER_LISTING": "Transfer listing",
  "TRANSFER_LISTING_KEEPS_NAME_AND_REVIEWS": "The listing keeps its name, Google Place ID and reviews. Only the linked shop, website and address change.",
  "TRANSFER_LISTING_TO_ANOTHER_SHOP": "Transfer listing to another shop",
  "TRANSFER_MOVES_TO": "Moves to",
  "TRANSFER_PHOTOS_STILL_SHOW_PREVIOUS_LOCATION": "Photos on the listing still show the previous location — replace them in Business Profile Manager. Customer photos cannot be deleted.",
  "TRANSFER_WARNING_LISTING_IS_CLOSED": "This listing is closed on Google. It transfers as closed — a transfer cannot reopen it; use Reactivate for that.",
  "TRANSFER_WARNING_SAME_LOCATION": "This is the location the listing is already on. Transferring changes nothing.",
  "TRANSFER_WARNING_TARGET_HAS_LIVE_LISTING": "This location already has a live listing. Transferring gives it a second one.",
  "TRANSLATED": "Translated",
  "TRANSLATION_CONTEXT": "Translation Context",
  "TRANSLATION_CONTEXT_PLACEHOLDER": "Call-to-action to book luggage storage",
  "TRANSLATION_ID": "Translation Key",
  "TRANSLATION_ID_PLACEHOLDER": "BOOK_NOW",
  "TRAVELER": "Traveler",
  "TRAVELERS_GAVE_THIS_5_STARS": "travelers gave this place 5 out of 5 stars",
  "TRAVELERS_RATED_THIS": "travelers rated this place",
  "TRINIDAD_AND_TOBAGO": "Trinidad and Tobago",
  "TROUBLE_FINDING_LOCATION": "Unable to find the location?",
  "TRUSTED_BY": "Trusted by",
  "TRY_AGAIN": "Try again",
  "TUESDAY": "Tuesday",
  "TUNISIA": "Tunisia",
  "TURKEY": "Turkey",
  "TYPE": "Type",
  "UNABLE_TO_CHARGE_PART_1": "We were unable to charge",
  "UNABLE_TO_CHARGE_PART_2": "to your card",
  "UNDO_CHECK_IN": "Cancel storage timer",
  "UNDO_CHECK_IN_EXPLANATION": "You can undo the dropoff below if you haven't handed over your luggage yet.",
  "UNEXPECTED_ERROR": "An error occurred, please try again",
  "UNITED_ARAB_EMIRATES": "United Arab Emirates",
  "UNITED_KINGDOM": "United Kingdom",
  "UNITED_STATES": "United States",
  "UNIT_SUFFIX_FEET": "ft",
  "UNIT_SUFFIX_KILOMETERS": "km",
  "UNIT_SUFFIX_METERS": "m",
  "UNIT_SUFFIX_MILE": "mile",
  "UNIT_SUFFIX_MILES": "miles",
  "UNIT_SUFFIX_MINUTE": "min",
  "UNIT_SUFFIX_MINUTES": "mins",
  "UNNAMED_TRAVELER": "Unnamed traveler",
  "UNRESOLVED": "Unresolved",
  "UPCOMING": "Upcoming",
  "UPDATE_ADDRESS": "Update Address",
  "UPDATE_ORGANIZATION_PROFILE": "Update Organization Settings",
  "UPDATE_REQUIRED": "Update required",
  "UPDATE_REVIEW": "Update",
  "UPGRADE_GUEST_EXPERIENCE": "Upgrade your guest experience and reduce friction on arrival and departure days",
  "UPLOADING": "Uploading",
  "UPLOAD_SHOP_IMAGES": "Upload images",
  "UP_TO_ONE_BAG": "up to 1 bag",
  "UP_TO_X_BAGS": "Up to",
  "UP_TO_X_BAGS_COUNT": "up to {{count}} bags",
  "URUGUAY": "Uruguay",
  "USAGE": "Usage",
  "USED_LUGGAGEHERO": "Used LuggageHero",
  "USERS_TAB_TITLE": "Users",
  "USER_INACTIVE_HEADER": "You have been inactive for a while",
  "USER_INACTIVE_REFRESH_BOOKING": "Refresh booking?",
  "USER_INACTIVE_SUBHEADER": "It's possible your booking has changed",
  "USER_INFORMATION": "User Information",
  "USER_WITH_PHONE_ALREADY_EXISTS": "A user with the specified phone number already exists",
  "USE_ANOTHER_PAYMENT_CARD": "Use another payment card",
  "USE_A_DIFFERENT_EMAIL": "Use a different email",
  "USE_LINK_AND_START_STORAGE_TIMER": "Use the link in your email or SMS confirmation to access your booking page and start the storage timer.",
  "USE_OTHER_PAYMENT_METHOD": "Use other payment method",
  "USE_TIQETS_DISCOUNT_CODE": "Use the code HERO5 to get 5% off top experiences with our partner Tiqets in",
  "USE_YOUR_KEYCARD_TO_ACCESS_STORAGE_ROOM": "Use your keycard to access the storage room",
  "USING_PAYMENT_CARD": "Using",
  "UZBEKISTAN": "Uzbekistan",
  "VALID": "valid",
  "VALIDATE_CODE": "Validate",
  "VALID_FROM_LABEL": "Valid from",
  "VALID_KEY_TEXT": "API key valid",
  "VALID_UNTIL": "Valid until",
  "VAT_NUMBER": "VAT number",
  "VAT_NUMBER_COUNTRY_CODE_FORMAT_ERROR": "Invalid country code format",
  "VAT_NUMBER_COUNTRY_CODE_REQUIRED_ERROR": "VAT number must start with a country code (e.g., DE, FR, NL)",
  "VAT_NUMBER_EU_COUNTRY_ONLY_ERROR": "VAT number must be from an EU country",
  "VAT_NUMBER_INVALID": "Invalid VAT number",
  "VAT_NUMBER_INVALID_ERROR": "Invalid VAT number format",
  "VAT_NUMBER_MIN_LENGTH_ERROR": "VAT number must be at least 10 characters",
  "VAT_NUMBER_NOT_FOUND": "VAT number not found",
  "VAT_NUMBER_NOT_FOUND_ERROR": "VAT number not found in the registry",
  "VAT_NUMBER_PLACEHOLDER": "VAT number (e.g. 'GB123456789')",
  "VAT_NUMBER_REQUIRED_ERROR": "VAT number is required",
  "VAT_NUMBER_VALIDATING": "Validating VAT number...",
  "VAT_STATUS_CONFIRM_MODAL_INTRO": "LuggageHero staff set the following VAT status for your business:",
  "VAT_STATUS_CONFIRM_MODAL_TITLE": "Confirm your VAT status",
  "VAT_STATUS_CONFIRM_MODAL_VALUE_HAS_NUMBER": "Has a VAT number: {{vatNumber}}",
  "VAT_STATUS_CONFIRM_MODAL_VALUE_NO_NUMBER": "Has no VAT number",
  "VAT_STATUS_CONFIRM_NO": "No, let me change it",
  "VAT_STATUS_CONFIRM_YES": "Yes, this is correct",
  "VAT_STATUS_DECLARED_BY_STAFF_BADGE": "Declared by LuggageHero staff — please confirm this is correct.",
  "VAT_STATUS_HAS_VAT_NUMBER": "I have a VAT number",
  "VAT_STATUS_NO_VAT_NUMBER": "My business has no VAT number",
  "VAT_STATUS_NO_VAT_NUMBER_CONSEQUENCE": "-",
  "VAT_STATUS_NO_VAT_NUMBER_CONSEQUENCE_HEADING": "What this means",
  "VAT_STATUS_PROVIDED_HAS_NUMBER": "VAT number provided",
  "VAT_STATUS_PROVIDED_NO_NUMBER": "No VAT number",
  "VERIFICATION_STATUS": "Status",
  "VERIFY_NOW": "Verify now",
  "VERIFY_YOUR_PHONE_NUMBER_TO_RECEIVE_BOOKING_NOTIFICATIONS": "Help us support you better. Verify your phone number.",
  "VIETNAM": "Vietnam",
  "VIEW_AND_ACCEPT_TERMS_OF_SERVICE": "View and accept",
  "VIEW_IN_MAPS": "Open in Maps",
  "VIEW_ORIGINAL": "View original",
  "VIEW_RECEIPT": "View receipt",
  "VIEW_TRANSLATION": "View translation",
  "VOLUME_DISCOUNTS_FOR_ONLINE_BOOKINGS": "Volume discounts automatically applied to multi-day and large bookings made online",
  "WALK_IN": "Walk-in",
  "WALK_IN_BONUS": "Walk-in Bonus",
  "WALK_IN_BONUS_CARD_TITLE": "Walk-In Bonus",
  "WALK_IN_BONUS_EXPLAIN_DESCRIPTION": "Earn a bonus payout every time your location completes a set number of walk-in bookings.",
  "WALK_IN_BONUS_EXPLAIN_DISPLAY_HERO_CODE": "Display your HeroCode so customers can scan it",
  "WALK_IN_BONUS_EXPLAIN_DISPLAY_HERO_CODE_BOLD": "HeroCode",
  "WALK_IN_BONUS_EXPLAIN_DISPLAY_HERO_CODE_POST": " so customers can scan it",
  "WALK_IN_BONUS_EXPLAIN_DISPLAY_HERO_CODE_PRE": "Display your ",
  "WALK_IN_BONUS_EXPLAIN_GET_STARTED": "To get started:",
  "WALK_IN_BONUS_EXPLAIN_NO_HERO_CODE_LINK": "Signage",
  "WALK_IN_BONUS_EXPLAIN_NO_HERO_CODE_PREFIX": "No HeroCode yet? Download a temporary one from",
  "WALK_IN_EXPLANATION": "This customer walked in from the street without a prior booking",
  "WALK_IN_RATES_MAY_BE_HIGHER": "Walk-in rates may be higher",
  "WALK_IN_STATUS": "Walk In Status",
  "WEDNESDAY": "Wednesday",
  "WELCOME": "Welcome!",
  "WELCOME_BACK": "Welcome back!",
  "WELCOME_BASIC_HERO": "Welcome on board 👏",
  "WELCOME_TO_STORE": "Welcome to",
  "WE_LIKE_TO_KNOW_WHY_PEOPLE_CANCEL": "We like to know why people cancel their bookings so that we can try to improve our service",
  "WE_USE_LOCAL_SHOPS": "We use certified local shops, cafés and hotels to store your luggage for a few hours or days. We call them luggage heroes.",
  "WHAT_CAN_I_STORE_TEXT": "Suitcases, backpacks, shopping bags — we're not picky!",
  "WHAT_CAN_I_STORE_TOOLTIP": "People store lots of different things with us. If you can carry it, we can store it.",
  "WHAT_HAPPENED": "What happened?",
  "WHAT_WE_OFFER": "What we offer",
  "WHAT_WE_OFFER_TEXT": "With this integration, your guests gain access to LuggageHero's wide network of secure storage locations. We offer 2 hours of free storage and charge a low hourly rate after that. You earn commission on all completed transactions.",
  "WHEN_BOOKED_BY_THE_DAY_BEFORE": "when booked by the day before",
  "WHEN_PICKING_UP_STOP_THE_STORAGE_TIMER": "When picking up your luggage, access your booking page and stop the storage timer",
  "WHEN_PICKING_UP_YOUR_BAGS": "When picking up your bags",
  "WHEN_YOURE_DONE": "when you're done",
  "WHERE": "Where",
  "WHY_ARE_YOU_CANCELING": "Why are you canceling your booking?",
  "WHY_ARE_YOU_CANCELING_SHORT": "Why are you canceling?",
  "WIFI": "Wi-Fi",
  "WIFI_FILTER": "Wi-Fi available",
  "WIFI_PASSWORD": "Password",
  "WIFI_SCREENSHOT_HINT": "Tip: Take a screenshot of this page with your phone, then you have the Wi-Fi details available offline when you arrive at the shop.",
  "WIFI_SELECTION_REQUIRED": "Please select whether Wi-Fi is available at this location",
  "WIFI_SSID": "Network Name (SSID)",
  "WIFI_USERNAME": "Username (web login)",
  "WILL_BE_APPLIED_TO_BOOKING": "will be applied to your next booking",
  "WILL_YOU_TIP_THE_STAFF": "Would you like to tip the staff?",
  "WITHOUT_PAYING_MORE_AT_LOCATION": " without paying more at this location",
  "WITH_THE_SEALS_PROVIDED": "with the original branded LuggageHero seals provided in the shop to enable insurance",
  "WOULD_YOU_LIKE_TO_CALL_THE_LOCATION": "Would you like to call the location?",
  "X_BOOKINGS_IN_THE_LAST_24_HOURS": "bookings in the last 24 hours",
  "X_HOURS_OF_FREE_STORAGE": "hours of free storage",
  "X_HOUR_OF_FREE_STORAGE": "hour of free storage",
  "YES": "Yes",
  "YESTERDAY": "Yesterday",
  "YES_CANCEL_MY_BOOKING": "Yes, cancel my booking",
  "YOURE_ALL_SET": "You're all set!",
  "YOUR_ARE_A_SUPERHERO": "You are a SuperHero. Good job!",
  "YOUR_BOOKING": "Your booking",
  "YOUR_CONTACT_DETAILS": "Your contact details",
  "YOUR_FEEDBACK_IS_IMPORTANT": "Your feedback is important to us",
  "YOUR_LUGGAGE_IS_HANDED_BACK": "Your luggage is handed back",
  "YOUR_LUGGAGE_IS_SAFE": "Your luggage is safe with us",
  "YOUR_NEXT": "Your next",
  "YOUR_PAYMENT_METHODS": "Your payment methods",
  "YOUR_REVIEW_OF": "Your evaluation of",
  "YOUR_REVIEW_OF_SHOP_NAME": "Your review of",
  "YOUR_STATUS": "Your Status",
  "YOUR_STORAGE_LOCATION": "Your storage location",
  "YOU_ALREADY_DROPPED_OFF_YOUR_BAGS": "You already dropped off your bags",
  "YOU_ARE_ABOUT_TO_REMOVE_QR_CODE_FROM": "You are about to remove QR code",
  "YOU_ARE_CHARGED_ONLY_FOR_STORAGE_HOURS": "You are charged only for the hours you end up keeping your bags stored.",
  "YOU_ARE_DROPPING_OFF_NO_BAGS": "You are dropping off",
  "YOU_ARE_OWED": "You are owed",
  "YOU_ARE_SAVING_X_ON_ADDITIONAL_DAYS_PART_1": "You're saving",
  "YOU_ARE_SAVING_X_ON_ADDITIONAL_DAYS_PART_2": "on additional days",
  "YOU_CAN_MODIFY_BOOKING_ANYTIME": "You can modify your booking anytime.",
  "YOU_CAN_PAY_THE_STAFF_DIRECTLY": "NOTE: You can pay the staff directly using any payment method that the shop accepts",
  "YOU_CHECKED_IN_BAGS_AT_PART_1": "You checked in",
  "YOU_CHECKED_IN_BAGS_AT_PART_2": "at",
  "YOU_MUST_ACCEPT_THE_TERMS_OF_SERVICE": "Accept our Terms of Service before your location can go live.",
  "YOU_ONLY_PAY_IF_YOU_SHOW_UP": "You only pay if you show up."
};
